function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "785px",
    height: "589px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.746
    },
    fill: "#f8f8f8",
    d: "M 338.5,-0.5 C 342.167,-0.5 345.833,-0.5 349.5,-0.5C 351.437,0.93142 353.27,2.59809 355,4.5C 356.985,11.4811 361.319,16.1477 368,18.5C 383.676,12.9152 399.509,7.74856 415.5,3C 437.514,-0.936471 452.014,7.56353 459,28.5C 460.015,32.4402 460.515,36.4402 460.5,40.5C 471.62,38.7524 482.62,39.2524 493.5,42C 505.136,46.3051 512.636,54.4718 516,66.5C 517.84,78.7672 519.173,91.1006 520,103.5C 520.578,106.903 521.745,110.07 523.5,113C 524.5,113.5 525.5,114 526.5,114.5C 532.221,113.717 537.888,112.717 543.5,111.5C 551.864,111.86 556.864,116.193 558.5,124.5C 565.079,126.581 571.079,129.748 576.5,134C 583.809,140.978 590.809,148.311 597.5,156C 602.636,157.98 607.969,159.313 613.5,160C 622.317,163.133 625.817,169.3 624,178.5C 618.525,190.641 609.692,199.475 597.5,205C 588.807,208.384 580.141,211.717 571.5,215C 576.703,217.553 579.87,221.72 581,227.5C 595.973,214.902 613.139,210.402 632.5,214C 642.588,215.626 650.755,220.459 657,228.5C 664.189,238.534 672.523,247.534 682,255.5C 683,257.167 684,258.833 685,260.5C 694.131,269.453 702.798,278.786 711,288.5C 711.499,292.152 711.665,295.818 711.5,299.5C 710.448,299.649 709.448,299.483 708.5,299C 702.339,291.008 695.673,283.508 688.5,276.5C 687.243,273.573 685.243,271.239 682.5,269.5C 682.167,268.5 681.5,267.833 680.5,267.5C 679.92,265.251 678.587,263.585 676.5,262.5C 669.139,254.807 661.806,247.14 654.5,239.5C 653.243,236.573 651.243,234.239 648.5,232.5C 646.996,230.164 644.996,228.331 642.5,227C 637.553,224.692 632.553,222.859 627.5,221.5C 622.015,220.348 616.349,220.182 610.5,221C 608.68,221.2 607.347,222.034 606.5,223.5C 606.167,223.5 605.833,223.5 605.5,223.5C 602.369,222.908 600.036,223.908 598.5,226.5C 594.495,227.498 591.161,229.498 588.5,232.5C 584.5,234.5 581.5,237.5 579.5,241.5C 578.5,241.833 577.833,242.5 577.5,243.5C 576.094,243.973 575.427,244.973 575.5,246.5C 574.094,246.973 573.427,247.973 573.5,249.5C 572.094,249.973 571.427,250.973 571.5,252.5C 571.107,254.284 570.441,255.95 569.5,257.5C 568.732,258.263 568.232,259.263 568,260.5C 567.501,266.491 567.334,272.491 567.5,278.5C 566.508,278.328 565.842,278.662 565.5,279.5C 563.973,279.427 562.973,280.094 562.5,281.5C 560.973,281.427 559.973,282.094 559.5,283.5C 557.596,283.738 556.262,284.738 555.5,286.5C 553.251,287.08 551.585,288.413 550.5,290.5C 546.854,292.817 543.52,295.484 540.5,298.5C 537.911,299.419 535.911,301.086 534.5,303.5C 527.35,308.582 520.35,313.915 513.5,319.5C 512.719,312.981 512.052,306.314 511.5,299.5C 515.416,299.975 518.749,298.975 521.5,296.5C 522.436,295.026 523.77,294.026 525.5,293.5C 526.906,293.027 527.573,292.027 527.5,290.5C 531.969,281.864 532.636,272.864 529.5,263.5C 530.215,258.022 531.881,253.022 534.5,248.5C 535.738,246.786 536.405,244.786 536.5,242.5C 540.371,242.815 544.038,242.482 547.5,241.5C 550.568,241.453 553.568,240.953 556.5,240C 559.706,238.231 563.039,236.731 566.5,235.5C 571.65,233.071 573.316,229.071 571.5,223.5C 570.311,222.571 568.978,222.238 567.5,222.5C 562.701,220.537 560.034,216.871 559.5,211.5C 559.5,210.5 559.5,209.5 559.5,208.5C 563.764,208.656 567.764,207.989 571.5,206.5C 573.403,206.204 575.07,205.537 576.5,204.5C 577.209,203.596 578.209,203.263 579.5,203.5C 582.112,202.629 584.779,201.963 587.5,201.5C 589.606,200.217 591.94,199.384 594.5,199C 596.063,198.241 597.063,197.074 597.5,195.5C 599.027,195.573 600.027,194.906 600.5,193.5C 602.027,193.573 603.027,192.906 603.5,191.5C 605.404,191.262 606.738,190.262 607.5,188.5C 610.5,187.5 612.5,185.5 613.5,182.5C 616.734,179.281 617.901,175.281 617,170.5C 616.329,169.748 615.496,169.414 614.5,169.5C 614.027,168.094 613.027,167.427 611.5,167.5C 610.833,167.5 610.167,167.5 609.5,167.5C 605.684,166.518 601.684,165.851 597.5,165.5C 597.027,164.094 596.027,163.427 594.5,163.5C 593.527,163.013 592.527,162.513 591.5,162C 585.662,155.33 579.662,148.83 573.5,142.5C 572.415,140.413 570.749,139.08 568.5,138.5C 566.847,138.34 565.514,137.674 564.5,136.5C 564.027,135.094 563.027,134.427 561.5,134.5C 558.5,133.833 555.5,133.167 552.5,132.5C 551.791,131.596 550.791,131.263 549.5,131.5C 549.806,128.615 549.473,125.948 548.5,123.5C 547.172,119.746 544.506,118.579 540.5,120C 539.956,120.717 539.289,121.217 538.5,121.5C 532.108,121.751 525.775,121.418 519.5,120.5C 518.5,118.833 517.167,117.5 515.5,116.5C 515.34,114.847 514.674,113.514 513.5,112.5C 513.192,108.64 512.525,104.974 511.5,101.5C 511.5,101.167 511.5,100.833 511.5,100.5C 511.237,91.8232 510.737,83.1566 510,74.5C 509.79,72.9419 509.29,71.6085 508.5,70.5C 508.655,67.284 507.655,64.6174 505.5,62.5C 504.488,61.1283 503.488,59.795 502.5,58.5C 501.833,55.8333 500.167,54.1667 497.5,53.5C 495.847,53.3404 494.514,52.6737 493.5,51.5C 491.383,49.3455 488.716,48.3455 485.5,48.5C 478.5,48.5 471.5,48.5 464.5,48.5C 461.659,48.5597 458.993,49.2264 456.5,50.5C 454.938,43.4537 453.438,36.1203 452,28.5C 451.617,27.944 451.117,27.6107 450.5,27.5C 450.672,26.5084 450.338,25.8417 449.5,25.5C 449.573,23.9731 448.906,22.9731 447.5,22.5C 441.774,13.8832 433.607,9.54986 423,9.5C 420.639,9.50393 418.473,9.83726 416.5,10.5C 413.848,10.4095 411.515,11.0762 409.5,12.5C 405.468,13.0822 401.801,14.4155 398.5,16.5C 395.603,17.129 392.936,18.129 390.5,19.5C 387.053,20.083 384.053,21.4163 381.5,23.5C 379.901,23.2322 378.568,23.5655 377.5,24.5C 376.167,24.5 374.833,24.5 373.5,24.5C 368.797,24.5628 364.13,24.2295 359.5,23.5C 355.874,21.5407 352.874,18.874 350.5,15.5C 350.276,10.6649 347.943,7.66495 343.5,6.5C 338.599,7.41014 336.266,10.4101 336.5,15.5C 335.662,15.8417 335.328,16.5084 335.5,17.5C 334.517,21.2984 334.183,25.2984 334.5,29.5C 328.1,28.0322 321.766,26.3656 315.5,24.5C 313.579,23.6373 311.579,22.9707 309.5,22.5C 307.485,21.0762 305.152,20.4095 302.5,20.5C 290.057,15.9245 277.057,14.2578 263.5,15.5C 261.102,15.2594 259.102,15.9261 257.5,17.5C 257.167,17.5 256.833,17.5 256.5,17.5C 251.57,17.8067 247.237,19.4733 243.5,22.5C 241.973,22.427 240.973,23.0937 240.5,24.5C 238.973,24.427 237.973,25.0937 237.5,26.5C 235.251,27.0798 233.585,28.4131 232.5,30.5C 227.833,33.1667 224.167,36.8333 221.5,41.5C 219.086,42.9108 217.419,44.9108 216.5,47.5C 214.738,48.2623 213.738,49.5956 213.5,51.5C 212.094,51.9731 211.427,52.9731 211.5,54.5C 209.412,56.3356 208.079,58.6689 207.5,61.5C 206.094,61.9731 205.427,62.9731 205.5,64.5C 204.662,64.8417 204.328,65.5084 204.5,66.5C 203.094,66.9731 202.427,67.9731 202.5,69.5C 201.094,69.9731 200.427,70.9731 200.5,72.5C 199.094,72.9731 198.427,73.9731 198.5,75.5C 196.765,77.2351 194.765,78.5684 192.5,79.5C 190.211,78.5349 188.211,77.2016 186.5,75.5C 185.903,74.8614 185.07,74.528 184,74.5C 182.624,74.6842 181.791,75.3509 181.5,76.5C 180.058,80.5441 180.391,84.5441 182.5,88.5C 182.5,89.5 182.5,90.5 182.5,91.5C 180.447,91.4021 178.78,92.0687 177.5,93.5C 175.973,93.427 174.973,94.0937 174.5,95.5C 171.236,97.0941 168.569,99.4275 166.5,102.5C 164.738,103.262 163.738,104.596 163.5,106.5C 162.094,106.973 161.427,107.973 161.5,109.5C 161.5,109.833 161.5,110.167 161.5,110.5C 160.009,113.186 159.343,116.186 159.5,119.5C 159.505,121.696 159.838,123.696 160.5,125.5C 160.5,126.167 160.5,126.833 160.5,127.5C 160.41,130.152 161.076,132.485 162.5,134.5C 163.902,139.384 164.569,144.384 164.5,149.5C 163.833,150.167 163.167,150.833 162.5,151.5C 159.763,151.599 157.096,151.265 154.5,150.5C 149.364,146.196 144.698,141.363 140.5,136C 138.613,135.22 136.946,135.387 135.5,136.5C 133.025,137.687 132.025,139.687 132.5,142.5C 130.733,144.792 129.733,147.458 129.5,150.5C 127.945,154.203 127.278,158.203 127.5,162.5C 127.502,165.686 127.835,168.686 128.5,171.5C 128.068,174.877 128.735,177.877 130.5,180.5C 130.5,181.167 130.5,181.833 130.5,182.5C 130.755,184.967 131.755,186.967 133.5,188.5C 134.441,190.05 135.107,191.716 135.5,193.5C 135.427,195.027 136.094,196.027 137.5,196.5C 140.167,198.833 142.833,201.167 145.5,203.5C 145.973,204.906 146.973,205.573 148.5,205.5C 150.441,205.869 152.275,206.536 154,207.5C 155.477,211.429 156.644,215.429 157.5,219.5C 157.875,221.698 158.542,223.698 159.5,225.5C 160.915,231.205 162.249,236.871 163.5,242.5C 163.77,246.358 165.103,249.691 167.5,252.5C 171.863,258.882 175.863,265.549 179.5,272.5C 179.427,274.027 180.094,275.027 181.5,275.5C 182.833,277.167 184.167,278.833 185.5,280.5C 186.29,281.401 187.29,282.068 188.5,282.5C 192.27,282.998 195.937,283.998 199.5,285.5C 200.025,289.533 201.358,293.2 203.5,296.5C 204.495,308.655 204.829,320.989 204.5,333.5C 204.116,337.489 204.783,341.155 206.5,344.5C 206.5,345.167 206.5,345.833 206.5,346.5C 206.41,349.152 207.076,351.485 208.5,353.5C 208.755,355.967 209.755,357.967 211.5,359.5C 211.157,361.483 211.824,362.817 213.5,363.5C 213.963,366.482 214.296,369.482 214.5,372.5C 209.96,374.291 205.293,375.791 200.5,377C 199.429,377.852 198.429,378.685 197.5,379.5C 194.351,379.415 191.684,380.415 189.5,382.5C 187.973,382.427 186.973,383.094 186.5,384.5C 184.596,384.738 183.262,385.738 182.5,387.5C 179.833,388.167 178.167,389.833 177.5,392.5C 176.364,397.681 176.364,403.015 177.5,408.5C 177.677,412.708 179.01,416.374 181.5,419.5C 181.971,421.579 182.637,423.579 183.5,425.5C 183.942,428.343 184.942,431.009 186.5,433.5C 186.957,434.298 187.624,434.631 188.5,434.5C 190.341,436.849 191.674,439.515 192.5,442.5C 192.427,444.027 193.094,445.027 194.5,445.5C 197.883,449.553 200.883,453.886 203.5,458.5C 205.833,462.833 209.167,466.167 213.5,468.5C 214.8,469.827 216.133,471.16 217.5,472.5C 216.423,473.705 215.09,474.372 213.5,474.5C 207.319,475.885 201.652,478.219 196.5,481.5C 195.167,481.833 193.833,482.167 192.5,482.5C 190.597,482.796 188.93,483.463 187.5,484.5C 185.597,484.796 183.93,485.463 182.5,486.5C 173.332,488.883 164.665,492.217 156.5,496.5C 153.843,496.935 151.509,497.935 149.5,499.5C 146.284,499.345 143.617,500.345 141.5,502.5C 127.393,507.423 113.059,511.757 98.5,515.5C 93.8695,508.571 88.5362,502.237 82.5,496.5C 81.9202,494.251 80.5869,492.585 78.5,491.5C 77.1073,488.983 75.1073,487.316 72.5,486.5C 72.5,483.833 72.5,481.167 72.5,478.5C 75.7935,478.259 78.7935,479.092 81.5,481C 89.0455,489.544 96.2122,498.377 103,507.5C 136.778,495.795 170.278,483.295 203.5,470C 184.766,450.033 172.766,426.533 167.5,399.5C 168.144,391.046 171.81,384.213 178.5,379C 187.103,373.865 196.103,369.532 205.5,366C 201.771,360.369 199.271,354.202 198,347.5C 196.167,334.855 195.667,322.188 196.5,309.5C 195.827,303.095 194.827,296.762 193.5,290.5C 187.234,290.55 181.734,288.55 177,284.5C 171.081,274.998 165.414,265.331 160,255.5C 155.37,241.662 151.037,227.662 147,213.5C 132.863,207.007 124.196,196.007 121,180.5C 117.551,163.309 119.884,146.976 128,131.5C 136.014,124.334 143.347,125.001 150,133.5C 151.513,136.524 153.513,139.191 156,141.5C 154.853,137.691 153.853,133.691 153,129.5C 152.333,123.167 152.333,116.833 153,110.5C 156.342,99.4629 163.175,91.4629 173.5,86.5C 170.606,80.0793 171.606,74.246 176.5,69C 181.571,65.9051 186.737,65.7384 192,68.5C 192.5,68.1667 193,67.8333 193.5,67.5C 201.236,53.1917 210.57,40.025 221.5,28C 241.861,9.88798 265.528,3.55465 292.5,9C 304.437,11.6458 315.937,15.4791 327,20.5C 327.256,11.3046 331.089,4.30458 338.5,-0.5 Z M 565.5,246.5 C 564.266,250.628 562.766,254.628 561,258.5C 560.114,263.47 559.448,268.47 559,273.5C 552.078,278.378 545.245,283.378 538.5,288.5C 538.167,288.167 537.833,287.833 537.5,287.5C 539.974,279.871 539.974,272.205 537.5,264.5C 538.846,259.817 540.179,255.15 541.5,250.5C 549.748,250.583 557.748,249.25 565.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 350.5,15.5 C 348.59,14.0254 347.424,12.0254 347,9.5C 344.034,6.73483 341.367,7.06816 339,10.5C 338.95,12.744 338.117,14.4107 336.5,15.5C 336.266,10.4101 338.599,7.41014 343.5,6.5C 347.943,7.66495 350.276,10.6649 350.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#070607",
    d: "M 350.5,15.5 C 352.874,18.874 355.874,21.5407 359.5,23.5C 361.214,24.7384 363.214,25.405 365.5,25.5C 368.976,26.6433 372.642,26.8099 376.5,26C 377.056,25.6174 377.389,25.1174 377.5,24.5C 378.568,23.5655 379.901,23.2322 381.5,23.5C 384.947,22.917 387.947,21.5837 390.5,19.5C 393.716,19.6545 396.383,18.6545 398.5,16.5C 401.801,14.4155 405.468,13.0822 409.5,12.5C 412.152,12.5905 414.485,11.9238 416.5,10.5C 418.473,9.83726 420.639,9.50393 423,9.5C 433.607,9.54986 441.774,13.8832 447.5,22.5C 447.427,24.0269 448.094,25.0269 449.5,25.5C 450.338,25.8417 450.672,26.5084 450.5,27.5C 451.482,30.7635 452.149,34.0968 452.5,37.5C 452.5,42.5 452.5,47.5 452.5,52.5C 453.791,52.7373 454.791,52.404 455.5,51.5C 455.833,51.5 456.167,51.5 456.5,51.5C 459.397,50.871 462.064,49.871 464.5,48.5C 471.5,48.5 478.5,48.5 485.5,48.5C 487.936,49.871 490.603,50.871 493.5,51.5C 494.514,52.6737 495.847,53.3404 497.5,53.5C 498.833,55.5 500.5,57.1667 502.5,58.5C 503.488,59.795 504.488,61.1283 505.5,62.5C 506.129,65.3973 507.129,68.064 508.5,70.5C 508.897,80.7043 509.897,90.7043 511.5,100.5C 511.5,100.833 511.5,101.167 511.5,101.5C 511.116,105.489 511.783,109.155 513.5,112.5C 514.674,113.514 515.34,114.847 515.5,116.5C 515.833,118.833 517.167,120.167 519.5,120.5C 519.611,121.117 519.944,121.617 520.5,122C 526.681,122.819 532.681,122.653 538.5,121.5C 539.289,121.217 539.956,120.717 540.5,120C 544.506,118.579 547.172,119.746 548.5,123.5C 548.492,126.545 548.159,129.545 547.5,132.5C 549.167,132.5 550.833,132.5 552.5,132.5C 555.5,133.167 558.5,133.833 561.5,134.5C 561.973,135.906 562.973,136.573 564.5,136.5C 565.514,137.674 566.847,138.34 568.5,138.5C 569.585,140.587 571.251,141.92 573.5,142.5C 579.662,148.83 585.662,155.33 591.5,162C 592.527,162.513 593.527,163.013 594.5,163.5C 594.973,164.906 595.973,165.573 597.5,165.5C 597.918,166.222 598.584,166.722 599.5,167C 602.817,167.498 606.15,167.665 609.5,167.5C 610.167,167.5 610.833,167.5 611.5,167.5C 611.973,168.906 612.973,169.573 614.5,169.5C 615.582,170.594 616.248,171.927 616.5,173.5C 615.692,176.592 614.692,179.592 613.5,182.5C 611.167,184.167 609.167,186.167 607.5,188.5C 605.596,188.738 604.262,189.738 603.5,191.5C 601.973,191.427 600.973,192.094 600.5,193.5C 598.973,193.427 597.973,194.094 597.5,195.5C 594.314,196.597 591.314,197.93 588.5,199.5C 585.053,200.083 582.053,201.416 579.5,203.5C 578.209,203.263 577.209,203.596 576.5,204.5C 573.273,204.676 570.273,205.343 567.5,206.5C 564.518,206.963 561.518,207.296 558.5,207.5C 558.232,209.099 558.566,210.432 559.5,211.5C 560.034,216.871 562.701,220.537 567.5,222.5C 570.387,224.718 571.221,227.718 570,231.5C 568.624,232.705 567.458,234.038 566.5,235.5C 563.039,236.731 559.706,238.231 556.5,240C 553.568,240.953 550.568,241.453 547.5,241.5C 543.5,241.5 539.5,241.5 535.5,241.5C 535.007,243.806 534.674,246.139 534.5,248.5C 531.881,253.022 530.215,258.022 529.5,263.5C 532.636,272.864 531.969,281.864 527.5,290.5C 526.094,290.973 525.427,291.973 525.5,293.5C 523.77,294.026 522.436,295.026 521.5,296.5C 517.985,297.919 514.319,298.586 510.5,298.5C 510.971,305.843 511.638,313.177 512.5,320.5C 513.107,320.376 513.44,320.043 513.5,319.5C 520.35,313.915 527.35,308.582 534.5,303.5C 537.089,302.581 539.089,300.914 540.5,298.5C 543.52,295.484 546.854,292.817 550.5,290.5C 552.749,289.92 554.415,288.587 555.5,286.5C 557.404,286.262 558.738,285.262 559.5,283.5C 561.027,283.573 562.027,282.906 562.5,281.5C 564.027,281.573 565.027,280.906 565.5,279.5C 565.842,278.662 566.508,278.328 567.5,278.5C 568.319,271.656 568.986,264.656 569.5,257.5C 570.441,255.95 571.107,254.284 571.5,252.5C 572.906,252.027 573.573,251.027 573.5,249.5C 574.906,249.027 575.573,248.027 575.5,246.5C 576.906,246.027 577.573,245.027 577.5,243.5C 577.833,242.5 578.5,241.833 579.5,241.5C 582.833,238.833 585.833,235.833 588.5,232.5C 591.161,229.498 594.495,227.498 598.5,226.5C 600.824,225.344 603.157,224.344 605.5,223.5C 605.833,223.5 606.167,223.5 606.5,223.5C 613.351,221.716 620.351,221.05 627.5,221.5C 632.553,222.859 637.553,224.692 642.5,227C 644.996,228.331 646.996,230.164 648.5,232.5C 649.757,235.427 651.757,237.761 654.5,239.5C 661.806,247.14 669.139,254.807 676.5,262.5C 677.08,264.749 678.413,266.415 680.5,267.5C 681.5,267.833 682.167,268.5 682.5,269.5C 683.757,272.427 685.757,274.761 688.5,276.5C 695.673,283.508 702.339,291.008 708.5,299C 709.448,299.483 710.448,299.649 711.5,299.5C 711.5,305.167 711.5,310.833 711.5,316.5C 709.726,317.881 708.226,317.548 707,315.5C 686.619,290.575 666.119,265.741 645.5,241C 638.079,236.645 630.079,234.478 621.5,234.5C 619.5,234.5 617.5,234.5 615.5,234.5C 611.292,234.677 607.626,236.01 604.5,238.5C 599.776,240.529 595.776,243.529 592.5,247.5C 590.413,248.585 589.08,250.251 588.5,252.5C 586.412,254.336 585.079,256.669 584.5,259.5C 582.981,262.526 582.315,265.859 582.5,269.5C 582.503,272.025 582.837,274.359 583.5,276.5C 584.771,279.343 585.604,282.343 586,285.5C 625.334,330.843 666.167,375.009 708.5,418C 709.448,418.483 710.448,418.649 711.5,418.5C 711.5,423.5 711.5,428.5 711.5,433.5C 710.448,433.649 709.448,433.483 708.5,433C 703.965,428.297 699.298,423.797 694.5,419.5C 692.57,415.9 689.903,412.9 686.5,410.5C 683.5,406.833 680.167,403.5 676.5,400.5C 674.57,396.9 671.903,393.9 668.5,391.5C 638.266,359.948 609.933,326.948 583.5,292.5C 582.412,288.896 580.079,287.063 576.5,287C 570.63,292.702 564.964,298.535 559.5,304.5C 541.823,318.994 523.823,332.994 505.5,346.5C 502.63,347.433 500.296,349.1 498.5,351.5C 492.559,354.78 486.892,358.447 481.5,362.5C 479.973,362.427 478.973,363.094 478.5,364.5C 476.973,364.427 475.973,365.094 475.5,366.5C 474.508,366.328 473.842,366.662 473.5,367.5C 471.973,367.427 470.973,368.094 470.5,369.5C 468.973,369.427 467.973,370.094 467.5,371.5C 463.164,373.332 459.164,375.665 455.5,378.5C 453.973,378.427 452.973,379.094 452.5,380.5C 435.998,389.25 419.665,398.25 403.5,407.5C 397.402,409.384 391.735,412.051 386.5,415.5C 380.88,417.643 375.547,420.31 370.5,423.5C 364.57,425.132 359.236,427.798 354.5,431.5C 350.835,431.502 347.835,432.835 345.5,435.5C 340.166,436.746 335.166,438.746 330.5,441.5C 328.152,441.592 326.486,442.592 325.5,444.5C 322.145,444.69 319.145,445.69 316.5,447.5C 314.152,447.592 312.486,448.592 311.5,450.5C 310.833,450.5 310.167,450.5 309.5,450.5C 307.973,450.427 306.973,451.094 306.5,452.5C 304.421,452.971 302.421,453.637 300.5,454.5C 295.265,456.129 290.265,458.129 285.5,460.5C 281.299,461.223 277.632,462.89 274.5,465.5C 269.536,466.377 264.869,468.043 260.5,470.5C 256.064,471.414 252.064,473.081 248.5,475.5C 243.297,476.009 238.63,477.676 234.5,480.5C 232.079,480.878 229.746,481.545 227.5,482.5C 225.033,482.755 223.033,483.755 221.5,485.5C 220.833,485.5 220.167,485.5 219.5,485.5C 209.084,488.412 199.084,492.079 189.5,496.5C 188.209,496.263 187.209,496.596 186.5,497.5C 164.491,504.058 142.824,511.392 121.5,519.5C 121.167,519.5 120.833,519.5 120.5,519.5C 114.273,521.307 107.939,522.64 101.5,523.5C 117.45,545.129 133.45,566.796 149.5,588.5C 145.833,588.5 142.167,588.5 138.5,588.5C 117.922,559.02 97.0885,529.687 76,500.5C 75.1841,499.177 74.0174,498.511 72.5,498.5C 72.5,494.5 72.5,490.5 72.5,486.5C 75.1073,487.316 77.1073,488.983 78.5,491.5C 79.0798,493.749 80.4131,495.415 82.5,496.5C 88.5362,502.237 93.8695,508.571 98.5,515.5C 100.288,516.622 102.288,516.789 104.5,516C 116.981,511.63 129.314,507.13 141.5,502.5C 144.397,501.871 147.064,500.871 149.5,499.5C 151.509,497.935 153.843,496.935 156.5,496.5C 164.812,493.681 173.146,490.847 181.5,488C 182.056,487.617 182.389,487.117 182.5,486.5C 184.698,486.88 186.365,486.213 187.5,484.5C 189.698,484.88 191.365,484.213 192.5,482.5C 193.833,482.167 195.167,481.833 196.5,481.5C 202.607,479.937 208.274,477.604 213.5,474.5C 215.09,474.372 216.423,473.705 217.5,472.5C 216.133,471.16 214.8,469.827 213.5,468.5C 210.5,464.833 207.167,461.5 203.5,458.5C 200.883,453.886 197.883,449.553 194.5,445.5C 194.573,443.973 193.906,442.973 192.5,442.5C 191.674,439.515 190.341,436.849 188.5,434.5C 187.424,431.352 186.091,428.352 184.5,425.5C 184.245,423.033 183.245,421.033 181.5,419.5C 180.538,415.605 179.204,411.939 177.5,408.5C 176.364,403.015 176.364,397.681 177.5,392.5C 179.5,391.167 181.167,389.5 182.5,387.5C 183.262,385.738 184.596,384.738 186.5,384.5C 188.027,384.573 189.027,383.906 189.5,382.5C 192.649,382.585 195.316,381.585 197.5,379.5C 198.429,378.685 199.429,377.852 200.5,377C 205.293,375.791 209.96,374.291 214.5,372.5C 217.267,369.214 216.934,366.214 213.5,363.5C 213.34,361.847 212.674,360.514 211.5,359.5C 211.245,357.033 210.245,355.033 208.5,353.5C 208.59,350.848 207.924,348.515 206.5,346.5C 206.5,345.833 206.5,345.167 206.5,344.5C 206.192,340.64 205.525,336.974 204.5,333.5C 204.829,320.989 204.495,308.655 203.5,296.5C 203.333,292.327 202,288.66 199.5,285.5C 199.573,283.973 198.906,282.973 197.5,282.5C 193.684,281.518 189.684,280.851 185.5,280.5C 184.167,278.833 182.833,277.167 181.5,275.5C 181.573,273.973 180.906,272.973 179.5,272.5C 175.863,265.549 171.863,258.882 167.5,252.5C 166.733,248.851 165.4,245.518 163.5,242.5C 162.249,236.871 160.915,231.205 159.5,225.5C 159.946,222.99 159.28,220.99 157.5,219.5C 156.644,215.429 155.477,211.429 154,207.5C 152.275,206.536 150.441,205.869 148.5,205.5C 148.027,204.094 147.027,203.427 145.5,203.5C 142.833,201.167 140.167,198.833 137.5,196.5C 137.573,194.973 136.906,193.973 135.5,193.5C 135.107,191.716 134.441,190.05 133.5,188.5C 133.245,186.033 132.245,184.033 130.5,182.5C 130.5,181.833 130.5,181.167 130.5,180.5C 129.623,171.867 129.289,163.2 129.5,154.5C 129.5,153.5 129.5,152.5 129.5,151.5C 131.31,148.855 132.31,145.855 132.5,142.5C 133.492,140.544 134.492,138.544 135.5,136.5C 136.946,135.387 138.613,135.22 140.5,136C 144.698,141.363 149.364,146.196 154.5,150.5C 155.492,152.026 156.992,152.693 159,152.5C 160.385,152.486 161.551,152.152 162.5,151.5C 163.167,150.833 163.833,150.167 164.5,149.5C 166.028,144.261 165.361,139.261 162.5,134.5C 162.59,131.848 161.924,129.515 160.5,127.5C 160.5,126.833 160.5,126.167 160.5,125.5C 160.413,120.463 160.746,115.463 161.5,110.5C 161.5,110.167 161.5,109.833 161.5,109.5C 162.906,109.027 163.573,108.027 163.5,106.5C 165.262,105.738 166.262,104.404 166.5,102.5C 168.569,99.4275 171.236,97.0941 174.5,95.5C 176.027,95.573 177.027,94.9063 177.5,93.5C 182.125,94.1052 183.792,92.4386 182.5,88.5C 180.391,84.5441 180.058,80.5441 181.5,76.5C 181.791,75.3509 182.624,74.6842 184,74.5C 185.07,74.528 185.903,74.8614 186.5,75.5C 188.211,77.2016 190.211,78.5349 192.5,79.5C 194.765,78.5684 196.765,77.2351 198.5,75.5C 199.906,75.0269 200.573,74.0269 200.5,72.5C 201.906,72.0269 202.573,71.0269 202.5,69.5C 203.906,69.0269 204.573,68.0269 204.5,66.5C 204.328,65.5084 204.662,64.8417 205.5,64.5C 206.906,64.0269 207.573,63.0269 207.5,61.5C 209.931,59.954 211.264,57.6207 211.5,54.5C 212.906,54.0269 213.573,53.0269 213.5,51.5C 215.262,50.7377 216.262,49.4044 216.5,47.5C 217.419,44.9108 219.086,42.9108 221.5,41.5C 225.5,38.1667 229.167,34.5 232.5,30.5C 234.749,29.9202 236.415,28.5869 237.5,26.5C 239.027,26.573 240.027,25.9063 240.5,24.5C 242.027,24.573 243.027,23.9063 243.5,22.5C 248.207,21.6401 252.541,19.9734 256.5,17.5C 256.833,17.5 257.167,17.5 257.5,17.5C 259.898,17.7406 261.898,17.0739 263.5,15.5C 277.057,14.2578 290.057,15.9245 302.5,20.5C 304.515,21.9238 306.848,22.5905 309.5,22.5C 311.033,24.2451 313.033,25.2451 315.5,25.5C 321.971,27.9913 328.638,29.6579 335.5,30.5C 335.5,26.1667 335.5,21.8333 335.5,17.5C 335.328,16.5084 335.662,15.8417 336.5,15.5C 338.117,14.4107 338.95,12.744 339,10.5C 341.367,7.06816 344.034,6.73483 347,9.5C 347.424,12.0254 348.59,14.0254 350.5,15.5 Z M 565.5,246.5 C 557.748,249.25 549.748,250.583 541.5,250.5C 540.179,255.15 538.846,259.817 537.5,264.5C 539.974,272.205 539.974,279.871 537.5,287.5C 537.833,287.833 538.167,288.167 538.5,288.5C 545.245,283.378 552.078,278.378 559,273.5C 559.448,268.47 560.114,263.47 561,258.5C 562.766,254.628 564.266,250.628 565.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535353",
    d: "M 416.5,10.5 C 414.485,11.9238 412.152,12.5905 409.5,12.5C 411.515,11.0762 413.848,10.4095 416.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 263.5,15.5 C 261.898,17.0739 259.898,17.7406 257.5,17.5C 259.102,15.9261 261.102,15.2594 263.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 398.5,16.5 C 396.383,18.6545 393.716,19.6545 390.5,19.5C 392.936,18.129 395.603,17.129 398.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 256.5,17.5 C 252.541,19.9734 248.207,21.6401 243.5,22.5C 247.237,19.4733 251.57,17.8067 256.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777777",
    d: "M 302.5,20.5 C 305.152,20.4095 307.485,21.0762 309.5,22.5C 306.848,22.5905 304.515,21.9238 302.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 390.5,19.5 C 387.947,21.5837 384.947,22.917 381.5,23.5C 384.053,21.4163 387.053,20.083 390.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6e",
    d: "M 243.5,22.5 C 243.027,23.9063 242.027,24.573 240.5,24.5C 240.973,23.0937 241.973,22.427 243.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5c5c",
    d: "M 309.5,22.5 C 311.579,22.9707 313.579,23.6373 315.5,24.5C 315.5,24.8333 315.5,25.1667 315.5,25.5C 313.033,25.2451 311.033,24.2451 309.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c9c9",
    d: "M 359.5,23.5 C 364.13,24.2295 368.797,24.5628 373.5,24.5C 371.052,25.4731 368.385,25.8064 365.5,25.5C 363.214,25.405 361.214,24.7384 359.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 447.5,22.5 C 448.906,22.9731 449.573,23.9731 449.5,25.5C 448.094,25.0269 447.427,24.0269 447.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595959",
    d: "M 240.5,24.5 C 240.027,25.9063 239.027,26.573 237.5,26.5C 237.973,25.0937 238.973,24.427 240.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4f4f",
    d: "M 373.5,24.5 C 374.833,24.5 376.167,24.5 377.5,24.5C 377.389,25.1174 377.056,25.6174 376.5,26C 372.642,26.8099 368.976,26.6433 365.5,25.5C 368.385,25.8064 371.052,25.4731 373.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d3d3d",
    d: "M 237.5,26.5 C 236.415,28.5869 234.749,29.9202 232.5,30.5C 233.585,28.4131 235.251,27.0798 237.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a0a0",
    d: "M 335.5,17.5 C 335.5,21.8333 335.5,26.1667 335.5,30.5C 328.638,29.6579 321.971,27.9913 315.5,25.5C 315.5,25.1667 315.5,24.8333 315.5,24.5C 321.766,26.3656 328.1,28.0322 334.5,29.5C 334.183,25.2984 334.517,21.2984 335.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3c3c3",
    d: "M 450.5,27.5 C 451.117,27.6107 451.617,27.944 452,28.5C 453.438,36.1203 454.938,43.4537 456.5,50.5C 456.5,50.8333 456.5,51.1667 456.5,51.5C 456.167,51.5 455.833,51.5 455.5,51.5C 453.862,47.0874 452.862,42.4208 452.5,37.5C 452.149,34.0968 451.482,30.7635 450.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#391a22",
    d: "M 436.5,33.5 C 433.67,33.3059 431.004,32.6392 428.5,31.5C 412.484,28.6383 401.651,34.9716 396,50.5C 392.117,54.0504 387.951,57.2171 383.5,60C 369.731,64.136 356.397,63.136 343.5,57C 340.334,54.9999 337.668,52.4999 335.5,49.5C 339.848,49.0907 344.181,48.9241 348.5,49C 360.808,60.0264 374.142,61.3598 388.5,53C 390.746,51.7432 392.079,49.9099 392.5,47.5C 381.477,50.8116 370.811,49.9782 360.5,45C 358.333,42.8333 356.167,40.6667 354,38.5C 352.249,36.788 351.582,34.788 352,32.5C 364.085,40.4314 376.918,41.598 390.5,36C 400.677,30.7424 411.343,26.9091 422.5,24.5C 428.779,25.1324 433.446,28.1324 436.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 232.5,30.5 C 229.167,34.5 225.5,38.1667 221.5,41.5C 224.167,36.8333 227.833,33.1667 232.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#937462",
    d: "M 287.5,35.5 C 299.773,38.9243 311.773,42.9243 323.5,47.5C 317.545,46.3495 311.712,44.6828 306,42.5C 297.861,43.1431 289.694,43.3097 281.5,43C 280.167,44 280.167,45 281.5,46C 285.186,46.5588 288.853,47.2255 292.5,48C 294.286,48.1962 295.619,49.0295 296.5,50.5C 292.893,51.4892 289.226,51.8226 285.5,51.5C 287.969,50.6829 290.635,50.1829 293.5,50C 288.919,48.7247 284.252,47.7247 279.5,47C 278.446,45.6124 278.28,44.1124 279,42.5C 284.083,41.6929 289.25,41.1929 294.5,41C 290.584,39.8976 286.584,39.231 282.5,39C 281.663,37.9887 281.33,36.8221 281.5,35.5C 283.5,35.5 285.5,35.5 287.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4937f",
    d: "M 323.5,47.5 C 323.5,48.5 323.5,49.5 323.5,50.5C 319.475,50.1839 315.475,50.0172 311.5,50C 313.67,50.8112 315.337,52.1446 316.5,54C 316.355,54.772 316.022,55.4387 315.5,56C 313.527,56.4955 311.527,56.6621 309.5,56.5C 309.67,57.8221 309.337,58.9887 308.5,60C 304.644,60.1773 300.977,60.6773 297.5,61.5C 294.609,62.4025 291.609,62.7359 288.5,62.5C 288.674,60.139 289.007,57.8056 289.5,55.5C 288.167,55.5 286.833,55.5 285.5,55.5C 285.5,54.1667 285.5,52.8333 285.5,51.5C 289.226,51.8226 292.893,51.4892 296.5,50.5C 295.619,49.0295 294.286,48.1962 292.5,48C 288.853,47.2255 285.186,46.5588 281.5,46C 280.167,45 280.167,44 281.5,43C 289.694,43.3097 297.861,43.1431 306,42.5C 311.712,44.6828 317.545,46.3495 323.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#474747",
    d: "M 452.5,37.5 C 452.862,42.4208 453.862,47.0874 455.5,51.5C 454.791,52.404 453.791,52.7373 452.5,52.5C 452.5,47.5 452.5,42.5 452.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad8c78",
    d: "M 415.5,59.5 C 416.46,52.9221 416.793,46.2554 416.5,39.5C 417.738,38.5876 419.072,38.4209 420.5,39C 423.037,41.9063 425.204,45.073 427,48.5C 426.954,45.1996 426.788,41.8663 426.5,38.5C 428.167,38.5 429.833,38.5 431.5,38.5C 432.961,43.7866 433.628,43.4533 433.5,37.5C 437.312,38.0781 438.979,40.4114 438.5,44.5C 438.824,48.8423 436.824,50.8423 432.5,50.5C 432.648,53.3523 431.314,55.019 428.5,55.5C 425.578,53.6948 423.078,51.3615 421,48.5C 421.265,53.8074 419.765,58.4741 416.5,62.5C 415.614,61.675 415.281,60.675 415.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#63402a",
    d: "M 286.5,34.5 C 287.167,34.5 287.5,34.8333 287.5,35.5C 285.5,35.5 283.5,35.5 281.5,35.5C 281.33,36.8221 281.663,37.9887 282.5,39C 286.584,39.231 290.584,39.8976 294.5,41C 289.25,41.1929 284.083,41.6929 279,42.5C 278.28,44.1124 278.446,45.6124 279.5,47C 284.252,47.7247 288.919,48.7247 293.5,50C 290.635,50.1829 287.969,50.6829 285.5,51.5C 285.5,52.8333 285.5,54.1667 285.5,55.5C 286.833,55.5 288.167,55.5 289.5,55.5C 289.007,57.8056 288.674,60.139 288.5,62.5C 291.609,62.7359 294.609,62.4025 297.5,61.5C 300.85,61.335 304.183,61.5017 307.5,62C 304.833,62.6667 304.833,63.3333 307.5,64C 309.473,64.4955 311.473,64.6621 313.5,64.5C 299.584,66.6231 287.251,72.2898 276.5,81.5C 269.75,84.0391 263.083,86.8725 256.5,90C 247.877,92.9175 242.377,90.0842 240,81.5C 239.656,67.0171 245.156,55.1838 256.5,46C 261.865,41.3163 267.865,37.6496 274.5,35C 278.486,34.5012 282.486,34.3345 286.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 485.5,48.5 C 488.716,48.3455 491.383,49.3455 493.5,51.5C 490.603,50.871 487.936,49.871 485.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 216.5,47.5 C 216.262,49.4044 215.262,50.7377 213.5,51.5C 213.738,49.5956 214.738,48.2623 216.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66452f",
    d: "M 428.5,31.5 C 422.928,30.9896 417.595,31.8229 412.5,34C 414.439,35.4321 415.772,37.2654 416.5,39.5C 416.793,46.2554 416.46,52.9221 415.5,59.5C 414.566,60.5676 414.232,61.901 414.5,63.5C 416.308,63.4914 417.975,63.9914 419.5,65C 427.378,71.7129 434.712,78.8796 441.5,86.5C 437.595,88.4065 434.095,91.0731 431,94.5C 429.493,97.8202 429.327,101.153 430.5,104.5C 429.402,105.397 429.402,106.23 430.5,107C 439.047,108.398 446.547,111.898 453,117.5C 453.817,120.964 453.483,124.298 452,127.5C 447.906,132.102 443.406,136.102 438.5,139.5C 439.302,133.848 439.469,128.182 439,122.5C 432.791,108.491 423.458,105.824 411,114.5C 410.517,115.448 410.351,116.448 410.5,117.5C 401.167,117.5 391.833,117.5 382.5,117.5C 381.186,113.671 378.853,110.505 375.5,108C 371.944,106.392 368.611,104.559 365.5,102.5C 356.308,90.7388 344.308,85.9055 329.5,88C 325.786,88.6085 322.12,89.4418 318.5,90.5C 316.955,90.4892 315.622,90.1558 314.5,89.5C 328.598,85.9877 342.931,84.6544 357.5,85.5C 357.833,82.5 356.5,81.1667 353.5,81.5C 351.735,80.5386 349.735,80.2053 347.5,80.5C 347.739,78.5328 347.406,76.6995 346.5,75C 343.854,74.5026 341.187,74.3359 338.5,74.5C 338.5,73.5 338.5,72.5 338.5,71.5C 343.754,72.918 349.087,73.7513 354.5,74C 347.92,69.2489 340.587,66.2489 332.5,65C 326.175,64.5005 319.842,64.3338 313.5,64.5C 311.473,64.6621 309.473,64.4955 307.5,64C 304.833,63.3333 304.833,62.6667 307.5,62C 304.183,61.5017 300.85,61.335 297.5,61.5C 300.977,60.6773 304.644,60.1773 308.5,60C 309.337,58.9887 309.67,57.8221 309.5,56.5C 311.527,56.6621 313.527,56.4955 315.5,56C 316.022,55.4387 316.355,54.772 316.5,54C 315.337,52.1446 313.67,50.8112 311.5,50C 315.475,50.0172 319.475,50.1839 323.5,50.5C 323.5,49.5 323.5,48.5 323.5,47.5C 327.326,48.9997 331.326,49.6664 335.5,49.5C 337.668,52.4999 340.334,54.9999 343.5,57C 356.397,63.136 369.731,64.136 383.5,60C 387.951,57.2171 392.117,54.0504 396,50.5C 401.651,34.9716 412.484,28.6383 428.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 464.5,48.5 C 462.064,49.871 459.397,50.871 456.5,51.5C 456.5,51.1667 456.5,50.8333 456.5,50.5C 458.993,49.2264 461.659,48.5597 464.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a4c36",
    d: "M 428.5,31.5 C 431.004,32.6392 433.67,33.3059 436.5,33.5C 438.353,36.2084 439.353,39.2084 439.5,42.5C 439.788,48.9921 440.788,55.3255 442.5,61.5C 441.766,62.7079 441.433,64.0413 441.5,65.5C 446.902,63.9707 452.235,62.1373 457.5,60C 464.014,59.18 470.347,59.3467 476.5,60.5C 475.325,60.281 474.325,60.6143 473.5,61.5C 475.483,63.9837 477.65,66.3171 480,68.5C 480.667,69.1667 480.667,69.8333 480,70.5C 472.738,64.5745 464.572,62.2411 455.5,63.5C 454.035,65.5463 454.368,67.3796 456.5,69C 455.584,69.2784 454.918,69.7784 454.5,70.5C 453.675,72.3076 452.675,74.1409 451.5,76C 451.748,77.7491 452.748,78.5824 454.5,78.5C 458.271,81.7684 461.938,85.2684 465.5,89C 467.134,89.4935 468.801,89.6602 470.5,89.5C 470.682,87.4086 470.348,85.4086 469.5,83.5C 470.576,82.3441 471.576,82.5108 472.5,84C 478.451,85.1028 479.951,82.9361 477,77.5C 474.239,75.3188 472.406,72.9855 471.5,70.5C 472.5,71 473.5,71.5 474.5,72C 479.345,76.1799 484.178,80.3466 489,84.5C 490.5,84.3333 491.333,83.5 491.5,82C 490.541,78.3071 489.208,74.8071 487.5,71.5C 488.612,70.7348 489.279,69.7348 489.5,68.5C 491.828,69.7356 492.994,71.7356 493,74.5C 492.901,86.2857 493.901,97.9524 496,109.5C 497.24,112.978 498.74,116.311 500.5,119.5C 500.53,120.497 500.03,121.164 499,121.5C 490.913,115.418 483.413,108.584 476.5,101C 469.638,95.4475 462.305,90.7809 454.5,87C 450.179,86.501 445.846,86.3343 441.5,86.5C 434.712,78.8796 427.378,71.7129 419.5,65C 417.975,63.9914 416.308,63.4914 414.5,63.5C 414.232,61.901 414.566,60.5676 415.5,59.5C 415.281,60.675 415.614,61.675 416.5,62.5C 419.765,58.4741 421.265,53.8074 421,48.5C 423.078,51.3615 425.578,53.6948 428.5,55.5C 431.314,55.019 432.648,53.3523 432.5,50.5C 436.824,50.8423 438.824,48.8423 438.5,44.5C 438.979,40.4114 437.312,38.0781 433.5,37.5C 433.628,43.4533 432.961,43.7866 431.5,38.5C 429.833,38.5 428.167,38.5 426.5,38.5C 426.788,41.8663 426.954,45.1996 427,48.5C 425.204,45.073 423.037,41.9063 420.5,39C 419.072,38.4209 417.738,38.5876 416.5,39.5C 415.772,37.2654 414.439,35.4321 412.5,34C 417.595,31.8229 422.928,30.9896 428.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6e",
    d: "M 213.5,51.5 C 213.573,53.0269 212.906,54.0269 211.5,54.5C 211.427,52.9731 212.094,51.9731 213.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 497.5,53.5 C 500.167,54.1667 501.833,55.8333 502.5,58.5C 500.5,57.1667 498.833,55.5 497.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#434343",
    d: "M 211.5,54.5 C 211.264,57.6207 209.931,59.954 207.5,61.5C 208.079,58.6689 209.412,56.3356 211.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#463323",
    d: "M 439.5,42.5 C 441.32,48.1817 442.987,54.0151 444.5,60C 444.164,61.0299 443.497,61.5299 442.5,61.5C 440.788,55.3255 439.788,48.9921 439.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4937f",
    d: "M 476.5,60.5 C 481.674,61.9146 486.007,64.5813 489.5,68.5C 489.279,69.7348 488.612,70.7348 487.5,71.5C 489.208,74.8071 490.541,78.3071 491.5,82C 491.333,83.5 490.5,84.3333 489,84.5C 484.178,80.3466 479.345,76.1799 474.5,72C 473.5,71.5 472.5,71 471.5,70.5C 472.406,72.9855 474.239,75.3188 477,77.5C 479.951,82.9361 478.451,85.1028 472.5,84C 471.576,82.5108 470.576,82.3441 469.5,83.5C 470.348,85.4086 470.682,87.4086 470.5,89.5C 468.801,89.6602 467.134,89.4935 465.5,89C 461.938,85.2684 458.271,81.7684 454.5,78.5C 453.15,77.3501 453.316,76.6834 455,76.5C 457.602,78.7147 460.435,80.2147 463.5,81C 461.268,78.2651 458.601,76.0984 455.5,74.5C 454.571,73.3112 454.238,71.9778 454.5,70.5C 458.809,71.4852 462.809,73.3185 466.5,76C 467.5,76.6667 468.5,76.6667 469.5,76C 465.508,72.6691 461.175,69.8358 456.5,67.5C 455.571,66.3112 455.238,64.9778 455.5,63.5C 464.572,62.2411 472.738,64.5745 480,70.5C 480.667,69.8333 480.667,69.1667 480,68.5C 477.65,66.3171 475.483,63.9837 473.5,61.5C 474.325,60.6143 475.325,60.281 476.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 207.5,61.5 C 207.573,63.0269 206.906,64.0269 205.5,64.5C 205.427,62.9731 206.094,61.9731 207.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 505.5,62.5 C 507.655,64.6174 508.655,67.284 508.5,70.5C 507.129,68.064 506.129,65.3973 505.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656565",
    d: "M 204.5,66.5 C 204.573,68.0269 203.906,69.0269 202.5,69.5C 202.427,67.9731 203.094,66.9731 204.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#57473d",
    d: "M 333.5,70.5 C 326.465,70.3257 319.465,70.6591 312.5,71.5C 311.167,71.5 309.833,71.5 308.5,71.5C 313.599,70.0959 318.932,69.4292 324.5,69.5C 327.686,69.502 330.686,69.8353 333.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6e",
    d: "M 202.5,69.5 C 202.573,71.0269 201.906,72.0269 200.5,72.5C 200.427,70.9731 201.094,69.9731 202.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b59480",
    d: "M 333.5,70.5 C 334.609,71.29 335.942,71.79 337.5,72C 335.623,73.1853 333.623,74.1853 331.5,75C 336.167,75.3333 340.833,75.6667 345.5,76C 346.86,77.9376 346.527,79.6043 344.5,81C 347.482,81.498 350.482,81.6646 353.5,81.5C 356.5,81.1667 357.833,82.5 357.5,85.5C 342.931,84.6544 328.598,85.9877 314.5,89.5C 314.238,88.0222 314.571,86.6888 315.5,85.5C 319.384,83.7052 323.384,82.2052 327.5,81C 326.5,80.8333 325.5,80.6667 324.5,80.5C 313.155,81.757 302.155,84.0904 291.5,87.5C 291.215,85.712 291.548,84.0453 292.5,82.5C 297.193,80.4851 301.859,78.4851 306.5,76.5C 309.918,75.8118 313.251,74.8118 316.5,73.5C 315.051,72.8281 313.718,72.1614 312.5,71.5C 319.465,70.6591 326.465,70.3257 333.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b6c56",
    d: "M 455.5,63.5 C 455.238,64.9778 455.571,66.3112 456.5,67.5C 461.175,69.8358 465.508,72.6691 469.5,76C 468.5,76.6667 467.5,76.6667 466.5,76C 462.809,73.3185 458.809,71.4852 454.5,70.5C 454.918,69.7784 455.584,69.2784 456.5,69C 454.368,67.3796 454.035,65.5463 455.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 186.5,75.5 C 184.708,75.366 183.042,75.6993 181.5,76.5C 183.042,75.6993 184.708,75.366 186.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 200.5,72.5 C 200.573,74.0269 199.906,75.0269 198.5,75.5C 198.427,73.9731 199.094,72.9731 200.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#84634e",
    d: "M 333.5,70.5 C 335.415,70.2155 337.081,70.5489 338.5,71.5C 338.5,72.5 338.5,73.5 338.5,74.5C 341.187,74.3359 343.854,74.5026 346.5,75C 347.406,76.6995 347.739,78.5328 347.5,80.5C 349.735,80.2053 351.735,80.5386 353.5,81.5C 350.482,81.6646 347.482,81.498 344.5,81C 346.527,79.6043 346.86,77.9376 345.5,76C 340.833,75.6667 336.167,75.3333 331.5,75C 333.623,74.1853 335.623,73.1853 337.5,72C 335.942,71.79 334.609,71.29 333.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b6b55",
    d: "M 454.5,70.5 C 454.238,71.9778 454.571,73.3112 455.5,74.5C 458.601,76.0984 461.268,78.2651 463.5,81C 460.435,80.2147 457.602,78.7147 455,76.5C 453.316,76.6834 453.15,77.3501 454.5,78.5C 452.748,78.5824 451.748,77.7491 451.5,76C 452.675,74.1409 453.675,72.3076 454.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#927360",
    d: "M 308.5,71.5 C 309.833,71.5 311.167,71.5 312.5,71.5C 313.718,72.1614 315.051,72.8281 316.5,73.5C 313.251,74.8118 309.918,75.8118 306.5,76.5C 300.678,76.0839 295.011,77.4172 289.5,80.5C 288.893,80.3764 288.56,80.0431 288.5,79.5C 294.702,75.6189 301.368,72.9522 308.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#623f28",
    d: "M 306.5,76.5 C 301.859,78.4851 297.193,80.4851 292.5,82.5C 291.548,84.0453 291.215,85.712 291.5,87.5C 302.155,84.0904 313.155,81.757 324.5,80.5C 325.5,80.6667 326.5,80.8333 327.5,81C 323.384,82.2052 319.384,83.7052 315.5,85.5C 314.571,86.6888 314.238,88.0222 314.5,89.5C 315.622,90.1558 316.955,90.4892 318.5,90.5C 322.12,89.4418 325.786,88.6085 329.5,88C 344.308,85.9055 356.308,90.7388 365.5,102.5C 364.167,102.5 362.833,102.5 361.5,102.5C 361.082,101.778 360.416,101.278 359.5,101C 347.278,99.6748 335.278,100.675 323.5,104C 321.934,104.608 320.6,105.442 319.5,106.5C 304.727,111.886 290.727,118.886 277.5,127.5C 274.125,128.838 270.792,130.171 267.5,131.5C 264.739,130.019 262.906,127.686 262,124.5C 261.123,118.685 261.623,113.018 263.5,107.5C 268.987,95.6768 277.32,86.3435 288.5,79.5C 288.56,80.0431 288.893,80.3764 289.5,80.5C 295.011,77.4172 300.678,76.0839 306.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797979",
    d: "M 508.5,70.5 C 509.29,71.6085 509.79,72.9419 510,74.5C 510.737,83.1566 511.237,91.8232 511.5,100.5C 509.897,90.7043 508.897,80.7043 508.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b1a24",
    d: "M 441.5,86.5 C 445.846,86.3343 450.179,86.501 454.5,87C 462.305,90.7809 469.638,95.4475 476.5,101C 483.413,108.584 490.913,115.418 499,121.5C 500.03,121.164 500.53,120.497 500.5,119.5C 502.47,121.647 504.303,123.98 506,126.5C 507.896,128.53 510.063,130.197 512.5,131.5C 500.095,134.764 489.095,131.931 479.5,123C 478.552,122.517 477.552,122.351 476.5,122.5C 476.949,125.29 476.949,127.956 476.5,130.5C 470.364,128.05 464.031,126.383 457.5,125.5C 458.584,119.93 456.917,115.43 452.5,112C 445.786,107.656 438.453,105.156 430.5,104.5C 429.327,101.153 429.493,97.8202 431,94.5C 434.095,91.0731 437.595,88.4065 441.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4f4f",
    d: "M 182.5,88.5 C 183.792,92.4386 182.125,94.1052 177.5,93.5C 178.78,92.0687 180.447,91.4021 182.5,91.5C 182.5,90.5 182.5,89.5 182.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 177.5,93.5 C 177.027,94.9063 176.027,95.573 174.5,95.5C 174.973,94.0937 175.973,93.427 177.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#492722",
    d: "M 361.5,102.5 C 347.12,100.378 333.12,101.711 319.5,106.5C 320.6,105.442 321.934,104.608 323.5,104C 335.278,100.675 347.278,99.6748 359.5,101C 360.416,101.278 361.082,101.778 361.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#623e27",
    d: "M 239.5,100.5 C 244.723,101.35 250.057,102.35 255.5,103.5C 251.333,110.5 247.167,117.5 243,124.5C 240.5,126.333 238,128.167 235.5,130C 227.68,133.286 219.68,135.953 211.5,138C 207.648,141.308 206.648,145.308 208.5,150C 199.729,151.104 192.229,148.604 186,142.5C 179.783,134.607 177.283,125.607 178.5,115.5C 181.574,110.091 185.908,106.091 191.5,103.5C 191.47,104.497 191.97,105.164 193,105.5C 194.789,104.591 196.623,104.424 198.5,105C 194.722,107.112 191.222,109.612 188,112.5C 187.51,113.793 187.343,115.127 187.5,116.5C 194.908,114.102 202.408,111.769 210,109.5C 210.833,109.667 211.667,109.833 212.5,110C 209.5,111.833 206.5,113.667 203.5,115.5C 202.571,116.689 202.238,118.022 202.5,119.5C 207.453,118.684 212.286,117.35 217,115.5C 218.396,116.394 219.896,117.061 221.5,117.5C 224.13,116.622 226.797,115.955 229.5,115.5C 229.5,114.5 229.5,113.5 229.5,112.5C 227.335,112.884 225.668,112.217 224.5,110.5C 226.427,108.898 228.594,107.565 231,106.5C 231.765,104.934 231.598,103.601 230.5,102.5C 226.002,101.625 221.335,101.625 216.5,102.5C 216.5,101.5 216.5,100.5 216.5,99.5C 224.255,98.289 231.921,98.6223 239.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#765947",
    d: "M 216.5,99.5 C 216.5,100.5 216.5,101.5 216.5,102.5C 221.335,101.625 226.002,101.625 230.5,102.5C 223.764,103.236 217.097,104.07 210.5,105C 211.851,103.383 213.518,102.216 215.5,101.5C 208.09,100.846 200.757,101.512 193.5,103.5C 193.611,102.883 193.944,102.383 194.5,102C 201.694,99.9721 209.027,99.1388 216.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2917c",
    d: "M 230.5,102.5 C 231.598,103.601 231.765,104.934 231,106.5C 228.594,107.565 226.427,108.898 224.5,110.5C 225.668,112.217 227.335,112.884 229.5,112.5C 229.5,113.5 229.5,114.5 229.5,115.5C 226.797,115.955 224.13,116.622 221.5,117.5C 219.896,117.061 218.396,116.394 217,115.5C 212.286,117.35 207.453,118.684 202.5,119.5C 202.238,118.022 202.571,116.689 203.5,115.5C 206.5,113.667 209.5,111.833 212.5,110C 211.667,109.833 210.833,109.667 210,109.5C 202.408,111.769 194.908,114.102 187.5,116.5C 187.343,115.127 187.51,113.793 188,112.5C 191.222,109.612 194.722,107.112 198.5,105C 196.623,104.424 194.789,104.591 193,105.5C 191.97,105.164 191.47,104.497 191.5,103.5C 192.167,103.5 192.833,103.5 193.5,103.5C 200.757,101.512 208.09,100.846 215.5,101.5C 213.518,102.216 211.851,103.383 210.5,105C 217.097,104.07 223.764,103.236 230.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525252",
    d: "M 166.5,102.5 C 166.262,104.404 165.262,105.738 163.5,106.5C 163.738,104.596 164.738,103.262 166.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37151b",
    d: "M 361.5,102.5 C 362.833,102.5 364.167,102.5 365.5,102.5C 368.611,104.559 371.944,106.392 375.5,108C 378.853,110.505 381.186,113.671 382.5,117.5C 382.5,117.833 382.5,118.167 382.5,118.5C 379.102,118.82 375.768,118.487 372.5,117.5C 368.461,113.764 363.627,112.097 358,112.5C 343.673,113.693 330.173,117.526 317.5,124C 301.092,134.066 284.426,143.733 267.5,153C 250.907,161.494 235.24,160.16 220.5,149C 233.675,148.667 243.508,142.834 250,131.5C 254.274,123.276 258.774,115.276 263.5,107.5C 261.623,113.018 261.123,118.685 262,124.5C 262.906,127.686 264.739,130.019 267.5,131.5C 270.792,130.171 274.125,128.838 277.5,127.5C 290.727,118.886 304.727,111.886 319.5,106.5C 333.12,101.711 347.12,100.378 361.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 163.5,106.5 C 163.573,108.027 162.906,109.027 161.5,109.5C 161.427,107.973 162.094,106.973 163.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606060",
    d: "M 511.5,101.5 C 512.525,104.974 513.192,108.64 513.5,112.5C 511.783,109.155 511.116,105.489 511.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b1b20",
    d: "M 438.5,139.5 C 436.873,141.63 435.04,143.63 433,145.5C 433.768,138.877 434.101,132.21 434,125.5C 432.207,122.705 430.04,120.205 427.5,118C 412.521,118.332 397.521,118.499 382.5,118.5C 382.5,118.167 382.5,117.833 382.5,117.5C 391.833,117.5 401.167,117.5 410.5,117.5C 410.351,116.448 410.517,115.448 411,114.5C 423.458,105.824 432.791,108.491 439,122.5C 439.469,128.182 439.302,133.848 438.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575757",
    d: "M 515.5,116.5 C 517.167,117.5 518.5,118.833 519.5,120.5C 517.167,120.167 515.833,118.833 515.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M 161.5,110.5 C 160.746,115.463 160.413,120.463 160.5,125.5C 159.838,123.696 159.505,121.696 159.5,119.5C 159.343,116.186 160.009,113.186 161.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3f3f",
    d: "M 519.5,120.5 C 525.775,121.418 532.108,121.751 538.5,121.5C 532.681,122.653 526.681,122.819 520.5,122C 519.944,121.617 519.611,121.117 519.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37161c",
    d: "M 286.5,34.5 C 282.486,34.3345 278.486,34.5012 274.5,35C 267.865,37.6496 261.865,41.3163 256.5,46C 245.156,55.1838 239.656,67.0171 240,81.5C 242.377,90.0842 247.877,92.9175 256.5,90C 263.083,86.8725 269.75,84.0391 276.5,81.5C 270.854,86.9877 265.687,92.9877 261,99.5C 255.922,109.99 250.589,120.323 245,130.5C 236.837,143.159 225.67,147.159 211.5,142.5C 211.608,144.783 212.441,146.783 214,148.5C 217.557,152.025 221.39,155.191 225.5,158C 224.57,158.991 223.404,159.491 222,159.5C 209.996,155.608 199.163,157.775 189.5,166C 181.923,172.749 174.59,179.583 167.5,186.5C 165.784,186.371 164.117,186.038 162.5,185.5C 154.415,179.371 148.748,171.371 145.5,161.5C 155.363,167.496 164.53,166.496 173,158.5C 174.562,156.043 175.562,153.376 176,150.5C 175.844,140.505 175.844,130.505 176,120.5C 176.985,118.825 177.819,117.158 178.5,115.5C 177.283,125.607 179.783,134.607 186,142.5C 192.229,148.604 199.729,151.104 208.5,150C 206.648,145.308 207.648,141.308 211.5,138C 219.68,135.953 227.68,133.286 235.5,130C 238,128.167 240.5,126.333 243,124.5C 247.167,117.5 251.333,110.5 255.5,103.5C 250.057,102.35 244.723,101.35 239.5,100.5C 240.978,100.762 242.311,100.429 243.5,99.5C 235.86,95.565 227.86,92.7316 219.5,91C 213.5,90.6667 207.5,90.3333 201.5,90C 204.833,87.6667 208.167,85.3333 211.5,83C 220.376,73.1257 228.876,62.9591 237,52.5C 245.04,43.4006 254.874,37.2339 266.5,34C 273.346,33.1794 280.013,33.346 286.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b4c8f",
    d: "M 402.5,128.5 C 408.026,128.179 413.36,128.512 418.5,129.5C 418.362,134.414 419.028,139.081 420.5,143.5C 421.826,158.672 421.826,174.005 420.5,189.5C 419.352,191.149 418.019,192.649 416.5,194C 412.745,194.755 409.078,194.589 405.5,193.5C 406.712,179.011 406.712,164.677 405.5,150.5C 405.372,143.001 404.372,135.668 402.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#432f59",
    d: "M 365.5,129.5 C 360.402,130.957 355.069,131.624 349.5,131.5C 354.553,129.74 359.886,129.073 365.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bac4",
    d: "M 395.5,128.5 C 398.995,149.871 399.995,171.205 398.5,192.5C 382.497,192.333 366.497,192.5 350.5,193C 346.335,193.705 342.335,194.539 338.5,195.5C 338.167,195.5 337.833,195.5 337.5,195.5C 334.813,195.336 332.146,195.503 329.5,196C 328.584,196.278 327.918,196.778 327.5,197.5C 324.167,197.833 320.833,198.167 317.5,198.5C 314.848,198.41 312.515,199.076 310.5,200.5C 307.572,200.565 304.905,201.232 302.5,202.5C 297.835,203.057 293.502,204.39 289.5,206.5C 288.167,206.5 286.833,206.5 285.5,206.5C 283.585,206.784 281.919,206.451 280.5,205.5C 280.833,204.833 281.167,204.167 281.5,203.5C 282.167,202.833 282.833,202.167 283.5,201.5C 298.086,193.575 302.253,181.909 296,166.5C 293.963,164.294 291.797,162.294 289.5,160.5C 293.268,157.775 297.268,155.275 301.5,153C 305.765,148.034 311.099,144.867 317.5,143.5C 333.858,138.862 350.525,135.695 367.5,134C 368.942,133.623 369.942,132.79 370.5,131.5C 373.067,131.279 375.401,130.612 377.5,129.5C 383.471,128.759 389.471,128.425 395.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 548.5,123.5 C 549.473,125.948 549.806,128.615 549.5,131.5C 550.791,131.263 551.791,131.596 552.5,132.5C 550.833,132.5 549.167,132.5 547.5,132.5C 548.159,129.545 548.492,126.545 548.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#694b8b",
    d: "M 365.5,129.5 C 369.5,129.5 373.5,129.5 377.5,129.5C 375.401,130.612 373.067,131.279 370.5,131.5C 352.153,132.967 334.486,136.967 317.5,143.5C 311.099,144.867 305.765,148.034 301.5,153C 297.268,155.275 293.268,157.775 289.5,160.5C 287.579,159.637 285.579,158.971 283.5,158.5C 281.369,157.686 279.036,157.186 276.5,157C 277.056,156.617 277.389,156.117 277.5,155.5C 288.774,149.527 299.774,143.027 310.5,136C 323.382,133.439 336.382,131.939 349.5,131.5C 355.069,131.624 360.402,130.957 365.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 160.5,127.5 C 161.924,129.515 162.59,131.848 162.5,134.5C 161.076,132.485 160.41,130.152 160.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#415263",
    d: "M 428.5,139.5 C 427.732,140.263 427.232,141.263 427,142.5C 426.79,140.942 426.29,139.609 425.5,138.5C 424.072,135.697 423.405,132.697 423.5,129.5C 425.5,129.833 427.5,130.167 429.5,130.5C 429.296,133.518 428.963,136.518 428.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b96b5",
    d: "M 370.5,131.5 C 369.942,132.79 368.942,133.623 367.5,134C 350.525,135.695 333.858,138.862 317.5,143.5C 334.486,136.967 352.153,132.967 370.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 561.5,134.5 C 563.027,134.427 564.027,135.094 564.5,136.5C 562.973,136.573 561.973,135.906 561.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#312241",
    d: "M 418.5,129.5 C 419.972,133.919 420.638,138.586 420.5,143.5C 419.028,139.081 418.362,134.414 418.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d6175",
    d: "M 493.5,148.5 C 493.915,166.888 493.249,185.221 491.5,203.5C 490.365,208.237 489.032,212.903 487.5,217.5C 473.029,212.842 458.695,207.675 444.5,202C 437.831,201.051 431.164,200.218 424.5,199.5C 424.5,199.167 424.5,198.833 424.5,198.5C 425.29,197.391 425.79,196.058 426,194.5C 426.169,180.994 426.669,167.66 427.5,154.5C 428.858,155.626 430.192,155.626 431.5,154.5C 438.292,148.209 444.959,141.709 451.5,135C 452.333,134.833 453.167,134.667 454,134.5C 467.506,138.331 480.672,142.997 493.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M 135.5,136.5 C 134.492,138.544 133.492,140.544 132.5,142.5C 132.025,139.687 133.025,137.687 135.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 568.5,138.5 C 570.749,139.08 572.415,140.413 573.5,142.5C 571.251,141.92 569.585,140.587 568.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7e",
    d: "M 162.5,134.5 C 165.361,139.261 166.028,144.261 164.5,149.5C 164.569,144.384 163.902,139.384 162.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2455",
    d: "M 554.5,146.5 C 544.711,147.29 539.711,152.624 539.5,162.5C 535.669,163.918 532.002,165.584 528.5,167.5C 524.53,152.795 530.197,145.128 545.5,144.5C 547.833,144.667 550.167,144.833 552.5,145C 553.416,145.278 554.082,145.778 554.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555555",
    d: "M 132.5,142.5 C 132.31,145.855 131.31,148.855 129.5,151.5C 129.5,151.167 129.5,150.833 129.5,150.5C 129.733,147.458 130.733,144.792 132.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c5f73",
    d: "M 554.5,146.5 C 559.201,147.351 563.201,149.518 566.5,153C 571.902,161.9 578.235,170.067 585.5,177.5C 572.082,183.236 558.082,185.403 543.5,184C 538.225,179.613 537.225,174.446 540.5,168.5C 542.743,167.526 545.076,167.192 547.5,167.5C 551.773,169.305 555.773,171.639 559.5,174.5C 560.583,173.635 560.749,172.635 560,171.5C 554.488,165.496 547.654,162.496 539.5,162.5C 539.711,152.624 544.711,147.29 554.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#735696",
    d: "M 395.5,128.5 C 396.167,128.5 396.833,128.5 397.5,128.5C 399.731,135.996 401.231,143.663 402,151.5C 402.814,165.575 402.648,179.575 401.5,193.5C 400.5,193.5 399.5,193.5 398.5,193.5C 398.5,193.167 398.5,192.833 398.5,192.5C 399.995,171.205 398.995,149.871 395.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2556",
    d: "M 494.5,148.5 C 503.182,152.258 511.348,156.924 519,162.5C 520.047,165.039 520.547,167.705 520.5,170.5C 519.865,176.152 519.532,181.818 519.5,187.5C 519.781,192.565 519.448,197.565 518.5,202.5C 514.018,203.167 509.684,203.834 505.5,204.5C 495.565,208.351 491.232,215.684 492.5,226.5C 484.896,223.034 477.23,219.534 469.5,216C 459.275,212.694 448.942,209.861 438.5,207.5C 433.474,205.406 428.141,203.906 422.5,203C 423.973,202.29 424.64,201.124 424.5,199.5C 431.164,200.218 437.831,201.051 444.5,202C 458.695,207.675 473.029,212.842 487.5,217.5C 489.032,212.903 490.365,208.237 491.5,203.5C 492.738,199.381 493.571,195.047 494,190.5C 494.5,176.504 494.667,162.504 494.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 154.5,150.5 C 157.096,151.265 159.763,151.599 162.5,151.5C 161.551,152.152 160.385,152.486 159,152.5C 156.992,152.693 155.492,152.026 154.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#312241",
    d: "M 277.5,155.5 C 277.389,156.117 277.056,156.617 276.5,157C 279.036,157.186 281.369,157.686 283.5,158.5C 277.285,157.812 271.619,159.145 266.5,162.5C 266.158,161.662 265.492,161.328 264.5,161.5C 268.915,159.794 273.248,157.794 277.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b3642",
    d: "M 425.5,138.5 C 426.29,139.609 426.79,140.942 427,142.5C 427.232,141.263 427.732,140.263 428.5,139.5C 427.836,144.473 427.503,149.473 427.5,154.5C 426.669,167.66 426.169,180.994 426,194.5C 425.79,196.058 425.29,197.391 424.5,198.5C 425.439,178.523 425.772,158.523 425.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#151517",
    d: "M 283.5,158.5 C 285.579,158.971 287.579,159.637 289.5,160.5C 291.797,162.294 293.963,164.294 296,166.5C 302.253,181.909 298.086,193.575 283.5,201.5C 283.631,200.624 283.298,199.957 282.5,199.5C 281.158,201.005 279.492,201.672 277.5,201.5C 280.102,199.19 283.102,197.357 286.5,196C 289.722,193.044 292.056,189.544 293.5,185.5C 294.647,181.354 294.814,177.02 294,172.5C 293.623,171.058 292.79,170.058 291.5,169.5C 290.746,166.909 289.079,165.076 286.5,164C 284.655,162.872 282.655,162.372 280.5,162.5C 275.59,161.587 271.59,162.921 268.5,166.5C 266.167,166.833 264.833,168.167 264.5,170.5C 263.21,171.058 262.377,172.058 262,173.5C 261.192,177.027 261.359,180.36 262.5,183.5C 263.488,184.795 264.488,186.128 265.5,187.5C 265.611,188.117 265.944,188.617 266.5,189C 269.367,189.801 272.034,189.634 274.5,188.5C 281.657,185.599 283.323,180.766 279.5,174C 279.667,172.5 280.5,171.667 282,171.5C 283.882,172.093 284.882,173.427 285,175.5C 285.667,179.167 285.667,182.833 285,186.5C 284.617,187.056 284.117,187.389 283.5,187.5C 280.67,190.433 277.337,192.433 273.5,193.5C 266.982,194.608 262.315,192.275 259.5,186.5C 258.608,181.562 258.274,176.562 258.5,171.5C 259.167,170.167 259.833,168.833 260.5,167.5C 262.46,165.844 264.46,164.177 266.5,162.5C 271.619,159.145 277.285,157.812 283.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04d9d4",
    d: "M 145.5,161.5 C 148.748,171.371 154.415,179.371 162.5,185.5C 163.483,186.85 164.816,187.85 166.5,188.5C 166.137,189.183 165.804,189.85 165.5,190.5C 163.577,190.795 161.91,191.628 160.5,193C 158.167,193.667 155.833,193.667 153.5,193C 149.491,189.839 146.491,186.006 144.5,181.5C 144.065,178.843 143.065,176.509 141.5,174.5C 139.886,167.916 139.386,161.249 140,154.5C 141.666,156.996 143.5,159.329 145.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M 129.5,154.5 C 129.289,163.2 129.623,171.867 130.5,180.5C 128.735,177.877 128.068,174.877 128.5,171.5C 128.178,165.642 128.511,159.975 129.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f4467",
    d: "M 493.5,148.5 C 493.833,148.5 494.167,148.5 494.5,148.5C 494.667,162.504 494.5,176.504 494,190.5C 493.571,195.047 492.738,199.381 491.5,203.5C 493.249,185.221 493.915,166.888 493.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a8",
    d: "M 129.5,150.5 C 129.5,150.833 129.5,151.167 129.5,151.5C 129.5,152.5 129.5,153.5 129.5,154.5C 128.511,159.975 128.178,165.642 128.5,171.5C 127.835,168.686 127.502,165.686 127.5,162.5C 127.278,158.203 127.945,154.203 129.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d4f91",
    d: "M 244.5,167.5 C 240.154,167.334 235.821,167.501 231.5,168C 230.263,168.232 229.263,168.732 228.5,169.5C 217.43,174.029 206.43,178.862 195.5,184C 194.196,184.804 193.529,185.971 193.5,187.5C 193.964,190.349 194.631,193.016 195.5,195.5C 195.335,198.85 195.502,202.183 196,205.5C 196.852,206.571 197.685,207.571 198.5,208.5C 202.426,219.02 207.426,229.02 213.5,238.5C 209.181,241.996 204.515,244.996 199.5,247.5C 199.34,245.847 198.674,244.514 197.5,243.5C 196.586,239.064 194.919,235.064 192.5,231.5C 192.672,230.508 192.338,229.842 191.5,229.5C 191.59,226.848 190.924,224.515 189.5,222.5C 189.212,219.061 188.546,215.728 187.5,212.5C 187.044,206.939 186.044,201.606 184.5,196.5C 184.5,195.5 184.5,194.5 184.5,193.5C 184.802,190.941 184.468,188.607 183.5,186.5C 189.677,181.239 196.677,177.239 204.5,174.5C 210.844,173.16 216.511,170.493 221.5,166.5C 225.841,164.237 230.508,162.571 235.5,161.5C 238.991,163.094 242.658,163.761 246.5,163.5C 246.771,165.38 246.104,166.713 244.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#614581",
    d: "M 264.5,161.5 C 265.492,161.328 266.158,161.662 266.5,162.5C 264.46,164.177 262.46,165.844 260.5,167.5C 256.766,167.323 253.099,167.656 249.5,168.5C 250.117,166.771 251.117,165.271 252.5,164C 256.473,162.972 260.473,162.139 264.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c4479",
    d: "M 280.5,162.5 C 276.735,164.2 272.735,165.533 268.5,166.5C 271.59,162.921 275.59,161.587 280.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#826da2",
    d: "M 405.5,150.5 C 406.712,164.677 406.712,179.011 405.5,193.5C 405.167,193.5 404.833,193.5 404.5,193.5C 405.298,179.181 405.631,164.848 405.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb3bd",
    d: "M 280.5,162.5 C 282.655,162.372 284.655,162.872 286.5,164C 289.079,165.076 290.746,166.909 291.5,169.5C 292.969,174.716 293.635,180.05 293.5,185.5C 292.056,189.544 289.722,193.044 286.5,196C 283.102,197.357 280.102,199.19 277.5,201.5C 276.833,201.5 276.167,201.5 275.5,201.5C 270.012,201.752 264.678,201.085 259.5,199.5C 248.025,191.971 244.692,181.638 249.5,168.5C 253.099,167.656 256.766,167.323 260.5,167.5C 259.833,168.833 259.167,170.167 258.5,171.5C 257.352,175.981 257.185,180.648 258,185.5C 258.383,186.056 258.883,186.389 259.5,186.5C 262.315,192.275 266.982,194.608 273.5,193.5C 278.617,194.37 281.951,192.37 283.5,187.5C 284.117,187.389 284.617,187.056 285,186.5C 285.667,182.833 285.667,179.167 285,175.5C 284.882,173.427 283.882,172.093 282,171.5C 280.5,171.667 279.667,172.5 279.5,174C 283.323,180.766 281.657,185.599 274.5,188.5C 271.43,188.632 268.43,188.299 265.5,187.5C 264.488,186.128 263.488,184.795 262.5,183.5C 262.652,179.076 263.319,174.743 264.5,170.5C 264.833,168.167 266.167,166.833 268.5,166.5C 272.735,165.533 276.735,164.2 280.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747474",
    d: "M 594.5,163.5 C 596.027,163.427 597.027,164.094 597.5,165.5C 595.973,165.573 594.973,164.906 594.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4e4e",
    d: "M 597.5,165.5 C 601.684,165.851 605.684,166.518 609.5,167.5C 606.15,167.665 602.817,167.498 599.5,167C 598.584,166.722 597.918,166.222 597.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#958db0",
    d: "M 244.5,167.5 C 244.5,167.833 244.5,168.167 244.5,168.5C 244.167,168.5 243.833,168.5 243.5,168.5C 238.463,168.413 233.463,168.746 228.5,169.5C 229.263,168.732 230.263,168.232 231.5,168C 235.821,167.501 240.154,167.334 244.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bac4",
    d: "M 243.5,168.5 C 243.167,171.167 242.833,173.833 242.5,176.5C 241.504,189.99 241.171,203.656 241.5,217.5C 246.289,217.346 250.622,216.013 254.5,213.5C 256.288,213.215 257.955,213.548 259.5,214.5C 259.137,215.183 258.804,215.85 258.5,216.5C 258.158,217.338 257.492,217.672 256.5,217.5C 254.152,217.592 252.486,218.592 251.5,220.5C 250.833,220.5 250.167,220.5 249.5,220.5C 247.033,220.755 245.033,221.755 243.5,223.5C 233.19,227.988 223.19,232.988 213.5,238.5C 207.426,229.02 202.426,219.02 198.5,208.5C 197.943,203.948 196.943,199.615 195.5,195.5C 194.631,193.016 193.964,190.349 193.5,187.5C 193.529,185.971 194.196,184.804 195.5,184C 206.43,178.862 217.43,174.029 228.5,169.5C 233.463,168.746 238.463,168.413 243.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898989",
    d: "M 611.5,167.5 C 613.027,167.427 614.027,168.094 614.5,169.5C 612.973,169.573 611.973,168.906 611.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#523a6d",
    d: "M 221.5,166.5 C 216.511,170.493 210.844,173.16 204.5,174.5C 209.735,171.051 215.402,168.384 221.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 614.5,169.5 C 615.496,169.414 616.329,169.748 617,170.5C 617.901,175.281 616.734,179.281 613.5,182.5C 614.692,179.592 615.692,176.592 616.5,173.5C 616.248,171.927 615.582,170.594 614.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#083b3a",
    d: "M 141.5,174.5 C 143.065,176.509 144.065,178.843 144.5,181.5C 142.166,179.824 141.166,177.491 141.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3f43",
    d: "M 258.5,171.5 C 258.274,176.562 258.608,181.562 259.5,186.5C 258.883,186.389 258.383,186.056 258,185.5C 257.185,180.648 257.352,175.981 258.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6f75",
    d: "M 264.5,170.5 C 263.319,174.743 262.652,179.076 262.5,183.5C 261.359,180.36 261.192,177.027 262,173.5C 262.377,172.058 263.21,171.058 264.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323437",
    d: "M 243.5,168.5 C 243.833,168.5 244.167,168.5 244.5,168.5C 243.97,177.654 243.637,186.82 243.5,196C 243.503,202.869 244.17,209.369 245.5,215.5C 244.791,216.404 243.791,216.737 242.5,216.5C 242.5,203.167 242.5,189.833 242.5,176.5C 242.833,173.833 243.167,171.167 243.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a8188",
    d: "M 291.5,169.5 C 292.79,170.058 293.623,171.058 294,172.5C 294.814,177.02 294.647,181.354 293.5,185.5C 293.635,180.05 292.969,174.716 291.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#332a59",
    d: "M 547.5,167.5 C 545.076,167.192 542.743,167.526 540.5,168.5C 537.225,174.446 538.225,179.613 543.5,184C 558.082,185.403 572.082,183.236 585.5,177.5C 588.879,177.888 592.212,178.555 595.5,179.5C 594.479,181.188 593.145,182.521 591.5,183.5C 591.265,182.903 590.765,182.57 590,182.5C 581.228,186.421 572.062,188.754 562.5,189.5C 553.818,189.479 545.152,189.146 536.5,188.5C 533.959,187.897 531.626,187.897 529.5,188.5C 527.431,186.902 526.431,184.735 526.5,182C 527.125,178.456 527.959,174.956 529,171.5C 534.691,167.083 540.858,165.75 547.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575757",
    d: "M 130.5,182.5 C 132.245,184.033 133.245,186.033 133.5,188.5C 131.755,186.967 130.755,184.967 130.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3b9",
    d: "M 397.5,128.5 C 399.167,128.5 400.833,128.5 402.5,128.5C 404.372,135.668 405.372,143.001 405.5,150.5C 405.631,164.848 405.298,179.181 404.5,193.5C 403.5,193.5 402.5,193.5 401.5,193.5C 402.648,179.575 402.814,165.575 402,151.5C 401.231,143.663 399.731,135.996 397.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b4b4",
    d: "M 613.5,182.5 C 612.5,185.5 610.5,187.5 607.5,188.5C 609.167,186.167 611.167,184.167 613.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a3b3",
    d: "M 591.5,183.5 C 587.881,187.109 583.548,189.443 578.5,190.5C 579.643,188.899 578.976,188.233 576.5,188.5C 571.992,190.113 567.326,190.779 562.5,190.5C 562.5,190.167 562.5,189.833 562.5,189.5C 572.062,188.754 581.228,186.421 590,182.5C 590.765,182.57 591.265,182.903 591.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b4344",
    d: "M 162.5,185.5 C 164.117,186.038 165.784,186.371 167.5,186.5C 167.843,188.483 167.176,189.817 165.5,190.5C 165.804,189.85 166.137,189.183 166.5,188.5C 164.816,187.85 163.483,186.85 162.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62676d",
    d: "M 265.5,187.5 C 268.43,188.299 271.43,188.632 274.5,188.5C 272.034,189.634 269.367,189.801 266.5,189C 265.944,188.617 265.611,188.117 265.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b1b9",
    d: "M 536.5,188.5 C 536.5,188.833 536.5,189.167 536.5,189.5C 532.36,188.956 531.693,189.956 534.5,192.5C 532.251,191.92 530.585,190.587 529.5,188.5C 531.626,187.897 533.959,187.897 536.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d547c",
    d: "M 536.5,189.5 C 536.5,189.167 536.5,188.833 536.5,188.5C 545.152,189.146 553.818,189.479 562.5,189.5C 562.5,189.833 562.5,190.167 562.5,190.5C 553.809,190.632 545.142,190.299 536.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M 607.5,188.5 C 606.738,190.262 605.404,191.262 603.5,191.5C 604.262,189.738 605.596,188.738 607.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#07e0dd",
    d: "M 184.5,193.5 C 184.5,194.5 184.5,195.5 184.5,196.5C 184.227,202.216 185.227,207.549 187.5,212.5C 188.546,215.728 189.212,219.061 189.5,222.5C 189.41,225.152 190.076,227.485 191.5,229.5C 192.338,229.842 192.672,230.508 192.5,231.5C 193.414,235.936 195.081,239.936 197.5,243.5C 197.5,245.5 197.5,247.5 197.5,249.5C 196.833,250.5 196.167,251.5 195.5,252.5C 194.325,252.719 193.325,252.386 192.5,251.5C 191.14,248.78 189.807,246.114 188.5,243.5C 188.573,241.973 187.906,240.973 186.5,240.5C 186.5,239.833 186.5,239.167 186.5,238.5C 186.573,236.973 185.906,235.973 184.5,235.5C 183.302,231.02 181.969,226.687 180.5,222.5C 179.77,215.345 179.103,208.178 178.5,201C 178.667,198.167 178.833,195.333 179,192.5C 180.481,191.529 181.315,190.196 181.5,188.5C 182.117,188.389 182.617,188.056 183,187.5C 183.191,189.708 183.691,191.708 184.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b86a8",
    d: "M 183.5,186.5 C 184.468,188.607 184.802,190.941 184.5,193.5C 183.691,191.708 183.191,189.708 183,187.5C 182.617,188.056 182.117,188.389 181.5,188.5C 181.5,187.167 182.167,186.5 183.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaec",
    d: "M 578.5,190.5 C 576.374,191.048 574.374,191.715 572.5,192.5C 567.876,192.763 563.542,193.763 559.5,195.5C 554.167,195.5 548.833,195.5 543.5,195.5C 540.855,193.69 537.855,192.69 534.5,192.5C 531.693,189.956 532.36,188.956 536.5,189.5C 545.142,190.299 553.809,190.632 562.5,190.5C 567.326,190.779 571.992,190.113 576.5,188.5C 578.976,188.233 579.643,188.899 578.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e848b",
    d: "M 283.5,187.5 C 281.951,192.37 278.617,194.37 273.5,193.5C 277.337,192.433 280.67,190.433 283.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M 603.5,191.5 C 603.027,192.906 602.027,193.573 600.5,193.5C 600.973,192.094 601.973,191.427 603.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424649",
    d: "M 398.5,192.5 C 398.5,192.833 398.5,193.167 398.5,193.5C 378.45,193.077 358.45,193.743 338.5,195.5C 342.335,194.539 346.335,193.705 350.5,193C 366.497,192.5 382.497,192.333 398.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888888",
    d: "M 534.5,192.5 C 537.855,192.69 540.855,193.69 543.5,195.5C 540.084,195.472 537.084,194.472 534.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 135.5,193.5 C 136.906,193.973 137.573,194.973 137.5,196.5C 136.094,196.027 135.427,195.027 135.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5e5e",
    d: "M 572.5,192.5 C 572.082,193.222 571.416,193.722 570.5,194C 566.83,194.548 563.163,195.048 559.5,195.5C 563.542,193.763 567.876,192.763 572.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 600.5,193.5 C 600.027,194.906 599.027,195.573 597.5,195.5C 597.973,194.094 598.973,193.427 600.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f5357",
    d: "M 337.5,195.5 C 334.373,196.581 331.04,197.247 327.5,197.5C 327.918,196.778 328.584,196.278 329.5,196C 332.146,195.503 334.813,195.336 337.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686d73",
    d: "M 317.5,198.5 C 316.5,199.167 315.5,199.833 314.5,200.5C 313.167,200.5 311.833,200.5 310.5,200.5C 312.515,199.076 314.848,198.41 317.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9b1ba",
    d: "M 248.5,196.5 C 251.233,199.239 254.233,201.573 257.5,203.5C 258.6,204.558 259.934,205.392 261.5,206C 258.125,208.181 254.458,209.681 250.5,210.5C 249.5,210.5 248.5,210.5 247.5,210.5C 247.181,205.637 247.514,200.97 248.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfbfbf",
    d: "M 597.5,195.5 C 597.063,197.074 596.063,198.241 594.5,199C 591.94,199.384 589.606,200.217 587.5,201.5C 587.833,200.833 588.167,200.167 588.5,199.5C 591.314,197.93 594.314,196.597 597.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52575b",
    d: "M 259.5,199.5 C 264.678,201.085 270.012,201.752 275.5,201.5C 271.689,202.645 267.689,202.812 263.5,202C 261.934,201.392 260.6,200.558 259.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e3032",
    d: "M 310.5,200.5 C 311.833,200.5 313.167,200.5 314.5,200.5C 310.79,202.136 306.79,202.802 302.5,202.5C 304.905,201.232 307.572,200.565 310.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#211a3e",
    d: "M 424.5,198.5 C 424.5,198.833 424.5,199.167 424.5,199.5C 424.64,201.124 423.973,202.29 422.5,203C 428.141,203.906 433.474,205.406 438.5,207.5C 415.044,203.117 391.378,201.451 367.5,202.5C 381.661,201.669 395.994,201.169 410.5,201C 390.528,199.634 370.528,199.134 350.5,199.5C 358.612,197.989 366.946,197.322 375.5,197.5C 391.586,197.88 407.586,199.213 423.5,201.5C 423.263,200.209 423.596,199.209 424.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 588.5,199.5 C 588.167,200.167 587.833,200.833 587.5,201.5C 584.779,201.963 582.112,202.629 579.5,203.5C 582.053,201.416 585.053,200.083 588.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e1737",
    d: "M 519.5,187.5 C 520.719,193.357 520.719,199.357 519.5,205.5C 514.881,204.686 510.214,204.353 505.5,204.5C 509.684,203.834 514.018,203.167 518.5,202.5C 519.448,197.565 519.781,192.565 519.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d9ebd",
    d: "M 184.5,196.5 C 186.044,201.606 187.044,206.939 187.5,212.5C 185.227,207.549 184.227,202.216 184.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8572a4",
    d: "M 195.5,195.5 C 196.943,199.615 197.943,203.948 198.5,208.5C 197.685,207.571 196.852,206.571 196,205.5C 195.502,202.183 195.335,198.85 195.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 145.5,203.5 C 147.027,203.427 148.027,204.094 148.5,205.5C 146.973,205.573 145.973,204.906 145.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52565b",
    d: "M 281.5,203.5 C 281.167,204.167 280.833,204.833 280.5,205.5C 276.777,206.297 273.11,207.297 269.5,208.5C 273.064,206.081 277.064,204.414 281.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414448",
    d: "M 302.5,202.5 C 298.498,204.61 294.165,205.943 289.5,206.5C 293.502,204.39 297.835,203.057 302.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b214f",
    d: "M 547.5,212.5 C 545.219,212.077 543.552,212.744 542.5,214.5C 540.037,212.539 537.703,210.372 535.5,208C 533.26,207.023 530.927,206.523 528.5,206.5C 528.5,205.167 528.5,203.833 528.5,202.5C 534.348,204.068 540.348,204.902 546.5,205C 547.435,207.381 547.768,209.881 547.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b7b7b",
    d: "M 576.5,204.5 C 575.07,205.537 573.403,206.204 571.5,206.5C 570.167,206.5 568.833,206.5 567.5,206.5C 570.273,205.343 573.273,204.676 576.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a214e",
    d: "M 350.5,199.5 C 370.528,199.134 390.528,199.634 410.5,201C 395.994,201.169 381.661,201.669 367.5,202.5C 312.994,206.835 261.66,222.001 213.5,248C 207.326,252.022 201.326,256.189 195.5,260.5C 194.094,260.027 193.427,259.027 193.5,257.5C 216.418,240.704 241.418,227.538 268.5,218C 295.061,208.359 322.395,202.193 350.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a8b1",
    d: "M 280.5,205.5 C 281.919,206.451 283.585,206.784 285.5,206.5C 276.729,210.204 267.729,213.538 258.5,216.5C 258.804,215.85 259.137,215.183 259.5,214.5C 257.955,213.548 256.288,213.215 254.5,213.5C 254.5,213.167 254.5,212.833 254.5,212.5C 259.457,211.011 264.457,209.677 269.5,208.5C 273.11,207.297 276.777,206.297 280.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c2c2",
    d: "M 567.5,206.5 C 568.833,206.5 570.167,206.5 571.5,206.5C 567.764,207.989 563.764,208.656 559.5,208.5C 559.5,209.5 559.5,210.5 559.5,211.5C 558.566,210.432 558.232,209.099 558.5,207.5C 561.518,207.296 564.518,206.963 567.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00b2ae",
    d: "M 173.5,207.5 C 172.515,211.634 172.182,215.968 172.5,220.5C 171.18,212.99 171.18,205.323 172.5,197.5C 173.487,200.768 173.82,204.102 173.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777d84",
    d: "M 248.5,195.5 C 248.5,195.833 248.5,196.167 248.5,196.5C 247.514,200.97 247.181,205.637 247.5,210.5C 248.5,210.5 249.5,210.5 250.5,210.5C 249.432,211.434 248.099,211.768 246.5,211.5C 245.887,205.729 246.554,200.396 248.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#925376",
    d: "M 435.5,212.5 C 444.611,214.361 453.611,216.695 462.5,219.5C 464.217,223.997 464.884,228.663 464.5,233.5C 446.204,228.676 427.871,224.009 409.5,219.5C 409.167,219.5 408.833,219.5 408.5,219.5C 406.833,215.833 404.167,213.167 400.5,211.5C 398.973,211.573 397.973,210.906 397.5,209.5C 401.646,208.353 405.98,208.186 410.5,209C 418.837,210.215 427.17,211.382 435.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c2231",
    d: "M 435.5,212.5 C 427.17,211.382 418.837,210.215 410.5,209C 405.98,208.186 401.646,208.353 397.5,209.5C 396.624,209.631 395.957,209.298 395.5,208.5C 402.142,207.336 408.808,207.169 415.5,208C 422.37,209.185 429.037,210.685 435.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202123",
    d: "M 248.5,195.5 C 246.554,200.396 245.887,205.729 246.5,211.5C 248.099,211.768 249.432,211.434 250.5,210.5C 254.458,209.681 258.125,208.181 261.5,206C 259.934,205.392 258.6,204.558 257.5,203.5C 260.056,203.132 262.056,203.966 263.5,206C 263.355,206.772 263.022,207.439 262.5,208C 259.5,209 256.5,210 253.5,211C 254.056,211.383 254.389,211.883 254.5,212.5C 254.5,212.833 254.5,213.167 254.5,213.5C 251.673,213.584 249.006,214.25 246.5,215.5C 247.895,214.352 247.728,213.352 246,212.5C 245.501,206.509 245.334,200.509 245.5,194.5C 246.791,194.263 247.791,194.596 248.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f354d",
    d: "M 400.5,211.5 C 404.167,213.167 406.833,215.833 408.5,219.5C 405.5,217.167 402.833,214.5 400.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#312756",
    d: "M 542.5,220.5 C 543.3,222.573 544.633,224.24 546.5,225.5C 542.958,225.62 539.458,225.286 536,224.5C 534.624,224.684 533.791,225.351 533.5,226.5C 531.712,220.678 529.379,215.011 526.5,209.5C 532.702,210.858 537.368,214.358 540.5,220C 541.094,220.464 541.761,220.631 542.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c705a",
    d: "M 513.5,212.5 C 510.763,212.401 508.096,212.735 505.5,213.5C 506.492,211.974 507.992,211.307 510,211.5C 511.385,211.514 512.551,211.848 513.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#007673",
    d: "M 181.5,188.5 C 181.315,190.196 180.481,191.529 179,192.5C 178.833,195.333 178.667,198.167 178.5,201C 179.103,208.178 179.77,215.345 180.5,222.5C 178.41,215.627 177.41,208.461 177.5,201C 177.667,197.833 177.833,194.667 178,191.5C 179.039,190.29 180.206,189.29 181.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eabb97",
    d: "M 513.5,212.5 C 514.833,212.833 516.167,213.167 517.5,213.5C 517.611,214.117 517.944,214.617 518.5,215C 515.635,215.183 512.969,215.683 510.5,216.5C 509.833,216.5 509.167,216.5 508.5,216.5C 502.536,218.589 501.536,217.589 505.5,213.5C 508.096,212.735 510.763,212.401 513.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b5d71",
    d: "M 547.5,212.5 C 549.02,217.202 551.353,221.536 554.5,225.5C 551.833,225.5 549.167,225.5 546.5,225.5C 544.633,224.24 543.3,222.573 542.5,220.5C 542.5,218.5 542.5,216.5 542.5,214.5C 543.552,212.744 545.219,212.077 547.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00dfda",
    d: "M 173.5,207.5 C 173.993,209.806 174.326,212.139 174.5,214.5C 174.259,216.898 174.926,218.898 176.5,220.5C 176.5,221.167 176.5,221.833 176.5,222.5C 176.662,224.527 176.495,226.527 176,228.5C 175.098,226.569 173.931,224.903 172.5,223.5C 172.5,222.5 172.5,221.5 172.5,220.5C 172.182,215.968 172.515,211.634 173.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e4262",
    d: "M 313.5,225.5 C 312.797,223.284 311.464,221.451 309.5,220C 309.833,219.667 310.167,219.333 310.5,219C 306.812,218.55 303.146,218.717 299.5,219.5C 309.294,216.385 319.294,213.885 329.5,212C 331.833,211.333 334.167,211.333 336.5,212C 328.268,215.483 320.601,219.983 313.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81888f",
    d: "M 242.5,176.5 C 242.5,189.833 242.5,203.167 242.5,216.5C 243.791,216.737 244.791,216.404 245.5,215.5C 245.833,215.5 246.167,215.5 246.5,215.5C 249.006,214.25 251.673,213.584 254.5,213.5C 250.622,216.013 246.289,217.346 241.5,217.5C 241.171,203.656 241.504,189.99 242.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#967962",
    d: "M 517.5,213.5 C 521.535,215.206 524.202,218.206 525.5,222.5C 524.604,221.494 523.938,221.494 523.5,222.5C 520.634,217.57 516.301,215.57 510.5,216.5C 512.969,215.683 515.635,215.183 518.5,215C 517.944,214.617 517.611,214.117 517.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c5054",
    d: "M 256.5,217.5 C 255.341,219.25 253.674,220.25 251.5,220.5C 252.486,218.592 254.152,217.592 256.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be9080",
    d: "M 505.5,213.5 C 501.536,217.589 502.536,218.589 508.5,216.5C 507.833,217.167 507.167,217.833 506.5,218.5C 503.579,218.146 501.246,219.146 499.5,221.5C 498.702,221.043 498.369,220.376 498.5,219.5C 500.239,216.757 502.573,214.757 505.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#006967",
    d: "M 174.5,214.5 C 176.074,216.102 176.741,218.102 176.5,220.5C 174.926,218.898 174.259,216.898 174.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 627.5,221.5 C 620.351,221.05 613.351,221.716 606.5,223.5C 607.347,222.034 608.68,221.2 610.5,221C 616.349,220.182 622.015,220.348 627.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535353",
    d: "M 157.5,219.5 C 159.28,220.99 159.946,222.99 159.5,225.5C 158.542,223.698 157.875,221.698 157.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#462334",
    d: "M 295.5,220.5 C 293.064,221.871 290.397,222.871 287.5,223.5C 289.617,221.345 292.284,220.345 295.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5e64",
    d: "M 249.5,220.5 C 247.967,222.245 245.967,223.245 243.5,223.5C 245.033,221.755 247.033,220.755 249.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90486b",
    d: "M 313.5,225.5 C 312.289,227.563 313.123,228.563 316,228.5C 329.381,225.963 342.881,224.963 356.5,225.5C 355.07,226.537 353.403,227.204 351.5,227.5C 346.393,228.551 342.059,230.885 338.5,234.5C 337.279,235.028 336.113,235.695 335,236.5C 333.306,238.24 332.139,240.24 331.5,242.5C 323.998,250.904 320.998,260.904 322.5,272.5C 321.21,271.942 320.377,270.942 320,269.5C 318.12,262.221 316.453,254.888 315,247.5C 311.442,242.306 306.609,238.972 300.5,237.5C 290.955,235.249 282.288,237.249 274.5,243.5C 268.498,242.395 262.498,242.561 256.5,244C 255.748,244.671 255.414,245.504 255.5,246.5C 247.171,245.413 238.838,245.246 230.5,246C 248.376,235.87 267.376,228.37 287.5,223.5C 290.397,222.871 293.064,221.871 295.5,220.5C 296.568,219.566 297.901,219.232 299.5,219.5C 303.146,218.717 306.812,218.55 310.5,219C 310.167,219.333 309.833,219.667 309.5,220C 311.464,221.451 312.797,223.284 313.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 605.5,223.5 C 603.157,224.344 600.824,225.344 598.5,226.5C 600.036,223.908 602.369,222.908 605.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#30afc6",
    d: "M 189.5,222.5 C 190.924,224.515 191.59,226.848 191.5,229.5C 190.076,227.485 189.41,225.152 189.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e4e6",
    d: "M 546.5,225.5 C 549.167,225.5 551.833,225.5 554.5,225.5C 555.141,226.482 555.807,227.482 556.5,228.5C 550.795,231.836 544.795,232.336 538.5,230C 536.416,229.303 534.749,228.136 533.5,226.5C 533.791,225.351 534.624,224.684 536,224.5C 539.458,225.286 542.958,225.62 546.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#904d6f",
    d: "M 506.5,218.5 C 505.207,220.296 503.707,221.963 502,223.5C 501.179,226.554 501.345,229.554 502.5,232.5C 502.991,226.68 505.658,222.18 510.5,219C 512.5,218.333 514.5,218.333 516.5,219C 521.352,223.41 522.852,228.91 521,235.5C 517.295,244.01 516.128,252.677 517.5,261.5C 517.5,262.167 517.5,262.833 517.5,263.5C 516.518,266.962 516.185,270.629 516.5,274.5C 513.336,281.567 509.169,282.233 504,276.5C 504.317,281.615 507.15,283.615 512.5,282.5C 507.61,284.024 502.776,283.691 498,281.5C 496.97,281.836 496.47,282.503 496.5,283.5C 495.427,284.251 495.26,285.251 496,286.5C 496.995,287.066 497.828,287.733 498.5,288.5C 497.223,289.694 496.556,291.36 496.5,293.5C 497.366,303.481 497.699,313.481 497.5,323.5C 489.623,319.223 481.623,315.556 473.5,312.5C 474.833,312.5 476.167,312.5 477.5,312.5C 478.718,301.038 479.384,289.538 479.5,278C 479.499,272.323 479.166,266.823 478.5,261.5C 479.045,259.407 479.878,257.407 481,255.5C 485.318,250.86 489.151,245.86 492.5,240.5C 493.524,241.853 494.857,242.52 496.5,242.5C 496.334,235.492 496.5,228.492 497,221.5C 497.278,220.584 497.778,219.918 498.5,219.5C 498.369,220.376 498.702,221.043 499.5,221.5C 501.246,219.146 503.579,218.146 506.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#140e0f",
    d: "M 354.5,228.5 C 374.007,226.221 390.34,232.221 403.5,246.5C 405.432,249.366 407.099,252.366 408.5,255.5C 408.54,258.881 408.207,262.214 407.5,265.5C 406.559,267.05 405.893,268.716 405.5,270.5C 403.413,271.585 402.08,273.251 401.5,275.5C 396.085,279.587 390.418,283.254 384.5,286.5C 381.843,286.935 379.509,287.935 377.5,289.5C 366.622,292.46 355.622,293.127 344.5,291.5C 341.855,289.69 338.855,288.69 335.5,288.5C 333.589,287.925 331.922,286.925 330.5,285.5C 327.443,283.046 325.109,280.046 323.5,276.5C 323.567,275.041 323.234,273.708 322.5,272.5C 320.998,260.904 323.998,250.904 331.5,242.5C 334.526,239.805 337.526,237.138 340.5,234.5C 344.986,231.9 349.652,229.9 354.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcab8d",
    d: "M 356.5,225.5 C 362.167,225.5 367.833,225.5 373.5,225.5C 381.44,226.907 389.107,229.407 396.5,233C 398.667,235.167 400.833,237.333 403,239.5C 403.497,241.81 403.663,244.143 403.5,246.5C 390.34,232.221 374.007,226.221 354.5,228.5C 353.209,228.737 352.209,228.404 351.5,227.5C 353.403,227.204 355.07,226.537 356.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a1b23",
    d: "M 479.5,250.5 C 479.665,247.482 479.498,244.482 479,241.5C 475.844,240.001 472.677,238.668 469.5,237.5C 469.5,241.5 469.5,245.5 469.5,249.5C 468.346,243.013 468.179,236.346 469,229.5C 470.333,227.167 472.333,226.167 475,226.5C 479.578,227.372 483.745,229.205 487.5,232C 488.549,235.146 488.383,238.312 487,241.5C 484.636,244.69 482.136,247.69 479.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c99282",
    d: "M 351.5,227.5 C 352.209,228.404 353.209,228.737 354.5,228.5C 349.652,229.9 344.986,231.9 340.5,234.5C 339.833,234.5 339.167,234.5 338.5,234.5C 342.059,230.885 346.393,228.551 351.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#935274",
    d: "M 373.5,225.5 C 385.878,226.042 397.878,228.376 409.5,232.5C 410.919,233.451 412.585,233.784 414.5,233.5C 414.316,239.231 413.65,244.898 412.5,250.5C 411.692,252.22 410.692,253.887 409.5,255.5C 409.167,255.5 408.833,255.5 408.5,255.5C 407.099,252.366 405.432,249.366 403.5,246.5C 403.663,244.143 403.497,241.81 403,239.5C 400.833,237.333 398.667,235.167 396.5,233C 389.107,229.407 381.44,226.907 373.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b3733",
    d: "M 413.5,226.5 C 415.534,228.655 415.867,230.988 414.5,233.5C 412.585,233.784 410.919,233.451 409.5,232.5C 411.288,232.785 412.955,232.452 414.5,231.5C 413.691,229.929 413.357,228.262 413.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#896c58",
    d: "M 525.5,223.5 C 527.019,226.526 527.685,229.859 527.5,233.5C 527.637,237.447 526.97,241.114 525.5,244.5C 526.779,237.495 526.779,230.495 525.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 567.5,222.5 C 568.978,222.238 570.311,222.571 571.5,223.5C 573.316,229.071 571.65,233.071 566.5,235.5C 567.458,234.038 568.624,232.705 570,231.5C 571.221,227.718 570.387,224.718 567.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f80ad",
    d: "M 192.5,231.5 C 194.919,235.064 196.586,239.064 197.5,243.5C 195.081,239.936 193.414,235.936 192.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#513862",
    d: "M 357.5,234.5 C 355.064,235.871 352.397,236.871 349.5,237.5C 351.617,235.345 354.284,234.345 357.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9769b8",
    d: "M 357.5,234.5 C 376.53,233.335 391.697,240.335 403,255.5C 403.49,256.793 403.657,258.127 403.5,259.5C 400.86,258.552 398.193,257.552 395.5,256.5C 393.609,252.959 390.609,250.959 386.5,250.5C 386.5,250.167 386.5,249.833 386.5,249.5C 379.944,242.739 371.944,240.239 362.5,242C 360.273,242.941 358.273,244.108 356.5,245.5C 353.5,246.5 351.5,248.5 350.5,251.5C 349.094,251.973 348.427,252.973 348.5,254.5C 347.778,254.918 347.278,255.584 347,256.5C 346.503,259.146 346.336,261.813 346.5,264.5C 339.729,267.786 337.229,273.119 339,280.5C 339.383,281.056 339.883,281.389 340.5,281.5C 342.652,283.985 345.319,285.651 348.5,286.5C 353.975,287.489 359.642,287.822 365.5,287.5C 358.167,288.833 350.833,288.833 343.5,287.5C 341.316,285.415 338.649,284.415 335.5,284.5C 331.796,282.789 329.796,279.789 329.5,275.5C 329.076,267.685 329.743,260.018 331.5,252.5C 335.189,244.665 341.189,239.665 349.5,237.5C 352.397,236.871 355.064,235.871 357.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#23181b",
    d: "M 508.5,216.5 C 509.167,216.5 509.833,216.5 510.5,216.5C 516.301,215.57 520.634,217.57 523.5,222.5C 523.5,227.833 523.5,233.167 523.5,238.5C 522.076,240.515 521.41,242.848 521.5,245.5C 519.801,250.634 518.468,255.968 517.5,261.5C 516.128,252.677 517.295,244.01 521,235.5C 522.852,228.91 521.352,223.41 516.5,219C 514.5,218.333 512.5,218.333 510.5,219C 505.658,222.18 502.991,226.68 502.5,232.5C 501.345,229.554 501.179,226.554 502,223.5C 503.707,221.963 505.207,220.296 506.5,218.5C 507.167,217.833 507.833,217.167 508.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 588.5,232.5 C 585.833,235.833 582.833,238.833 579.5,241.5C 581.5,237.5 584.5,234.5 588.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#766a55",
    d: "M 615.5,234.5 C 612.061,236.204 608.395,237.538 604.5,238.5C 607.626,236.01 611.292,234.677 615.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#f3dcb1",
    d: "M 615.5,234.5 C 617.5,234.5 619.5,234.5 621.5,234.5C 642.088,258.594 663.255,282.26 685,305.5C 692.094,314.684 699.427,323.684 707,332.5C 708.11,334.037 709.61,334.703 711.5,334.5C 711.5,353.167 711.5,371.833 711.5,390.5C 708.86,390.046 706.527,388.879 704.5,387C 696.091,378.818 687.758,370.651 679.5,362.5C 674.776,356.773 669.442,351.773 663.5,347.5C 653.563,337.062 643.396,326.728 633,316.5C 618.635,299.973 604.135,283.639 589.5,267.5C 588.92,265.251 587.587,263.585 585.5,262.5C 586.492,259.177 587.492,255.844 588.5,252.5C 590.587,251.415 591.92,249.749 592.5,247.5C 595.776,243.529 599.776,240.529 604.5,238.5C 608.395,237.538 612.061,236.204 615.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3bd9a",
    d: "M 409.5,219.5 C 427.871,224.009 446.204,228.676 464.5,233.5C 465.313,241.439 465.979,249.439 466.5,257.5C 466.607,259.379 466.107,259.712 465,258.5C 447.91,259.941 430.744,261.108 413.5,262C 412.333,262.5 411.5,263.333 411,264.5C 410.228,259.616 410.728,254.949 412.5,250.5C 413.65,244.898 414.316,239.231 414.5,233.5C 415.867,230.988 415.534,228.655 413.5,226.5C 412.139,224.15 410.806,221.816 409.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#925d83",
    d: "M 621.5,234.5 C 630.079,234.478 638.079,236.645 645.5,241C 666.119,265.741 686.619,290.575 707,315.5C 708.226,317.548 709.726,317.881 711.5,316.5C 711.5,322.5 711.5,328.5 711.5,334.5C 709.61,334.703 708.11,334.037 707,332.5C 699.427,323.684 692.094,314.684 685,305.5C 663.255,282.26 642.088,258.594 621.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505050",
    d: "M 648.5,232.5 C 651.243,234.239 653.243,236.573 654.5,239.5C 651.757,237.761 649.757,235.427 648.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#007977",
    d: "M 184.5,235.5 C 185.906,235.973 186.573,236.973 186.5,238.5C 185.094,238.027 184.427,237.027 184.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4b091",
    d: "M 300.5,237.5 C 306.609,238.972 311.442,242.306 315,247.5C 316.453,254.888 318.12,262.221 320,269.5C 320.377,270.942 321.21,271.942 322.5,272.5C 323.234,273.708 323.567,275.041 323.5,276.5C 324.578,279.402 325.244,282.402 325.5,285.5C 327.167,285.5 328.833,285.5 330.5,285.5C 331.922,286.925 333.589,287.925 335.5,288.5C 338.084,290.472 341.084,291.472 344.5,291.5C 355.622,293.127 366.622,292.46 377.5,289.5C 380.491,289.834 382.824,288.834 384.5,286.5C 390.418,283.254 396.085,279.587 401.5,275.5C 401.833,275.5 402.167,275.5 402.5,275.5C 401.71,276.794 400.71,277.961 399.5,279C 400.056,279.383 400.389,279.883 400.5,280.5C 396.494,283.934 392.328,287.268 388,290.5C 387.316,291.784 387.483,292.951 388.5,294C 403.833,294.667 419.167,294.667 434.5,294C 436.193,293.153 437.86,292.32 439.5,291.5C 442.917,289.109 444.25,285.775 443.5,281.5C 455.404,281.008 467.071,282.008 478.5,284.5C 478.5,279.833 478.5,275.167 478.5,270.5C 476.901,270.768 475.568,270.434 474.5,269.5C 475.5,269.5 476.5,269.5 477.5,269.5C 477.401,266.763 477.735,264.096 478.5,261.5C 479.166,266.823 479.499,272.323 479.5,278C 479.384,289.538 478.718,301.038 477.5,312.5C 476.167,312.5 474.833,312.5 473.5,312.5C 465.424,309.541 457.09,307.541 448.5,306.5C 445.155,304.783 441.489,304.116 437.5,304.5C 415.224,302.199 392.891,301.866 370.5,303.5C 354.151,303.683 337.818,303.35 321.5,302.5C 317.262,300.044 312.596,299.044 307.5,299.5C 309.644,293.473 311.311,287.306 312.5,281C 312.017,277.538 310.85,277.038 309,279.5C 308.667,273.833 308.333,268.167 308,262.5C 306.853,261.542 305.853,261.875 305,263.5C 304.131,255.094 300.631,248.094 294.5,242.5C 293.667,243.5 292.833,244.5 292,245.5C 290.167,243.667 288.333,241.833 286.5,240C 290.813,237.706 295.48,236.873 300.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#261a1c",
    d: "M 510.5,251.5 C 510.665,248.15 510.498,244.817 510,241.5C 509.617,240.944 509.117,240.611 508.5,240.5C 506.236,239.781 503.903,239.448 501.5,239.5C 501.685,237.11 503.018,236.11 505.5,236.5C 510.739,237.567 513.072,240.734 512.5,246C 512.453,248.295 511.787,250.129 510.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6a98c",
    d: "M 300.5,237.5 C 295.48,236.873 290.813,237.706 286.5,240C 288.333,241.833 290.167,243.667 292,245.5C 292.833,244.5 293.667,243.5 294.5,242.5C 300.631,248.094 304.131,255.094 305,263.5C 305.853,261.875 306.853,261.542 308,262.5C 308.333,268.167 308.667,273.833 309,279.5C 310.85,277.038 312.017,277.538 312.5,281C 311.311,287.306 309.644,293.473 307.5,299.5C 312.596,299.044 317.262,300.044 321.5,302.5C 314.657,301.941 307.824,301.275 301,300.5C 295.218,300.159 289.718,301.159 284.5,303.5C 284.444,295.024 284.277,286.357 284,277.5C 283.34,274.322 282.507,271.322 281.5,268.5C 280.87,266.25 279.87,264.25 278.5,262.5C 276.975,258.635 274.642,255.302 271.5,252.5C 271.129,248.997 272.129,245.997 274.5,243.5C 282.288,237.249 290.955,235.249 300.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#654732",
    d: "M 479.5,250.5 C 477.244,254.011 475.244,257.678 473.5,261.5C 470.392,258.177 469.059,254.177 469.5,249.5C 469.5,245.5 469.5,241.5 469.5,237.5C 472.677,238.668 475.844,240.001 479,241.5C 479.498,244.482 479.665,247.482 479.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#006461",
    d: "M 176.5,235.5 C 178.245,237.033 179.245,239.033 179.5,241.5C 177.755,239.967 176.755,237.967 176.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d5f5c",
    d: "M 338.5,234.5 C 339.167,234.5 339.833,234.5 340.5,234.5C 337.526,237.138 334.526,239.805 331.5,242.5C 332.139,240.24 333.306,238.24 335,236.5C 336.113,235.695 337.279,235.028 338.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7a989",
    d: "M 525.5,222.5 C 525.5,222.833 525.5,223.167 525.5,223.5C 526.779,230.495 526.779,237.495 525.5,244.5C 524.699,246.042 524.366,247.708 524.5,249.5C 523.5,249.833 522.833,250.5 522.5,251.5C 521.539,249.735 521.205,247.735 521.5,245.5C 522.924,243.485 523.59,241.152 523.5,238.5C 523.5,233.167 523.5,227.833 523.5,222.5C 523.938,221.494 524.604,221.494 525.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 547.5,241.5 C 544.038,242.482 540.371,242.815 536.5,242.5C 536.405,244.786 535.738,246.786 534.5,248.5C 534.674,246.139 535.007,243.806 535.5,241.5C 539.5,241.5 543.5,241.5 547.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#005e5c",
    d: "M 182.5,240.5 C 183.906,240.973 184.573,241.973 184.5,243.5C 183.094,243.027 182.427,242.027 182.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a1e1d",
    d: "M 176.5,220.5 C 178.255,222.761 179.422,225.428 180,228.5C 180.495,226.527 180.662,224.527 180.5,222.5C 181.969,226.687 183.302,231.02 184.5,235.5C 184.427,237.027 185.094,238.027 186.5,238.5C 186.5,239.167 186.5,239.833 186.5,240.5C 186.427,242.027 187.094,243.027 188.5,243.5C 189.807,246.114 191.14,248.78 192.5,251.5C 193.325,252.386 194.325,252.719 195.5,252.5C 194.745,254.466 193.579,254.8 192,253.5C 191.536,254.094 191.369,254.761 191.5,255.5C 188.677,251.864 186.344,247.864 184.5,243.5C 184.573,241.973 183.906,240.973 182.5,240.5C 180.184,234.553 178.184,228.553 176.5,222.5C 176.5,221.833 176.5,221.167 176.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#006f6d",
    d: "M 186.5,240.5 C 187.906,240.973 188.573,241.973 188.5,243.5C 187.094,243.027 186.427,242.027 186.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d070c",
    d: "M 386.5,249.5 C 383.772,249.171 381.438,249.837 379.5,251.5C 379.167,251.5 378.833,251.5 378.5,251.5C 376.286,248.148 373.119,246.815 369,247.5C 355.803,249.195 350.636,256.528 353.5,269.5C 353.5,271.5 353.5,273.5 353.5,275.5C 353.5,276.833 352.833,277.5 351.5,277.5C 349.787,274.706 348.454,271.706 347.5,268.5C 347.437,263.797 347.771,259.13 348.5,254.5C 348.427,252.973 349.094,251.973 350.5,251.5C 352.833,249.833 354.833,247.833 356.5,245.5C 358.273,244.108 360.273,242.941 362.5,242C 371.944,240.239 379.944,242.739 386.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90715c",
    d: "M 523.5,238.5 C 523.59,241.152 522.924,243.485 521.5,245.5C 521.41,242.848 522.076,240.515 523.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00beba",
    d: "M 176.5,222.5 C 178.184,228.553 180.184,234.553 182.5,240.5C 182.427,242.027 183.094,243.027 184.5,243.5C 186.344,247.864 188.677,251.864 191.5,255.5C 191.833,256.5 192.5,257.167 193.5,257.5C 193.427,259.027 194.094,260.027 195.5,260.5C 195.169,262.322 194.502,263.989 193.5,265.5C 192.5,265.5 191.5,265.5 190.5,265.5C 190.737,264.209 190.404,263.209 189.5,262.5C 185.896,255.626 182.563,248.626 179.5,241.5C 179.245,239.033 178.245,237.033 176.5,235.5C 174.604,231.703 173.271,227.703 172.5,223.5C 173.931,224.903 175.098,226.569 176,228.5C 176.495,226.527 176.662,224.527 176.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0ab90",
    d: "M 501.5,239.5 C 503.903,239.448 506.236,239.781 508.5,240.5C 508.995,242.452 509.328,244.452 509.5,246.5C 509.415,248.333 508.748,249.666 507.5,250.5C 506.833,250.5 506.5,250.167 506.5,249.5C 506.5,247.167 506.5,244.833 506.5,242.5C 504.067,242.727 502.401,241.727 501.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 577.5,243.5 C 577.573,245.027 576.906,246.027 575.5,246.5C 575.427,244.973 576.094,243.973 577.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37a4bc",
    d: "M 197.5,243.5 C 198.674,244.514 199.34,245.847 199.5,247.5C 199.167,248.5 198.5,249.167 197.5,249.5C 197.5,247.5 197.5,245.5 197.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c6d58",
    d: "M 508.5,240.5 C 509.117,240.611 509.617,240.944 510,241.5C 510.498,244.817 510.665,248.15 510.5,251.5C 510.158,252.338 509.492,252.672 508.5,252.5C 508.167,251.833 507.833,251.167 507.5,250.5C 508.748,249.666 509.415,248.333 509.5,246.5C 509.328,244.452 508.995,242.452 508.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 163.5,242.5 C 165.4,245.518 166.733,248.851 167.5,252.5C 165.103,249.691 163.77,246.358 163.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 575.5,246.5 C 575.573,248.027 574.906,249.027 573.5,249.5C 573.427,247.973 574.094,246.973 575.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#918469",
    d: "M 592.5,247.5 C 591.92,249.749 590.587,251.415 588.5,252.5C 589.08,250.251 590.413,248.585 592.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a2847",
    d: "M 356.5,245.5 C 354.833,247.833 352.833,249.833 350.5,251.5C 351.5,248.5 353.5,246.5 356.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#730e1a",
    d: "M 378.5,251.5 C 377.075,252.922 376.075,254.589 375.5,256.5C 374.883,256.611 374.383,256.944 374,257.5C 369.164,252.935 365.498,253.601 363,259.5C 362.503,262.146 362.336,264.813 362.5,267.5C 361.837,265.958 361.17,264.291 360.5,262.5C 357.528,263.63 355.528,265.63 354.5,268.5C 354.5,268.833 354.5,269.167 354.5,269.5C 354.167,269.5 353.833,269.5 353.5,269.5C 350.636,256.528 355.803,249.195 369,247.5C 373.119,246.815 376.286,248.148 378.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d4264",
    d: "M 274.5,243.5 C 272.129,245.997 271.129,248.997 271.5,252.5C 268.387,250.195 264.887,248.529 261,247.5C 260.5,247.833 260,248.167 259.5,248.5C 261.607,251.061 264.274,252.894 267.5,254C 271.416,257.41 274.749,261.243 277.5,265.5C 278.148,267.086 278.648,268.753 279,270.5C 279.671,271.252 280.504,271.586 281.5,271.5C 282.38,282.473 282.713,293.473 282.5,304.5C 282.167,304.5 281.833,304.5 281.5,304.5C 281.5,300.167 281.5,295.833 281.5,291.5C 280.5,291.5 279.5,291.5 278.5,291.5C 278.699,285.448 276.699,280.281 272.5,276C 268.875,272.526 264.875,269.693 260.5,267.5C 259.653,266.034 258.32,265.2 256.5,265C 248.821,262.642 241.488,263.142 234.5,266.5C 227.637,270.686 222.637,276.353 219.5,283.5C 219.008,281.181 218.008,279.181 216.5,277.5C 226.396,264.033 239.396,254.7 255.5,249.5C 256.562,248.575 256.562,247.575 255.5,246.5C 255.414,245.504 255.748,244.671 256.5,244C 262.498,242.561 268.498,242.395 274.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6d6e",
    d: "M 386.5,249.5 C 386.5,249.833 386.5,250.167 386.5,250.5C 384.5,250.833 382.5,251.167 380.5,251.5C 380.167,251.5 379.833,251.5 379.5,251.5C 381.438,249.837 383.772,249.171 386.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcacd",
    d: "M 386.5,250.5 C 390.609,250.959 393.609,252.959 395.5,256.5C 394.417,256.461 393.417,256.127 392.5,255.5C 392.167,256.333 391.833,257.167 391.5,258C 392.71,262.656 392.71,267.156 391.5,271.5C 390.082,269.692 388.082,269.025 385.5,269.5C 387.606,262.715 385.94,257.049 380.5,252.5C 380.5,252.167 380.5,251.833 380.5,251.5C 382.5,251.167 384.5,250.833 386.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d2a2a",
    d: "M 506.5,249.5 C 506.5,250.167 506.833,250.5 507.5,250.5C 507.833,251.167 508.167,251.833 508.5,252.5C 507.833,254.5 507.167,256.5 506.5,258.5C 507.401,254.759 506.068,252.759 502.5,252.5C 500.485,251.076 498.152,250.41 495.5,250.5C 496.152,249.275 497.319,248.608 499,248.5C 501.498,248.917 503.998,249.251 506.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f6350",
    d: "M 524.5,249.5 C 523.917,252.947 522.584,255.947 520.5,258.5C 521.167,256.167 521.833,253.833 522.5,251.5C 522.833,250.5 523.5,249.833 524.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 573.5,249.5 C 573.573,251.027 572.906,252.027 571.5,252.5C 571.427,250.973 572.094,249.973 573.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d1214",
    d: "M 271.5,252.5 C 274.642,255.302 276.975,258.635 278.5,262.5C 278.737,263.791 278.404,264.791 277.5,265.5C 274.749,261.243 271.416,257.41 267.5,254C 264.274,252.894 261.607,251.061 259.5,248.5C 260,248.167 260.5,247.833 261,247.5C 264.887,248.529 268.387,250.195 271.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8b091",
    d: "M 502.5,252.5 C 506.068,252.759 507.401,254.759 506.5,258.5C 505.833,259.833 505.167,261.167 504.5,262.5C 502.086,264.34 500.419,266.673 499.5,269.5C 498.883,269.389 498.383,269.056 498,268.5C 497.502,265.183 497.335,261.85 497.5,258.5C 496.943,256.051 496.943,253.718 497.5,251.5C 499.071,252.309 500.738,252.643 502.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0303",
    d: "M 375.5,256.5 C 375.5,258.833 375.5,261.167 375.5,263.5C 374.972,271.416 371.305,273.749 364.5,270.5C 364.573,268.973 363.906,267.973 362.5,267.5C 362.336,264.813 362.503,262.146 363,259.5C 365.498,253.601 369.164,252.935 374,257.5C 374.383,256.944 374.883,256.611 375.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f5f6",
    d: "M 395.5,256.5 C 398.193,257.552 400.86,258.552 403.5,259.5C 403.5,259.833 403.5,260.167 403.5,260.5C 403.713,263.451 403.046,266.118 401.5,268.5C 399.413,269.585 398.08,271.251 397.5,273.5C 395.246,274.415 393.246,275.748 391.5,277.5C 390.167,277.5 389.5,276.833 389.5,275.5C 391.104,274.713 391.771,273.38 391.5,271.5C 392.71,267.156 392.71,262.656 391.5,258C 391.833,257.167 392.167,256.333 392.5,255.5C 393.417,256.127 394.417,256.461 395.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b68d72",
    d: "M 521.5,245.5 C 521.205,247.735 521.539,249.735 522.5,251.5C 521.833,253.833 521.167,256.167 520.5,258.5C 521.361,265.668 521.361,272.668 520.5,279.5C 520.529,273.79 520.029,268.123 519,262.5C 518.617,263.056 518.117,263.389 517.5,263.5C 517.5,262.833 517.5,262.167 517.5,261.5C 518.468,255.968 519.801,250.634 521.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc888c",
    d: "M 378.5,251.5 C 378.833,251.5 379.167,251.5 379.5,251.5C 379.833,251.5 380.167,251.5 380.5,251.5C 380.5,251.833 380.5,252.167 380.5,252.5C 376.846,255.141 375.512,258.808 376.5,263.5C 376.167,263.5 375.833,263.5 375.5,263.5C 375.5,261.167 375.5,258.833 375.5,256.5C 376.075,254.589 377.075,252.922 378.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a77371",
    d: "M 495.5,250.5 C 498.152,250.41 500.485,251.076 502.5,252.5C 500.738,252.643 499.071,252.309 497.5,251.5C 496.943,253.718 496.943,256.051 497.5,258.5C 495.96,256.162 495.294,253.495 495.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#554036",
    d: "M 408.5,255.5 C 408.833,255.5 409.167,255.5 409.5,255.5C 409.664,258.187 409.497,260.854 409,263.5C 408.722,264.416 408.222,265.082 407.5,265.5C 408.207,262.214 408.54,258.881 408.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5b796",
    d: "M 412.5,250.5 C 410.728,254.949 410.228,259.616 411,264.5C 411.5,263.333 412.333,262.5 413.5,262C 430.744,261.108 447.91,259.941 465,258.5C 466.107,259.712 466.607,259.379 466.5,257.5C 468.711,261.728 471.377,265.728 474.5,269.5C 475.568,270.434 476.901,270.768 478.5,270.5C 478.5,275.167 478.5,279.833 478.5,284.5C 467.071,282.008 455.404,281.008 443.5,281.5C 444.25,285.775 442.917,289.109 439.5,291.5C 441.382,287.019 441.882,282.353 441,277.5C 434.926,269.523 427.093,267.356 417.5,271C 411.779,274.191 406.112,277.358 400.5,280.5C 400.389,279.883 400.056,279.383 399.5,279C 400.71,277.961 401.71,276.794 402.5,275.5C 403.925,274.078 404.925,272.411 405.5,270.5C 405.893,268.716 406.559,267.05 407.5,265.5C 408.222,265.082 408.722,264.416 409,263.5C 409.497,260.854 409.664,258.187 409.5,255.5C 410.692,253.887 411.692,252.22 412.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94856c",
    d: "M 588.5,252.5 C 587.492,255.844 586.492,259.177 585.5,262.5C 585.167,262.5 584.833,262.5 584.5,262.5C 584.5,261.5 584.5,260.5 584.5,259.5C 585.079,256.669 586.412,254.336 588.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#473652",
    d: "M 348.5,254.5 C 347.771,259.13 347.437,263.797 347.5,268.5C 347.167,268.5 346.833,268.5 346.5,268.5C 346.5,267.833 346.5,267.167 346.5,266.5C 346.5,265.833 346.5,265.167 346.5,264.5C 346.336,261.813 346.503,259.146 347,256.5C 347.278,255.584 347.778,254.918 348.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e1515",
    d: "M 508.5,252.5 C 509.303,258.435 507.636,263.769 503.5,268.5C 502.903,268.265 502.57,267.765 502.5,267C 503.414,265.594 504.08,264.094 504.5,262.5C 505.167,261.167 505.833,259.833 506.5,258.5C 507.167,256.5 507.833,254.5 508.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4cfd0",
    d: "M 380.5,252.5 C 385.94,257.049 387.606,262.715 385.5,269.5C 381.247,269.218 378.247,267.218 376.5,263.5C 375.512,258.808 376.846,255.141 380.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b98e97",
    d: "M 585.5,262.5 C 587.587,263.585 588.92,265.251 589.5,267.5C 587.413,266.415 586.08,264.749 585.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585858",
    d: "M 676.5,262.5 C 678.587,263.585 679.92,265.251 680.5,267.5C 678.413,266.415 677.08,264.749 676.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00e3df",
    d: "M 204.5,273.5 C 204.167,273.5 203.833,273.5 203.5,273.5C 202.925,271.589 201.925,269.922 200.5,268.5C 201.055,266.271 202.389,264.605 204.5,263.5C 205.806,266.98 205.806,270.313 204.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#301822",
    d: "M 260.5,267.5 C 251.944,265.213 243.277,264.88 234.5,266.5C 241.488,263.142 248.821,262.642 256.5,265C 258.32,265.2 259.653,266.034 260.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75508e",
    d: "M 331.5,252.5 C 329.743,260.018 329.076,267.685 329.5,275.5C 328.778,275.082 328.278,274.416 328,273.5C 327.333,269.167 327.333,264.833 328,260.5C 328.387,257.401 329.554,254.734 331.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#073534",
    d: "M 189.5,262.5 C 190.404,263.209 190.737,264.209 190.5,265.5C 191.5,265.5 192.5,265.5 193.5,265.5C 192.998,267.085 191.998,267.585 190.5,267C 189.62,265.644 189.286,264.144 189.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d0a0e",
    d: "M 260.5,267.5 C 264.875,269.693 268.875,272.526 272.5,276C 276.699,280.281 278.699,285.448 278.5,291.5C 280.315,293.468 280.815,295.802 280,298.5C 277.588,302.916 274.422,306.749 270.5,310C 265.437,312.861 260.437,315.694 255.5,318.5C 255.167,318.5 254.833,318.5 254.5,318.5C 249.203,319.275 243.87,319.608 238.5,319.5C 234.403,318.8 230.737,317.134 227.5,314.5C 221.257,305.198 218.59,294.865 219.5,283.5C 222.637,276.353 227.637,270.686 234.5,266.5C 243.277,264.88 251.944,265.213 260.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#945e85",
    d: "M 584.5,262.5 C 584.833,262.5 585.167,262.5 585.5,262.5C 586.08,264.749 587.413,266.415 589.5,267.5C 604.135,283.639 618.635,299.973 633,316.5C 643.396,326.728 653.563,337.062 663.5,347.5C 668.224,353.227 673.558,358.227 679.5,362.5C 687.758,370.651 696.091,378.818 704.5,387C 706.527,388.879 708.86,390.046 711.5,390.5C 711.5,399.833 711.5,409.167 711.5,418.5C 710.448,418.649 709.448,418.483 708.5,418C 666.167,375.009 625.334,330.843 586,285.5C 585.604,282.343 584.771,279.343 583.5,276.5C 583.226,271.737 583.559,267.07 584.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4c4d",
    d: "M 403.5,260.5 C 405.184,263.718 404.517,266.385 401.5,268.5C 403.046,266.118 403.713,263.451 403.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4f7",
    d: "M 346.5,266.5 C 346.5,267.167 346.5,267.833 346.5,268.5C 346.592,272.684 348.259,276.017 351.5,278.5C 352.5,278.5 353.5,278.5 354.5,278.5C 354.263,279.791 354.596,280.791 355.5,281.5C 355.973,282.906 356.973,283.573 358.5,283.5C 359.347,284.966 360.68,285.8 362.5,286C 357.845,286.499 353.179,286.666 348.5,286.5C 345.319,285.651 342.652,283.985 340.5,281.5C 339.532,278.555 339.366,275.555 340,272.5C 341.98,270.101 344.147,268.101 346.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ce2c2b",
    d: "M 362.5,267.5 C 362.427,269.027 363.094,270.027 364.5,270.5C 371.305,273.749 374.972,271.416 375.5,263.5C 375.833,263.5 376.167,263.5 376.5,263.5C 378.247,267.218 381.247,269.218 385.5,269.5C 385.5,269.833 385.5,270.167 385.5,270.5C 379.667,281.388 371.333,284.055 360.5,278.5C 360.5,278.167 360.5,277.833 360.5,277.5C 363.199,271.274 361.199,268.274 354.5,268.5C 355.528,265.63 357.528,263.63 360.5,262.5C 361.17,264.291 361.837,265.958 362.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00ada9",
    d: "M 207.5,263.5 C 206.833,267.5 206.167,271.5 205.5,275.5C 204.662,275.158 204.328,274.492 204.5,273.5C 205.806,270.313 205.806,266.98 204.5,263.5C 202.389,264.605 201.055,266.271 200.5,268.5C 200.167,268.5 199.833,268.5 199.5,268.5C 200.345,264.647 202.679,261.981 206.5,260.5C 207.386,261.325 207.719,262.325 207.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#003a39",
    d: "M 207.5,263.5 C 207.826,267.884 207.492,272.217 206.5,276.5C 205.893,276.376 205.56,276.043 205.5,275.5C 206.167,271.5 206.833,267.5 207.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8c7e4",
    d: "M 346.5,264.5 C 346.5,265.167 346.5,265.833 346.5,266.5C 344.147,268.101 341.98,270.101 340,272.5C 339.366,275.555 339.532,278.555 340.5,281.5C 339.883,281.389 339.383,281.056 339,280.5C 337.229,273.119 339.729,267.786 346.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#741616",
    d: "M 362.5,267.5 C 363.906,267.973 364.573,268.973 364.5,270.5C 363.094,270.027 362.427,269.027 362.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727171",
    d: "M 385.5,270.5 C 385.5,270.167 385.5,269.833 385.5,269.5C 388.082,269.025 390.082,269.692 391.5,271.5C 391.771,273.38 391.104,274.713 389.5,275.5C 390.038,273.883 390.371,272.216 390.5,270.5C 388.833,270.5 387.167,270.5 385.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f3435",
    d: "M 504.5,262.5 C 504.08,264.094 503.414,265.594 502.5,267C 502.57,267.765 502.903,268.265 503.5,268.5C 502.241,271.526 500.908,271.86 499.5,269.5C 500.419,266.673 502.086,264.34 504.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d2737",
    d: "M 584.5,259.5 C 584.5,260.5 584.5,261.5 584.5,262.5C 583.559,267.07 583.226,271.737 583.5,276.5C 582.837,274.359 582.503,272.025 582.5,269.5C 582.315,265.859 582.981,262.526 584.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#482f60",
    d: "M 255.5,271.5 C 254.791,272.404 253.791,272.737 252.5,272.5C 249.5,272.5 246.5,272.5 243.5,272.5C 242.081,271.549 240.415,271.216 238.5,271.5C 240.462,269.983 242.795,269.316 245.5,269.5C 248.976,269.55 252.31,270.217 255.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#60353d",
    d: "M 278.5,262.5 C 279.87,264.25 280.87,266.25 281.5,268.5C 281.5,269.5 281.5,270.5 281.5,271.5C 280.504,271.586 279.671,271.252 279,270.5C 278.648,268.753 278.148,267.086 277.5,265.5C 278.404,264.791 278.737,263.791 278.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 569.5,257.5 C 568.986,264.656 568.319,271.656 567.5,278.5C 567.334,272.491 567.501,266.491 568,260.5C 568.232,259.263 568.732,258.263 569.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 682.5,269.5 C 685.243,271.239 687.243,273.573 688.5,276.5C 685.757,274.761 683.757,272.427 682.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#014847",
    d: "M 199.5,268.5 C 199.833,268.5 200.167,268.5 200.5,268.5C 201.925,269.922 202.925,271.589 203.5,273.5C 201.413,272.415 200.08,270.749 199.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9a9",
    d: "M 346.5,268.5 C 346.833,268.5 347.167,268.5 347.5,268.5C 348.454,271.706 349.787,274.706 351.5,277.5C 351.5,277.833 351.5,278.167 351.5,278.5C 348.259,276.017 346.592,272.684 346.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5c2c2",
    d: "M 354.5,268.5 C 361.199,268.274 363.199,271.274 360.5,277.5C 360.167,277.5 359.833,277.5 359.5,277.5C 356.024,276.188 354.357,273.521 354.5,269.5C 354.5,269.167 354.5,268.833 354.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 401.5,268.5 C 400.92,270.749 399.587,272.415 397.5,273.5C 398.08,271.251 399.413,269.585 401.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5ded3",
    d: "M 439.5,291.5 C 437.86,292.32 436.193,293.153 434.5,294C 419.167,294.667 403.833,294.667 388.5,294C 387.483,292.951 387.316,291.784 388,290.5C 392.328,287.268 396.494,283.934 400.5,280.5C 406.112,277.358 411.779,274.191 417.5,271C 427.093,267.356 434.926,269.523 441,277.5C 441.882,282.353 441.382,287.019 439.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#261933",
    d: "M 255.5,271.5 C 259.976,272.657 263.642,274.99 266.5,278.5C 266.167,278.5 265.833,278.5 265.5,278.5C 261.485,275.722 257.152,273.722 252.5,272.5C 253.791,272.737 254.791,272.404 255.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6afaf",
    d: "M 353.5,269.5 C 353.833,269.5 354.167,269.5 354.5,269.5C 354.357,273.521 356.024,276.188 359.5,277.5C 357.142,277.747 355.142,277.081 353.5,275.5C 353.5,273.5 353.5,271.5 353.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#946e5a",
    d: "M 405.5,270.5 C 404.925,272.411 403.925,274.078 402.5,275.5C 402.167,275.5 401.833,275.5 401.5,275.5C 402.08,273.251 403.413,271.585 405.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5d5d",
    d: "M 179.5,272.5 C 180.906,272.973 181.573,273.973 181.5,275.5C 180.094,275.027 179.427,274.027 179.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#39254b",
    d: "M 252.5,276.5 C 249.14,276.616 245.807,276.949 242.5,277.5C 245.708,275.469 249.041,275.135 252.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#674589",
    d: "M 252.5,276.5 C 254.698,276.12 256.365,276.787 257.5,278.5C 255.447,278.402 253.78,279.069 252.5,280.5C 239.987,280.181 234.987,286.181 237.5,298.5C 237.5,298.833 237.5,299.167 237.5,299.5C 236.286,302.129 236.286,304.796 237.5,307.5C 230.115,299.388 229.615,290.721 236,281.5C 237.972,279.768 240.139,278.435 242.5,277.5C 245.807,276.949 249.14,276.616 252.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494545",
    d: "M 353.5,275.5 C 355.142,277.081 357.142,277.747 359.5,277.5C 359.833,277.5 360.167,277.5 360.5,277.5C 360.5,277.833 360.5,278.167 360.5,278.5C 358.833,278.5 357.167,278.5 355.5,278.5C 355.5,279.5 355.5,280.5 355.5,281.5C 354.596,280.791 354.263,279.791 354.5,278.5C 353.5,278.5 352.5,278.5 351.5,278.5C 351.5,278.167 351.5,277.833 351.5,277.5C 352.833,277.5 353.5,276.833 353.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c9c9c",
    d: "M 389.5,275.5 C 389.5,276.833 390.167,277.5 391.5,277.5C 386.167,281.5 385.5,280.833 389.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454349",
    d: "M 265.5,278.5 C 265.833,278.5 266.167,278.5 266.5,278.5C 268.262,279.262 269.262,280.596 269.5,282.5C 267.833,281.833 266.167,281.167 264.5,280.5C 262.833,280.5 261.167,280.5 259.5,280.5C 259.5,280.167 259.5,279.833 259.5,279.5C 261.735,279.795 263.735,279.461 265.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5d5d",
    d: "M 565.5,279.5 C 565.027,280.906 564.027,281.573 562.5,281.5C 562.973,280.094 563.973,279.427 565.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#565656",
    d: "M 185.5,280.5 C 189.684,280.851 193.684,281.518 197.5,282.5C 194.5,282.5 191.5,282.5 188.5,282.5C 187.29,282.068 186.29,281.401 185.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2e0e4",
    d: "M 259.5,280.5 C 261.167,280.5 262.833,280.5 264.5,280.5C 265.458,281.962 266.624,283.295 268,284.5C 268.49,285.793 268.657,287.127 268.5,288.5C 268.167,289.167 267.833,289.833 267.5,290.5C 266.533,291.806 265.199,292.473 263.5,292.5C 261.807,288.628 259.474,285.128 256.5,282C 257.244,280.961 258.244,280.461 259.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24151b",
    d: "M 516.5,274.5 C 517.641,278.112 516.308,280.779 512.5,282.5C 507.15,283.615 504.317,281.615 504,276.5C 509.169,282.233 513.336,281.567 516.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dba287",
    d: "M 520.5,279.5 C 520.567,280.959 520.234,282.292 519.5,283.5C 518.094,283.973 517.427,284.973 517.5,286.5C 509.802,289.899 502.802,288.899 496.5,283.5C 496.47,282.503 496.97,281.836 498,281.5C 502.776,283.691 507.61,284.024 512.5,282.5C 516.308,280.779 517.641,278.112 516.5,274.5C 516.185,270.629 516.518,266.962 517.5,263.5C 518.117,263.389 518.617,263.056 519,262.5C 520.029,268.123 520.529,273.79 520.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1a1a1",
    d: "M 188.5,282.5 C 191.5,282.5 194.5,282.5 197.5,282.5C 198.906,282.973 199.573,283.973 199.5,285.5C 195.937,283.998 192.27,282.998 188.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#009f9c",
    d: "M 214.5,278.5 C 213.854,280.156 213.187,281.823 212.5,283.5C 212.846,284.849 213.179,286.183 213.5,287.5C 209.296,284.084 209.629,281.084 214.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 355.5,281.5 C 357.027,281.427 358.027,282.094 358.5,283.5C 356.973,283.573 355.973,282.906 355.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595959",
    d: "M 562.5,281.5 C 562.027,282.906 561.027,283.573 559.5,283.5C 559.973,282.094 560.973,281.427 562.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8596f",
    d: "M 281.5,268.5 C 282.507,271.322 283.34,274.322 284,277.5C 284.277,286.357 284.444,295.024 284.5,303.5C 284.158,304.338 283.492,304.672 282.5,304.5C 282.713,293.473 282.38,282.473 281.5,271.5C 281.5,270.5 281.5,269.5 281.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be876f",
    d: "M 323.5,276.5 C 325.109,280.046 327.443,283.046 330.5,285.5C 328.833,285.5 327.167,285.5 325.5,285.5C 325.244,282.402 324.578,279.402 323.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#664c3e",
    d: "M 519.5,283.5 C 519.573,285.027 518.906,286.027 517.5,286.5C 517.427,284.973 518.094,283.973 519.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5a",
    d: "M 559.5,283.5 C 558.738,285.262 557.404,286.262 555.5,286.5C 556.262,284.738 557.596,283.738 559.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c7cb",
    d: "M 257.5,278.5 C 258.167,278.833 258.833,279.167 259.5,279.5C 259.5,279.833 259.5,280.167 259.5,280.5C 258.244,280.461 257.244,280.961 256.5,282C 259.474,285.128 261.807,288.628 263.5,292.5C 262.508,292.328 261.842,292.662 261.5,293.5C 261.167,293.5 260.833,293.5 260.5,293.5C 259.685,289.841 257.519,287.174 254,285.5C 253.506,287.134 253.34,288.801 253.5,290.5C 252.662,290.158 252.328,289.492 252.5,288.5C 252.366,286.708 252.699,285.042 253.5,283.5C 253.737,282.209 253.404,281.209 252.5,280.5C 253.78,279.069 255.447,278.402 257.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a3e6d",
    d: "M 335.5,284.5 C 338.649,284.415 341.316,285.415 343.5,287.5C 340.351,287.585 337.684,286.585 335.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18141b",
    d: "M 252.5,280.5 C 253.404,281.209 253.737,282.209 253.5,283.5C 250.615,283.194 247.948,283.527 245.5,284.5C 242.833,285.167 241.167,286.833 240.5,289.5C 240.5,292.5 240.5,295.5 240.5,298.5C 239.5,298.5 238.5,298.5 237.5,298.5C 234.987,286.181 239.987,280.181 252.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c4873",
    d: "M 245.5,284.5 C 244.167,286.5 242.5,288.167 240.5,289.5C 241.167,286.833 242.833,285.167 245.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5acbb",
    d: "M 358.5,283.5 C 361.467,283.989 364.133,285.155 366.5,287C 366.272,287.399 365.938,287.565 365.5,287.5C 359.642,287.822 353.975,287.489 348.5,286.5C 353.179,286.666 357.845,286.499 362.5,286C 360.68,285.8 359.347,284.966 358.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e8ed",
    d: "M 260.5,293.5 C 259.5,293.5 258.5,293.5 257.5,293.5C 256.833,293.167 256.167,292.833 255.5,292.5C 254.5,292.167 253.833,291.5 253.5,290.5C 253.34,288.801 253.506,287.134 254,285.5C 257.519,287.174 259.685,289.841 260.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#111012",
    d: "M 252.5,288.5 C 252.328,289.492 252.662,290.158 253.5,290.5C 253.833,291.5 254.5,292.167 255.5,292.5C 255.663,294.857 255.497,297.19 255,299.5C 253.301,300.406 251.467,300.739 249.5,300.5C 246.169,297.184 245.002,293.184 246,288.5C 248.163,287.232 250.33,287.232 252.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888593",
    d: "M 264.5,280.5 C 266.167,281.167 267.833,281.833 269.5,282.5C 272,285.494 274,288.827 275.5,292.5C 274.542,292.047 273.708,291.381 273,290.5C 272.802,292.382 272.302,294.048 271.5,295.5C 271.663,293.143 271.497,290.81 271,288.5C 270.23,287.402 269.397,287.402 268.5,288.5C 268.657,287.127 268.49,285.793 268,284.5C 266.624,283.295 265.458,281.962 264.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b715d",
    d: "M 384.5,286.5 C 382.824,288.834 380.491,289.834 377.5,289.5C 379.509,287.935 381.843,286.935 384.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#945d86",
    d: "M 583.5,292.5 C 609.933,326.948 638.266,359.948 668.5,391.5C 670.43,395.1 673.097,398.1 676.5,400.5C 680.167,403.5 683.5,406.833 686.5,410.5C 688.43,414.1 691.097,417.1 694.5,419.5C 699.298,423.797 703.965,428.297 708.5,433C 709.448,433.483 710.448,433.649 711.5,433.5C 711.5,451.833 711.5,470.167 711.5,488.5C 708.281,488.776 705.615,490.109 703.5,492.5C 690.221,478.383 677.055,464.05 664,449.5C 648.303,429.645 632.469,409.979 616.5,390.5C 621.715,389.278 624.382,385.945 624.5,380.5C 620.411,381.523 616.411,382.857 612.5,384.5C 598.853,365.022 585.02,345.689 571,326.5C 567.799,319.1 564.299,311.767 560.5,304.5C 565.965,299.536 571.298,294.37 576.5,289C 577.5,288.333 578.5,288.333 579.5,289C 580.705,290.376 582.038,291.542 583.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#302041",
    d: "M 230.5,284.5 C 229.8,288.798 229.467,293.131 229.5,297.5C 228.839,295.866 228.506,294.033 228.5,292C 228.3,289.134 228.967,286.634 230.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f4438",
    d: "M 335.5,288.5 C 338.855,288.69 341.855,289.69 344.5,291.5C 341.084,291.472 338.084,290.472 335.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e3e3e",
    d: "M 555.5,286.5 C 554.415,288.587 552.749,289.92 550.5,290.5C 551.585,288.413 553.251,287.08 555.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 527.5,290.5 C 527.573,292.027 526.906,293.027 525.5,293.5C 525.427,291.973 526.094,290.973 527.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8e8e",
    d: "M 199.5,285.5 C 202,288.66 203.333,292.327 203.5,296.5C 201.358,293.2 200.025,289.533 199.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94919f",
    d: "M 267.5,290.5 C 267.5,292.167 267.5,293.833 267.5,295.5C 266.699,297.042 266.366,298.708 266.5,300.5C 265.883,300.611 265.383,300.944 265,301.5C 264.503,298.854 264.336,296.187 264.5,293.5C 263.5,293.5 262.5,293.5 261.5,293.5C 261.842,292.662 262.508,292.328 263.5,292.5C 265.199,292.473 266.533,291.806 267.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#343338",
    d: "M 271.5,295.5 C 271.672,296.492 271.338,297.158 270.5,297.5C 270.664,294.813 270.497,292.146 270,289.5C 268.981,291.502 268.148,293.502 267.5,295.5C 267.5,293.833 267.5,292.167 267.5,290.5C 267.833,289.833 268.167,289.167 268.5,288.5C 269.397,287.402 270.23,287.402 271,288.5C 271.497,290.81 271.663,293.143 271.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a2b6",
    d: "M 275.5,292.5 C 276.598,293.601 276.765,294.934 276,296.5C 274.248,298.351 272.748,300.351 271.5,302.5C 270.662,302.158 270.328,301.492 270.5,300.5C 270.5,299.5 270.5,298.5 270.5,297.5C 271.338,297.158 271.672,296.492 271.5,295.5C 272.302,294.048 272.802,292.382 273,290.5C 273.708,291.381 274.542,292.047 275.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ded4d9",
    d: "M 498.5,288.5 C 500.081,290.142 500.747,292.142 500.5,294.5C 500.5,296.167 500.5,297.833 500.5,299.5C 499.698,298.048 499.198,296.382 499,294.5C 498.5,304.161 498.334,313.828 498.5,323.5C 498.167,323.5 497.833,323.5 497.5,323.5C 497.699,313.481 497.366,303.481 496.5,293.5C 496.556,291.36 497.223,289.694 498.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f7f7",
    d: "M 500.5,299.5 C 500.666,306.841 500.5,314.174 500,321.5C 499.722,322.416 499.222,323.082 498.5,323.5C 498.334,313.828 498.5,304.161 499,294.5C 499.198,296.382 499.698,298.048 500.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#633e59",
    d: "M 583.5,292.5 C 582.038,291.542 580.705,290.376 579.5,289C 578.5,288.333 577.5,288.333 576.5,289C 571.298,294.37 565.965,299.536 560.5,304.5C 560.167,304.5 559.833,304.5 559.5,304.5C 564.964,298.535 570.63,292.702 576.5,287C 580.079,287.063 582.412,288.896 583.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaabe",
    d: "M 253.5,283.5 C 252.699,285.042 252.366,286.708 252.5,288.5C 250.33,287.232 248.163,287.232 246,288.5C 245.002,293.184 246.169,297.184 249.5,300.5C 255.61,302.746 258.277,300.413 257.5,293.5C 258.5,293.5 259.5,293.5 260.5,293.5C 260.833,293.5 261.167,293.5 261.5,293.5C 261.968,297.936 260.968,301.936 258.5,305.5C 256.608,306.851 254.442,307.518 252,307.5C 248.877,307.182 246.044,306.182 243.5,304.5C 244.728,302.99 244.728,301.49 243.5,300C 241.527,299.505 239.527,299.338 237.5,299.5C 237.5,299.167 237.5,298.833 237.5,298.5C 238.5,298.5 239.5,298.5 240.5,298.5C 240.5,295.5 240.5,292.5 240.5,289.5C 242.5,288.167 244.167,286.5 245.5,284.5C 247.948,283.527 250.615,283.194 253.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ee1dd",
    d: "M 216.5,277.5 C 218.008,279.181 219.008,281.181 219.5,283.5C 218.59,294.865 221.257,305.198 227.5,314.5C 227.36,320.536 227.693,326.536 228.5,332.5C 228.044,337.596 229.044,342.262 231.5,346.5C 232.338,346.842 232.672,347.508 232.5,348.5C 232.6,351.108 231.933,353.442 230.5,355.5C 229.185,356.476 227.852,357.476 226.5,358.5C 222.743,353.653 220.076,348.319 218.5,342.5C 217.734,327.858 217.234,313.191 217,298.5C 216.79,296.942 216.29,295.609 215.5,294.5C 215.6,291.892 214.933,289.558 213.5,287.5C 213.179,286.183 212.846,284.849 212.5,283.5C 213.187,281.823 213.854,280.156 214.5,278.5C 214.842,277.662 215.508,277.328 216.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b7886",
    d: "M 255.5,292.5 C 256.167,292.833 256.833,293.167 257.5,293.5C 258.277,300.413 255.61,302.746 249.5,300.5C 251.467,300.739 253.301,300.406 255,299.5C 255.497,297.19 255.663,294.857 255.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f3f7f",
    d: "M 238.5,271.5 C 240.415,271.216 242.081,271.549 243.5,272.5C 237.202,274.468 232.869,278.468 230.5,284.5C 228.967,286.634 228.3,289.134 228.5,292C 228.506,294.033 228.839,295.866 229.5,297.5C 230.867,304.173 234.2,309.506 239.5,313.5C 239.5,314.167 239.5,314.833 239.5,315.5C 234.579,315.957 231.079,313.957 229,309.5C 223.114,299.123 223.114,288.79 229,278.5C 231.501,275.152 234.668,272.818 238.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3c",
    d: "M 540.5,298.5 C 539.089,300.914 537.089,302.581 534.5,303.5C 535.911,301.086 537.911,299.419 540.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dedbe2",
    d: "M 237.5,299.5 C 239.527,299.338 241.527,299.505 243.5,300C 244.728,301.49 244.728,302.99 243.5,304.5C 243.5,304.833 243.5,305.167 243.5,305.5C 241.886,307.075 239.886,307.741 237.5,307.5C 236.286,304.796 236.286,302.129 237.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4a53",
    d: "M 270.5,300.5 C 270.328,301.492 270.662,302.158 271.5,302.5C 270.678,304.728 269.345,305.395 267.5,304.5C 268.035,302.739 269.035,301.406 270.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#805c4c",
    d: "M 321.5,302.5 C 337.818,303.35 354.151,303.683 370.5,303.5C 363.675,304.166 356.675,304.5 349.5,304.5C 339.944,304.724 330.611,304.058 321.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#876250",
    d: "M 437.5,304.5 C 441.489,304.116 445.155,304.783 448.5,306.5C 444.64,306.192 440.974,305.525 437.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3b42",
    d: "M 261.5,293.5 C 262.5,293.5 263.5,293.5 264.5,293.5C 264.336,296.187 264.503,298.854 265,301.5C 265.383,300.944 265.883,300.611 266.5,300.5C 264.451,306.212 260.451,309.879 254.5,311.5C 252.5,310.833 250.5,310.167 248.5,309.5C 253.447,310.372 257.613,309.039 261,305.5C 261.667,304.833 261.667,304.167 261,303.5C 260.292,304.381 259.458,305.047 258.5,305.5C 260.968,301.936 261.968,297.936 261.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d6175",
    d: "M 340.5,309.5 C 366,310.341 391.666,310.341 417.5,309.5C 437.596,309.514 456.929,313.181 475.5,320.5C 475.5,322.167 475.5,323.833 475.5,325.5C 454.124,322.986 433.457,325.652 413.5,333.5C 402.983,335.864 399.817,342.198 404,352.5C 408.013,358.541 410.013,365.208 410,372.5C 403.68,374.909 397.513,377.742 391.5,381C 375.5,390 359.5,399 343.5,408C 339.671,408.758 336.338,407.758 333.5,405C 330.296,402.131 327.463,398.965 325,395.5C 324.333,390.5 324.333,385.5 325,380.5C 328.7,378.446 329.2,375.946 326.5,373C 322.833,372.667 319.167,372.333 315.5,372C 314.978,371.439 314.645,370.772 314.5,370C 322.86,365.646 331.194,360.98 339.5,356C 345.554,353.825 351.554,351.659 357.5,349.5C 360.448,349.777 363.281,349.444 366,348.5C 366.667,347.5 366.667,346.5 366,345.5C 364.5,344.333 363,343.167 361.5,342C 354.986,341.18 348.653,341.347 342.5,342.5C 341.504,342.414 340.671,342.748 340,343.5C 339.798,345.256 339.298,346.922 338.5,348.5C 329.944,354.034 320.61,357.701 310.5,359.5C 303.377,351.536 296.377,343.369 289.5,335C 286.025,327.206 284.691,319.04 285.5,310.5C 289.25,306.101 294.083,304.434 300,305.5C 313.501,306.881 327.001,308.215 340.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3dcb1",
    d: "M 559.5,304.5 C 559.833,304.5 560.167,304.5 560.5,304.5C 564.299,311.767 567.799,319.1 571,326.5C 585.02,345.689 598.853,365.022 612.5,384.5C 606.748,388.043 600.748,391.043 594.5,393.5C 589.071,394.747 584.071,396.747 579.5,399.5C 577.734,402.774 578.568,405.107 582,406.5C 586.973,403.794 592.14,401.461 597.5,399.5C 599.422,401.687 601.088,404.02 602.5,406.5C 602.166,409.491 603.166,411.824 605.5,413.5C 609.729,422.013 612.895,431.013 615,440.5C 621.637,449.725 629.47,450.892 638.5,444C 641.313,441.464 641.146,439.297 638,437.5C 628.016,442.76 621.85,439.76 619.5,428.5C 619.573,426.973 618.906,425.973 617.5,425.5C 613.162,415.153 609.829,404.486 607.5,393.5C 610.594,392.787 613.594,391.787 616.5,390.5C 632.469,409.979 648.303,429.645 664,449.5C 677.055,464.05 690.221,478.383 703.5,492.5C 696.833,497.5 690.167,502.5 683.5,507.5C 681.973,507.427 680.973,508.094 680.5,509.5C 678.973,509.427 677.973,510.094 677.5,511.5C 675.973,511.427 674.973,512.094 674.5,513.5C 672.973,513.427 671.973,514.094 671.5,515.5C 669.973,515.427 668.973,516.094 668.5,517.5C 665.489,518.669 662.822,520.336 660.5,522.5C 658.973,522.427 657.973,523.094 657.5,524.5C 656.508,524.328 655.842,524.662 655.5,525.5C 653.973,525.427 652.973,526.094 652.5,527.5C 650.326,527.75 648.659,528.75 647.5,530.5C 645.973,530.427 644.973,531.094 644.5,532.5C 626.73,542.942 608.73,552.942 590.5,562.5C 588.326,562.75 586.659,563.75 585.5,565.5C 570.086,573.207 554.753,580.873 539.5,588.5C 459.167,588.5 378.833,588.5 298.5,588.5C 304.583,585.079 308.917,580.079 311.5,573.5C 312.222,573.082 312.722,572.416 313,571.5C 313.667,566.167 313.667,560.833 313,555.5C 312.434,553.277 311.6,551.277 310.5,549.5C 304.477,533.654 293.144,527.487 276.5,531C 269.864,534.466 265.197,539.632 262.5,546.5C 261.732,547.263 261.232,548.263 261,549.5C 260.362,556.208 260.695,562.874 262,569.5C 262.377,570.942 263.21,571.942 264.5,572.5C 266.961,579.46 271.295,584.793 277.5,588.5C 254.833,588.5 232.167,588.5 209.5,588.5C 208.897,580.846 209.897,573.513 212.5,566.5C 216.363,558.566 222.363,556.232 230.5,559.5C 234.14,558.106 235.64,555.44 235,551.5C 232.083,549.607 228.916,549.107 225.5,550C 208.491,557.179 200.491,570.013 201.5,588.5C 189.167,588.5 176.833,588.5 164.5,588.5C 151.601,569.051 138.434,549.718 125,530.5C 123.167,527.333 121.333,524.167 119.5,521C 120.056,520.617 120.389,520.117 120.5,519.5C 120.833,519.5 121.167,519.5 121.5,519.5C 143.658,513.337 165.324,506.003 186.5,497.5C 187.209,496.596 188.209,496.263 189.5,496.5C 199.916,493.588 209.916,489.921 219.5,485.5C 220.167,485.5 220.833,485.5 221.5,485.5C 223.967,485.245 225.967,484.245 227.5,482.5C 229.746,481.545 232.079,480.878 234.5,480.5C 239.393,479.204 244.06,477.538 248.5,475.5C 252.936,474.586 256.936,472.919 260.5,470.5C 264.869,468.043 269.536,466.377 274.5,465.5C 278.624,464.601 282.291,462.934 285.5,460.5C 287.527,460.662 289.527,460.495 291.5,460C 295.153,459.17 298.153,457.337 300.5,454.5C 302.421,453.637 304.421,452.971 306.5,452.5C 308.027,452.573 309.027,451.906 309.5,450.5C 310.167,450.5 310.833,450.5 311.5,450.5C 313.674,450.25 315.341,449.25 316.5,447.5C 319.145,445.69 322.145,444.69 325.5,444.5C 327.674,444.25 329.341,443.25 330.5,441.5C 335.166,438.746 340.166,436.746 345.5,435.5C 348.918,435.076 351.918,433.742 354.5,431.5C 360.517,430.137 365.85,427.471 370.5,423.5C 376.682,422.409 382.016,419.742 386.5,415.5C 392.844,414.16 398.511,411.493 403.5,407.5C 419.665,398.25 435.998,389.25 452.5,380.5C 454.027,380.573 455.027,379.906 455.5,378.5C 459.164,375.665 463.164,373.332 467.5,371.5C 469.027,371.573 470.027,370.906 470.5,369.5C 472.027,369.573 473.027,368.906 473.5,367.5C 473.842,366.662 474.508,366.328 475.5,366.5C 477.027,366.573 478.027,365.906 478.5,364.5C 480.027,364.573 481.027,363.906 481.5,362.5C 486.892,358.447 492.559,354.78 498.5,351.5C 502.071,351.439 504.404,349.773 505.5,346.5C 523.823,332.994 541.823,318.994 559.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#141315",
    d: "M 248.5,309.5 C 245.796,309.33 244.129,307.997 243.5,305.5C 243.5,305.167 243.5,304.833 243.5,304.5C 246.044,306.182 248.877,307.182 252,307.5C 254.442,307.518 256.608,306.851 258.5,305.5C 259.458,305.047 260.292,304.381 261,303.5C 261.667,304.167 261.667,304.833 261,305.5C 257.613,309.039 253.447,310.372 248.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#073b3b",
    d: "M 215.5,294.5 C 216.29,295.609 216.79,296.942 217,298.5C 217.234,313.191 217.734,327.858 218.5,342.5C 216.862,338.124 216.029,333.458 216,328.5C 215.5,317.172 215.333,305.838 215.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaa6ba",
    d: "M 243.5,305.5 C 244.129,307.997 245.796,309.33 248.5,309.5C 250.5,310.167 252.5,310.833 254.5,311.5C 250.486,311.666 246.486,311.499 242.5,311C 240.654,309.97 238.987,308.804 237.5,307.5C 239.886,307.741 241.886,307.075 243.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#773855",
    d: "M 278.5,291.5 C 279.5,291.5 280.5,291.5 281.5,291.5C 281.5,295.833 281.5,300.167 281.5,304.5C 276.191,308.803 270.858,313.137 265.5,317.5C 265.631,316.624 265.298,315.957 264.5,315.5C 261.766,317.371 258.766,318.371 255.5,318.5C 260.437,315.694 265.437,312.861 270.5,310C 274.422,306.749 277.588,302.916 280,298.5C 280.815,295.802 280.315,293.468 278.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#364452",
    d: "M 417.5,309.5 C 391.666,310.341 366,310.341 340.5,309.5C 366.337,308.936 392.003,308.936 417.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808080",
    d: "M 521.5,296.5 C 518.749,298.975 515.416,299.975 511.5,299.5C 512.052,306.314 512.719,312.981 513.5,319.5C 513.44,320.043 513.107,320.376 512.5,320.5C 511.638,313.177 510.971,305.843 510.5,298.5C 514.319,298.586 517.985,297.919 521.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2557",
    d: "M 285.5,310.5 C 284.691,319.04 286.025,327.206 289.5,335C 296.377,343.369 303.377,351.536 310.5,359.5C 320.61,357.701 329.944,354.034 338.5,348.5C 339.298,346.922 339.798,345.256 340,343.5C 340.671,342.748 341.504,342.414 342.5,342.5C 349.414,342.041 356.08,342.874 362.5,345C 363.672,345.419 364.672,346.085 365.5,347C 362.325,346.947 359.658,347.78 357.5,349.5C 351.554,351.659 345.554,353.825 339.5,356C 331.194,360.98 322.86,365.646 314.5,370C 314.645,370.772 314.978,371.439 315.5,372C 319.167,372.333 322.833,372.667 326.5,373C 329.2,375.946 328.7,378.446 325,380.5C 324.333,385.5 324.333,390.5 325,395.5C 327.463,398.965 330.296,402.131 333.5,405C 336.338,407.758 339.671,408.758 343.5,408C 359.5,399 375.5,390 391.5,381C 397.513,377.742 403.68,374.909 410,372.5C 410.013,365.208 408.013,358.541 404,352.5C 399.817,342.198 402.983,335.864 413.5,333.5C 411.667,335.496 411.167,337.829 412,340.5C 415.347,346.188 417.847,352.188 419.5,358.5C 420.387,366.476 421.054,374.476 421.5,382.5C 397.66,395.98 373.327,408.647 348.5,420.5C 316.06,422.307 285.727,415.14 257.5,399C 254.582,397.291 251.748,395.458 249,393.5C 247.031,387.32 245.697,380.987 245,374.5C 243.893,371.887 242.06,370.22 239.5,369.5C 239.784,367.585 239.451,365.919 238.5,364.5C 238.13,361.733 236.796,359.733 234.5,358.5C 239.611,352.601 244.944,346.934 250.5,341.5C 259.119,344.473 265.952,341.806 271,333.5C 271.812,329.311 271.645,325.311 270.5,321.5C 274.652,316.682 279.652,313.015 285.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4752",
    d: "M 239.5,313.5 C 241.75,313.181 243.75,313.681 245.5,315C 243.517,316.707 241.517,316.874 239.5,315.5C 239.5,314.833 239.5,314.167 239.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92496c",
    d: "M 227.5,314.5 C 230.737,317.134 234.403,318.8 238.5,319.5C 242.981,320.648 247.648,320.815 252.5,320C 253.416,319.722 254.082,319.222 254.5,318.5C 254.833,318.5 255.167,318.5 255.5,318.5C 258.766,318.371 261.766,317.371 264.5,315.5C 265.298,315.957 265.631,316.624 265.5,317.5C 263.806,318.527 262.473,319.861 261.5,321.5C 261.083,320.876 260.416,320.543 259.5,320.5C 253.456,322.875 247.122,323.875 240.5,323.5C 240.988,328.632 242.654,333.299 245.5,337.5C 241.472,341.859 237.472,346.193 233.5,350.5C 233.672,349.508 233.338,348.842 232.5,348.5C 232.672,347.508 232.338,346.842 231.5,346.5C 230.491,341.717 229.491,337.05 228.5,332.5C 227.693,326.536 227.36,320.536 227.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d2c43",
    d: "M 254.5,318.5 C 254.082,319.222 253.416,319.722 252.5,320C 247.648,320.815 242.981,320.648 238.5,319.5C 243.87,319.608 249.203,319.275 254.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808080",
    d: "M 500.5,294.5 C 501.494,304.319 501.827,314.319 501.5,324.5C 500.209,324.737 499.209,324.404 498.5,323.5C 499.222,323.082 499.722,322.416 500,321.5C 500.5,314.174 500.666,306.841 500.5,299.5C 500.5,297.833 500.5,296.167 500.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#495b6f",
    d: "M 270.5,321.5 C 271.645,325.311 271.812,329.311 271,333.5C 265.952,341.806 259.119,344.473 250.5,341.5C 256.167,333.833 262.833,327.167 270.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#282049",
    d: "M 475.5,320.5 C 483.487,323.492 491.487,326.492 499.5,329.5C 499,329.833 498.5,330.167 498,330.5C 490.554,328.516 483.054,326.85 475.5,325.5C 475.5,323.833 475.5,322.167 475.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eda58a",
    d: "M 261.5,321.5 C 258.167,324.167 255.167,327.167 252.5,330.5C 250.086,331.911 248.419,333.911 247.5,336.5C 246.833,336.833 246.167,337.167 245.5,337.5C 242.654,333.299 240.988,328.632 240.5,323.5C 247.122,323.875 253.456,322.875 259.5,320.5C 260.416,320.543 261.083,320.876 261.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48332a",
    d: "M 252.5,330.5 C 251.581,333.089 249.914,335.089 247.5,336.5C 248.419,333.911 250.086,331.911 252.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878787",
    d: "M 443.5,335.5 C 440.026,336.525 436.36,337.192 432.5,337.5C 435.845,335.783 439.511,335.116 443.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#362541",
    d: "M 482.5,335.5 C 485.187,335.336 487.854,335.503 490.5,336C 491.416,336.278 492.082,336.778 492.5,337.5C 488.96,337.247 485.627,336.581 482.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f9",
    d: "M 470.5,334.5 C 468.952,338.598 467.119,342.598 465,346.5C 462.021,348.067 459.188,349.734 456.5,351.5C 452.764,351.541 449.764,352.874 447.5,355.5C 443.505,356.001 439.838,357.334 436.5,359.5C 435.5,359.5 434.5,359.5 433.5,359.5C 432.454,353.681 430.454,348.348 427.5,343.5C 426.833,341.833 426.167,340.167 425.5,338.5C 427.806,338.007 430.139,337.674 432.5,337.5C 436.36,337.192 440.026,336.525 443.5,335.5C 452.416,334.529 461.416,334.196 470.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b6cbc",
    d: "M 470.5,334.5 C 474.548,334.395 478.548,334.728 482.5,335.5C 485.627,336.581 488.96,337.247 492.5,337.5C 473.219,351.482 453.219,364.482 432.5,376.5C 430.869,372.768 429.869,368.768 429.5,364.5C 429.59,361.848 428.924,359.515 427.5,357.5C 426.89,356.609 426.557,355.609 426.5,354.5C 426.245,352.033 425.245,350.033 423.5,348.5C 422.408,345.898 421.075,343.398 419.5,341C 419.645,340.228 419.978,339.561 420.5,339C 422.134,338.506 423.801,338.34 425.5,338.5C 426.167,340.167 426.833,341.833 427.5,343.5C 429.369,349.108 431.036,354.775 432.5,360.5C 434.099,360.768 435.432,360.434 436.5,359.5C 439.838,357.334 443.505,356.001 447.5,355.5C 450.744,354.537 453.744,353.204 456.5,351.5C 459.188,349.734 462.021,348.067 465,346.5C 467.119,342.598 468.952,338.598 470.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b9b9b",
    d: "M 204.5,333.5 C 205.525,336.974 206.192,340.64 206.5,344.5C 204.783,341.155 204.116,337.489 204.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#539baa",
    d: "M 228.5,332.5 C 229.491,337.05 230.491,341.717 231.5,346.5C 229.044,342.262 228.044,337.596 228.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383660",
    d: "M 342.5,342.5 C 348.653,341.347 354.986,341.18 361.5,342C 363,343.167 364.5,344.333 366,345.5C 366.667,346.5 366.667,347.5 366,348.5C 363.281,349.444 360.448,349.777 357.5,349.5C 359.658,347.78 362.325,346.947 365.5,347C 364.672,346.085 363.672,345.419 362.5,345C 356.08,342.874 349.414,342.041 342.5,342.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfaba1",
    d: "M 663.5,347.5 C 669.442,351.773 674.776,356.773 679.5,362.5C 673.558,358.227 668.224,353.227 663.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1bae1",
    d: "M 427.5,343.5 C 430.454,348.348 432.454,353.681 433.5,359.5C 434.5,359.5 435.5,359.5 436.5,359.5C 435.432,360.434 434.099,360.768 432.5,360.5C 431.036,354.775 429.369,349.108 427.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 206.5,346.5 C 207.924,348.515 208.59,350.848 208.5,353.5C 207.076,351.485 206.41,349.152 206.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad9d7e",
    d: "M 505.5,346.5 C 504.404,349.773 502.071,351.439 498.5,351.5C 500.296,349.1 502.63,347.433 505.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15585a",
    d: "M 232.5,348.5 C 233.338,348.842 233.672,349.508 233.5,350.5C 233.727,352.933 232.727,354.599 230.5,355.5C 231.933,353.442 232.6,351.108 232.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d4071",
    d: "M 423.5,348.5 C 425.245,350.033 426.245,352.033 426.5,354.5C 424.755,352.967 423.755,350.967 423.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1a2d7",
    d: "M 456.5,351.5 C 453.744,353.204 450.744,354.537 447.5,355.5C 449.764,352.874 452.764,351.541 456.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 208.5,353.5 C 210.245,355.033 211.245,357.033 211.5,359.5C 209.755,357.967 208.755,355.967 208.5,353.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03d7d5",
    d: "M 234.5,358.5 C 236.796,359.733 238.13,361.733 238.5,364.5C 238.5,365.833 238.5,367.167 238.5,368.5C 236.901,368.232 235.568,368.566 234.5,369.5C 231.31,370.635 229.643,369.302 229.5,365.5C 230.769,362.895 232.436,360.562 234.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 211.5,359.5 C 212.674,360.514 213.34,361.847 213.5,363.5C 211.824,362.817 211.157,361.483 211.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c3f70",
    d: "M 427.5,357.5 C 428.924,359.515 429.59,361.848 429.5,364.5C 428.076,362.485 427.41,360.152 427.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#887b63",
    d: "M 481.5,362.5 C 481.027,363.906 480.027,364.573 478.5,364.5C 478.973,363.094 479.973,362.427 481.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8167",
    d: "M 478.5,364.5 C 478.027,365.906 477.027,366.573 475.5,366.5C 475.973,365.094 476.973,364.427 478.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b4b4",
    d: "M 213.5,363.5 C 216.934,366.214 217.267,369.214 214.5,372.5C 214.296,369.482 213.963,366.482 213.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#09999d",
    d: "M 238.5,364.5 C 239.451,365.919 239.784,367.585 239.5,369.5C 237.833,369.5 236.167,369.5 234.5,369.5C 235.568,368.566 236.901,368.232 238.5,368.5C 238.5,367.167 238.5,365.833 238.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f745c",
    d: "M 473.5,367.5 C 473.027,368.906 472.027,369.573 470.5,369.5C 470.973,368.094 471.973,367.427 473.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#908268",
    d: "M 470.5,369.5 C 470.027,370.906 469.027,371.573 467.5,371.5C 467.973,370.094 468.973,369.427 470.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#533965",
    d: "M 429.5,364.5 C 429.869,368.768 430.869,372.768 432.5,376.5C 431.791,377.404 430.791,377.737 429.5,377.5C 429.5,373.167 429.5,368.833 429.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e1838",
    d: "M 419.5,358.5 C 421.018,361.534 421.851,364.867 422,368.5C 422.815,373.352 422.648,378.019 421.5,382.5C 421.054,374.476 420.387,366.476 419.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 238.5,379.5 C 234.485,380.512 230.485,381.512 226.5,382.5C 230.228,379.801 234.228,378.801 238.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#908268",
    d: "M 455.5,378.5 C 455.027,379.906 454.027,380.573 452.5,380.5C 452.973,379.094 453.973,378.427 455.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a4a",
    d: "M 197.5,379.5 C 195.316,381.585 192.649,382.585 189.5,382.5C 191.684,380.415 194.351,379.415 197.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafb",
    d: "M 238.5,379.5 C 239.425,383.79 240.091,388.124 240.5,392.5C 240.259,394.898 240.926,396.898 242.5,398.5C 243.373,402.198 244.373,405.865 245.5,409.5C 245.345,412.716 246.345,415.383 248.5,417.5C 251.72,425.608 255.72,433.274 260.5,440.5C 261.5,442.5 262.5,444.5 263.5,446.5C 260.692,447.929 257.692,448.595 254.5,448.5C 250.818,448.665 247.152,448.499 243.5,448C 241.091,446.293 238.425,445.46 235.5,445.5C 226.068,441.334 221.068,434.001 220.5,423.5C 218.897,414.582 218.23,405.582 218.5,396.5C 218.878,392.322 219.878,388.322 221.5,384.5C 223.403,384.204 225.07,383.537 226.5,382.5C 230.485,381.512 234.485,380.512 238.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a2f27",
    d: "M 616.5,390.5 C 613.594,391.787 610.594,392.787 607.5,393.5C 609.829,404.486 613.162,415.153 617.5,425.5C 617.427,427.027 618.094,428.027 619.5,428.5C 621.85,439.76 628.016,442.76 638,437.5C 641.146,439.297 641.313,441.464 638.5,444C 629.47,450.892 621.637,449.725 615,440.5C 612.895,431.013 609.729,422.013 605.5,413.5C 605.065,410.843 604.065,408.509 602.5,406.5C 601.088,404.02 599.422,401.687 597.5,399.5C 592.14,401.461 586.973,403.794 582,406.5C 578.568,405.107 577.734,402.774 579.5,399.5C 584.929,398.253 589.929,396.253 594.5,393.5C 600.748,391.043 606.748,388.043 612.5,384.5C 616.411,382.857 620.411,381.523 624.5,380.5C 624.382,385.945 621.715,389.278 616.5,390.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 189.5,382.5 C 189.027,383.906 188.027,384.573 186.5,384.5C 186.973,383.094 187.973,382.427 189.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8993",
    d: "M 226.5,382.5 C 225.07,383.537 223.403,384.204 221.5,384.5C 222.635,382.787 224.302,382.12 226.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c6ebf",
    d: "M 221.5,384.5 C 219.878,388.322 218.878,392.322 218.5,396.5C 217.345,403.321 217.179,410.321 218,417.5C 218.24,419.852 219.073,421.852 220.5,423.5C 221.068,434.001 226.068,441.334 235.5,445.5C 241.403,449.407 247.736,450.407 254.5,448.5C 257.692,448.595 260.692,447.929 263.5,446.5C 264.338,446.158 264.672,445.492 264.5,444.5C 267.371,448.28 271.038,451.113 275.5,453C 271.735,454.417 268.069,455.917 264.5,457.5C 258.724,459.082 253.39,461.415 248.5,464.5C 244.958,465.675 241.291,466.341 237.5,466.5C 237.5,465.833 237.167,465.5 236.5,465.5C 222.324,452.809 211.324,437.809 203.5,420.5C 202.204,415.607 200.538,410.94 198.5,406.5C 198.5,405.833 198.5,405.167 198.5,404.5C 198.448,402.097 198.781,399.764 199.5,397.5C 200.5,396.167 201.5,394.833 202.5,393.5C 204.909,392.299 206.909,390.633 208.5,388.5C 212.667,386.707 217,385.374 221.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 182.5,387.5 C 181.167,389.5 179.5,391.167 177.5,392.5C 178.167,389.833 179.833,388.167 182.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#13acae",
    d: "M 208.5,388.5 C 206.909,390.633 204.909,392.299 202.5,393.5C 201.749,392.427 200.749,392.26 199.5,393C 197.63,395.04 195.63,396.873 193.5,398.5C 194.543,395.944 196.21,393.777 198.5,392C 201.748,390.54 205.081,389.374 208.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c3a53",
    d: "M 668.5,391.5 C 671.903,393.9 674.57,396.9 676.5,400.5C 673.097,398.1 670.43,395.1 668.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#17dada",
    d: "M 202.5,393.5 C 201.5,394.833 200.5,396.167 199.5,397.5C 198.007,398.312 197.34,399.645 197.5,401.5C 197.52,402.726 197.853,403.726 198.5,404.5C 198.5,405.167 198.5,405.833 198.5,406.5C 199.009,411.703 200.676,416.37 203.5,420.5C 211.324,437.809 222.324,452.809 236.5,465.5C 233.574,464.539 230.574,463.873 227.5,463.5C 225.246,462.876 223.579,461.543 222.5,459.5C 220.5,456.833 218.167,454.5 215.5,452.5C 215.262,450.596 214.262,449.262 212.5,448.5C 211.92,446.251 210.587,444.585 208.5,443.5C 205.5,438.167 202.5,432.833 199.5,427.5C 199.573,425.973 198.906,424.973 197.5,424.5C 196.669,421.341 195.669,418.341 194.5,415.5C 193.708,409.87 193.375,404.203 193.5,398.5C 195.63,396.873 197.63,395.04 199.5,393C 200.749,392.26 201.749,392.427 202.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#776854",
    d: "M 594.5,393.5 C 589.929,396.253 584.929,398.253 579.5,399.5C 584.071,396.747 589.071,394.747 594.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7d",
    d: "M 240.5,392.5 C 242.074,394.102 242.741,396.102 242.5,398.5C 240.926,396.898 240.259,394.898 240.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4ab1d4",
    d: "M 199.5,397.5 C 198.781,399.764 198.448,402.097 198.5,404.5C 197.853,403.726 197.52,402.726 197.5,401.5C 197.34,399.645 198.007,398.312 199.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9869b9",
    d: "M 290.5,421.5 C 292.515,422.924 294.848,423.59 297.5,423.5C 299.042,424.301 300.708,424.634 302.5,424.5C 311.081,427.697 320.081,429.197 329.5,429C 328.944,429.383 328.611,429.883 328.5,430.5C 318.368,435.119 308.034,439.286 297.5,443C 295.654,444.03 293.987,445.196 292.5,446.5C 289.278,446.85 286.112,447.517 283,448.5C 280.863,447.923 278.696,447.59 276.5,447.5C 274.973,447.573 273.973,446.906 273.5,445.5C 272.167,443.5 270.5,441.833 268.5,440.5C 260.74,430.829 255.24,419.829 252,407.5C 251.219,406.056 251.386,404.723 252.5,403.5C 263.792,412.144 276.459,418.144 290.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a2f27",
    d: "M 568.5,409.5 C 567.911,412.734 565.911,414.067 562.5,413.5C 554.675,411.997 548.842,414.997 545,422.5C 544.621,425.03 543.787,427.363 542.5,429.5C 541.35,434.316 541.184,439.316 542,444.5C 542.278,445.416 542.778,446.082 543.5,446.5C 547.038,458.039 554.705,465.039 566.5,467.5C 570.144,467.176 573.478,466.009 576.5,464C 580.409,459.601 584.076,455.101 587.5,450.5C 588.649,450.791 589.316,451.624 589.5,453C 589.057,454.825 588.723,456.658 588.5,458.5C 577.818,474.01 564.151,477.51 547.5,469C 544.917,465.932 542.584,462.765 540.5,459.5C 540.065,456.843 539.065,454.509 537.5,452.5C 530.508,430.305 537.841,414.472 559.5,405C 561.833,404.333 564.167,404.333 566.5,405C 568.037,406.11 568.703,407.61 568.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52add3",
    d: "M 198.5,406.5 C 200.538,410.94 202.204,415.607 203.5,420.5C 200.676,416.37 199.009,411.703 198.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac9a7c",
    d: "M 602.5,406.5 C 604.065,408.509 605.065,410.843 605.5,413.5C 603.166,411.824 602.166,409.491 602.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a7a7",
    d: "M 177.5,408.5 C 179.204,411.939 180.538,415.605 181.5,419.5C 179.01,416.374 177.677,412.708 177.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c3a53",
    d: "M 686.5,410.5 C 689.903,412.9 692.57,415.9 694.5,419.5C 691.097,417.1 688.43,414.1 686.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808080",
    d: "M 245.5,409.5 C 246.871,411.936 247.871,414.603 248.5,417.5C 246.345,415.383 245.345,412.716 245.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09174",
    d: "M 403.5,407.5 C 398.511,411.493 392.844,414.16 386.5,415.5C 391.735,412.051 397.402,409.384 403.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94836a",
    d: "M 568.5,409.5 C 568.659,414.252 566.659,415.586 562.5,413.5C 565.911,414.067 567.911,412.734 568.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#005d5b",
    d: "M 193.5,398.5 C 193.375,404.203 193.708,409.87 194.5,415.5C 192.981,412.474 192.315,409.141 192.5,405.5C 192.503,402.975 192.837,400.641 193.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af87cb",
    d: "M 218.5,396.5 C 218.23,405.582 218.897,414.582 220.5,423.5C 219.073,421.852 218.24,419.852 218,417.5C 217.179,410.321 217.345,403.321 218.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9997a",
    d: "M 386.5,415.5 C 382.016,419.742 376.682,422.409 370.5,423.5C 375.547,420.31 380.88,417.643 386.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d2a4a",
    d: "M 290.5,421.5 C 293.152,421.41 295.485,422.076 297.5,423.5C 294.848,423.59 292.515,422.924 290.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 181.5,419.5 C 183.245,421.033 184.245,423.033 184.5,425.5C 184.167,425.5 183.833,425.5 183.5,425.5C 182.637,423.579 181.971,421.579 181.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d355e",
    d: "M 302.5,424.5 C 311.777,425.993 321.111,426.993 330.5,427.5C 330.715,429.179 330.048,430.179 328.5,430.5C 328.611,429.883 328.944,429.383 329.5,429C 320.081,429.197 311.081,427.697 302.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#007371",
    d: "M 197.5,424.5 C 198.906,424.973 199.573,425.973 199.5,427.5C 198.094,427.027 197.427,426.027 197.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#918067",
    d: "M 617.5,425.5 C 618.906,425.973 619.573,426.973 619.5,428.5C 618.094,428.027 617.427,427.027 617.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0b0b0",
    d: "M 183.5,425.5 C 183.833,425.5 184.167,425.5 184.5,425.5C 186.091,428.352 187.424,431.352 188.5,434.5C 187.624,434.631 186.957,434.298 186.5,433.5C 184.942,431.009 183.942,428.343 183.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3a382",
    d: "M 370.5,423.5 C 365.85,427.471 360.517,430.137 354.5,431.5C 359.236,427.798 364.57,425.132 370.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3a282",
    d: "M 354.5,431.5 C 351.918,433.742 348.918,435.076 345.5,435.5C 347.835,432.835 350.835,431.502 354.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#685a49",
    d: "M 542.5,429.5 C 542.375,435.203 542.708,440.87 543.5,446.5C 542.778,446.082 542.278,445.416 542,444.5C 541.184,439.316 541.35,434.316 542.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adabae",
    d: "M 260.5,440.5 C 262.167,441.5 263.5,442.833 264.5,444.5C 264.672,445.492 264.338,446.158 263.5,446.5C 262.5,444.5 261.5,442.5 260.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32223d",
    d: "M 268.5,440.5 C 270.5,441.833 272.167,443.5 273.5,445.5C 270.833,444.833 269.167,443.167 268.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#867a62",
    d: "M 330.5,441.5 C 329.341,443.25 327.674,444.25 325.5,444.5C 326.486,442.592 328.152,441.592 330.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 192.5,442.5 C 193.906,442.973 194.573,443.973 194.5,445.5C 193.094,445.027 192.427,444.027 192.5,442.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#033c3a",
    d: "M 208.5,443.5 C 210.587,444.585 211.92,446.251 212.5,448.5C 210.413,447.415 209.08,445.749 208.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfb7df",
    d: "M 235.5,445.5 C 238.425,445.46 241.091,446.293 243.5,448C 247.152,448.499 250.818,448.665 254.5,448.5C 247.736,450.407 241.403,449.407 235.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#694880",
    d: "M 292.5,446.5 C 289.08,448.199 285.413,449.532 281.5,450.5C 279.308,450.243 277.641,449.243 276.5,447.5C 278.696,447.59 280.863,447.923 283,448.5C 286.112,447.517 289.278,446.85 292.5,446.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f735c",
    d: "M 316.5,447.5 C 315.341,449.25 313.674,450.25 311.5,450.5C 312.486,448.592 314.152,447.592 316.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a2f26",
    d: "M 514.5,476.5 C 516.617,478.655 519.284,479.655 522.5,479.5C 526.738,481.956 531.404,482.956 536.5,482.5C 536.778,487.279 534.612,490.279 530,491.5C 522.481,487.492 514.648,484.159 506.5,481.5C 496.838,485.664 487.172,489.83 477.5,494C 475.43,494.948 473.93,496.448 473,498.5C 472.465,504.515 471.799,510.515 471,516.5C 469.293,517.459 467.459,518.125 465.5,518.5C 463.734,518.566 462.734,517.732 462.5,516C 464.869,506.797 466.869,497.63 468.5,488.5C 469.968,484.258 470.634,479.758 470.5,475C 470.498,471.979 470.164,469.146 469.5,466.5C 467.33,464.914 464.996,463.58 462.5,462.5C 462.027,461.094 461.027,460.427 459.5,460.5C 455.257,458.879 450.924,457.546 446.5,456.5C 449.711,447.614 454.711,446.447 461.5,453C 478.38,462.436 496.047,470.27 514.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b7e65",
    d: "M 309.5,450.5 C 309.027,451.906 308.027,452.573 306.5,452.5C 306.973,451.094 307.973,450.427 309.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#615343",
    d: "M 587.5,450.5 C 589.377,449.072 590.711,449.572 591.5,452C 590.961,454.482 589.961,456.648 588.5,458.5C 588.723,456.658 589.057,454.825 589.5,453C 589.316,451.624 588.649,450.791 587.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#034140",
    d: "M 215.5,452.5 C 218.167,454.5 220.5,456.833 222.5,459.5C 219.167,458.167 216.833,455.833 215.5,452.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a69477",
    d: "M 537.5,452.5 C 539.065,454.509 540.065,456.843 540.5,459.5C 538.166,457.824 537.166,455.491 537.5,452.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdab8a",
    d: "M 300.5,454.5 C 298.153,457.337 295.153,459.17 291.5,460C 289.527,460.495 287.527,460.662 285.5,460.5C 290.265,458.129 295.265,456.129 300.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a2",
    d: "M 203.5,458.5 C 207.167,461.5 210.5,464.833 213.5,468.5C 209.167,466.167 205.833,462.833 203.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d7d65",
    d: "M 459.5,460.5 C 461.027,460.427 462.027,461.094 462.5,462.5C 460.973,462.573 459.973,461.906 459.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#392745",
    d: "M 264.5,457.5 C 263.426,458.885 262.093,460.051 260.5,461C 256.453,462.072 252.453,463.239 248.5,464.5C 253.39,461.415 258.724,459.082 264.5,457.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#877b62",
    d: "M 285.5,460.5 C 282.291,462.934 278.624,464.601 274.5,465.5C 277.632,462.89 281.299,461.223 285.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#008b88",
    d: "M 227.5,463.5 C 230.574,463.873 233.574,464.539 236.5,465.5C 237.167,465.5 237.5,465.833 237.5,466.5C 233.714,466.68 230.381,465.68 227.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#392f26",
    d: "M 428.5,528.5 C 426.71,526.728 425.377,524.728 424.5,522.5C 424.655,519.284 423.655,516.617 421.5,514.5C 418.175,503.172 413.508,492.505 407.5,482.5C 401.837,484.414 396.337,486.747 391,489.5C 387.928,488.553 386.928,486.553 388,483.5C 388.816,482.177 389.983,481.511 391.5,481.5C 396.929,480.253 401.929,478.253 406.5,475.5C 415.371,471.232 424.371,467.232 433.5,463.5C 433.747,466.505 432.747,469.005 430.5,471C 425.81,472.785 421.31,474.951 417,477.5C 416.927,480.158 417.26,482.824 418,485.5C 422.364,496.952 427.03,508.285 432,519.5C 436.518,524.388 441.518,524.721 447,520.5C 450.292,522.95 450.125,525.45 446.5,528C 440.536,532.335 434.536,532.502 428.5,528.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebd5aa",
    d: "M 476.5,468.5 C 483.962,471.376 491.295,474.543 498.5,478C 497.421,480.043 495.754,481.376 493.5,482C 487.341,484.75 481.007,486.917 474.5,488.5C 474.698,481.782 475.365,475.115 476.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a79779",
    d: "M 260.5,470.5 C 256.936,472.919 252.936,474.586 248.5,475.5C 252.064,473.081 256.064,471.414 260.5,470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#877760",
    d: "M 514.5,476.5 C 517.397,477.129 520.064,478.129 522.5,479.5C 519.284,479.655 516.617,478.655 514.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a7d64",
    d: "M 248.5,475.5 C 244.06,477.538 239.393,479.204 234.5,480.5C 238.63,477.676 243.297,476.009 248.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696969",
    d: "M 213.5,474.5 C 208.274,477.604 202.607,479.937 196.5,481.5C 201.652,478.219 207.319,475.885 213.5,474.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87775f",
    d: "M 406.5,475.5 C 401.929,478.253 396.929,480.253 391.5,481.5C 396.071,478.747 401.071,476.747 406.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6a383",
    d: "M 522.5,479.5 C 527.283,480.509 531.95,481.509 536.5,482.5C 531.404,482.956 526.738,481.956 522.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#655746",
    d: "M 469.5,466.5 C 470.164,469.146 470.498,471.979 470.5,475C 470.634,479.758 469.968,484.258 468.5,488.5C 469.118,481.183 469.451,473.849 469.5,466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676767",
    d: "M 192.5,482.5 C 191.365,484.213 189.698,484.88 187.5,484.5C 188.93,483.463 190.597,482.796 192.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09174",
    d: "M 227.5,482.5 C 225.967,484.245 223.967,485.245 221.5,485.5C 223.033,483.755 225.033,482.755 227.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585858",
    d: "M 187.5,484.5 C 186.365,486.213 184.698,486.88 182.5,486.5C 183.93,485.463 185.597,484.796 187.5,484.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0b0a09",
    d: "M 711.5,488.5 C 711.5,493.5 711.5,498.5 711.5,503.5C 708.386,503.555 706.052,504.888 704.5,507.5C 702.973,507.427 701.973,508.094 701.5,509.5C 699.973,509.427 698.973,510.094 698.5,511.5C 696.596,511.738 695.262,512.738 694.5,514.5C 692.973,514.427 691.973,515.094 691.5,516.5C 689.596,516.738 688.262,517.738 687.5,519.5C 686.508,519.328 685.842,519.662 685.5,520.5C 683.973,520.427 682.973,521.094 682.5,522.5C 680.973,522.427 679.973,523.094 679.5,524.5C 677.973,524.427 676.973,525.094 676.5,526.5C 674.973,526.427 673.973,527.094 673.5,528.5C 672.508,528.328 671.842,528.662 671.5,529.5C 669.973,529.427 668.973,530.094 668.5,531.5C 666.596,531.738 665.262,532.738 664.5,534.5C 659.5,536.664 654.833,539.331 650.5,542.5C 648.973,542.427 647.973,543.094 647.5,544.5C 637.492,550.17 627.492,555.837 617.5,561.5C 615.326,561.75 613.659,562.75 612.5,564.5C 609.515,565.326 606.849,566.659 604.5,568.5C 599.771,569.855 595.771,572.188 592.5,575.5C 591.167,575.833 589.833,576.167 588.5,576.5C 584,578.583 579.666,580.916 575.5,583.5C 571.849,584.659 568.515,586.326 565.5,588.5C 556.833,588.5 548.167,588.5 539.5,588.5C 554.753,580.873 570.086,573.207 585.5,565.5C 587.848,565.408 589.514,564.408 590.5,562.5C 608.73,552.942 626.73,542.942 644.5,532.5C 646.027,532.573 647.027,531.906 647.5,530.5C 649.848,530.408 651.514,529.408 652.5,527.5C 654.027,527.573 655.027,526.906 655.5,525.5C 655.842,524.662 656.508,524.328 657.5,524.5C 659.027,524.573 660.027,523.906 660.5,522.5C 662.822,520.336 665.489,518.669 668.5,517.5C 670.027,517.573 671.027,516.906 671.5,515.5C 673.027,515.573 674.027,514.906 674.5,513.5C 676.027,513.573 677.027,512.906 677.5,511.5C 679.027,511.573 680.027,510.906 680.5,509.5C 682.027,509.573 683.027,508.906 683.5,507.5C 690.167,502.5 696.833,497.5 703.5,492.5C 705.615,490.109 708.281,488.776 711.5,488.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#392f26",
    d: "M 341.5,538.5 C 341.427,540.027 342.094,541.027 343.5,541.5C 346.774,549.05 349.774,556.716 352.5,564.5C 352.43,565.772 352.097,566.938 351.5,568C 349.473,569.879 347.14,571.046 344.5,571.5C 344.769,567.069 344.436,562.735 343.5,558.5C 343.245,556.033 342.245,554.033 340.5,552.5C 337.106,542.486 333.606,532.486 330,522.5C 326.614,518.08 322.114,516.414 316.5,517.5C 316.547,513.063 318.381,509.73 322,507.5C 337.229,514.531 352.396,521.698 367.5,529C 372.037,531.013 376.704,532.513 381.5,533.5C 380.784,528.633 379.451,523.967 377.5,519.5C 377.065,516.843 376.065,514.509 374.5,512.5C 371.39,507.118 368.39,501.618 365.5,496C 367.889,490.868 371.389,489.702 376,492.5C 379.523,509.736 385.023,526.236 392.5,542C 392.168,544.492 391.168,546.658 389.5,548.5C 388.635,549.583 387.635,549.749 386.5,549C 384.833,546 382.5,543.667 379.5,542C 365.799,535.437 351.966,529.271 338,523.5C 337.5,523.833 337,524.167 336.5,524.5C 338.174,529.19 339.841,533.857 341.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#434343",
    d: "M 78.5,491.5 C 80.5869,492.585 81.9202,494.251 82.5,496.5C 80.4131,495.415 79.0798,493.749 78.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#847760",
    d: "M 219.5,485.5 C 209.916,489.921 199.916,493.588 189.5,496.5C 199.084,492.079 209.084,488.412 219.5,485.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 182.5,486.5 C 182.389,487.117 182.056,487.617 181.5,488C 173.146,490.847 164.812,493.681 156.5,496.5C 164.665,492.217 173.332,488.883 182.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#eed8ad",
    d: "M 72.5,498.5 C 74.0174,498.511 75.1841,499.177 76,500.5C 97.0885,529.687 117.922,559.02 138.5,588.5C 129.167,588.5 119.833,588.5 110.5,588.5C 100.927,573.025 91.0934,557.692 81,542.5C 78.3677,538.838 75.5344,535.505 72.5,532.5C 72.5,521.167 72.5,509.833 72.5,498.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 149.5,499.5 C 147.064,500.871 144.397,501.871 141.5,502.5C 143.617,500.345 146.284,499.345 149.5,499.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.727
    },
    fill: "#f8f8f8",
    d: "M 711.5,504.5 C 711.817,507.572 711.484,510.572 710.5,513.5C 672.987,539.768 633.654,563.268 592.5,584C 590.316,585.363 588.316,586.863 586.5,588.5C 580.833,588.5 575.167,588.5 569.5,588.5C 571.941,587.291 573.941,585.624 575.5,583.5C 580.903,582.968 585.237,580.635 588.5,576.5C 589.833,576.167 591.167,575.833 592.5,575.5C 597.229,574.145 601.229,571.812 604.5,568.5C 606.849,566.659 609.515,565.326 612.5,564.5C 614.848,564.408 616.514,563.408 617.5,561.5C 627.492,555.837 637.492,550.17 647.5,544.5C 649.027,544.573 650.027,543.906 650.5,542.5C 654.833,539.331 659.5,536.664 664.5,534.5C 666.404,534.262 667.738,533.262 668.5,531.5C 670.027,531.573 671.027,530.906 671.5,529.5C 671.842,528.662 672.508,528.328 673.5,528.5C 675.027,528.573 676.027,527.906 676.5,526.5C 678.027,526.573 679.027,525.906 679.5,524.5C 681.027,524.573 682.027,523.906 682.5,522.5C 684.027,522.573 685.027,521.906 685.5,520.5C 685.842,519.662 686.508,519.328 687.5,519.5C 689.404,519.262 690.738,518.262 691.5,516.5C 693.027,516.573 694.027,515.906 694.5,514.5C 696.404,514.262 697.738,513.262 698.5,511.5C 700.027,511.573 701.027,510.906 701.5,509.5C 703.027,509.573 704.027,508.906 704.5,507.5C 706.722,506.312 709.055,505.312 711.5,504.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaaaaa",
    d: "M 711.5,503.5 C 711.5,503.833 711.5,504.167 711.5,504.5C 709.055,505.312 706.722,506.312 704.5,507.5C 706.052,504.888 708.386,503.555 711.5,503.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5443",
    d: "M 683.5,507.5 C 683.027,508.906 682.027,509.573 680.5,509.5C 680.973,508.094 681.973,507.427 683.5,507.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9a",
    d: "M 704.5,507.5 C 704.027,508.906 703.027,509.573 701.5,509.5C 701.973,508.094 702.973,507.427 704.5,507.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#605746",
    d: "M 680.5,509.5 C 680.027,510.906 679.027,511.573 677.5,511.5C 677.973,510.094 678.973,509.427 680.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8c8c",
    d: "M 701.5,509.5 C 701.027,510.906 700.027,511.573 698.5,511.5C 698.973,510.094 699.973,509.427 701.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95876c",
    d: "M 186.5,497.5 C 165.324,506.003 143.658,513.337 121.5,519.5C 142.824,511.392 164.491,504.058 186.5,497.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#625947",
    d: "M 677.5,511.5 C 677.027,512.906 676.027,513.573 674.5,513.5C 674.973,512.094 675.973,511.427 677.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888888",
    d: "M 698.5,511.5 C 697.738,513.262 696.404,514.262 694.5,514.5C 695.262,512.738 696.596,511.738 698.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6c6c",
    d: "M 141.5,502.5 C 129.314,507.13 116.981,511.63 104.5,516C 102.288,516.789 100.288,516.622 98.5,515.5C 113.059,511.757 127.393,507.423 141.5,502.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#615947",
    d: "M 674.5,513.5 C 674.027,514.906 673.027,515.573 671.5,515.5C 671.973,514.094 672.973,513.427 674.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a99779",
    d: "M 374.5,512.5 C 376.065,514.509 377.065,516.843 377.5,519.5C 375.166,517.824 374.166,515.491 374.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M 694.5,514.5 C 694.027,515.906 693.027,516.573 691.5,516.5C 691.973,515.094 692.973,514.427 694.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e6f59",
    d: "M 421.5,514.5 C 423.655,516.617 424.655,519.284 424.5,522.5C 423.129,520.064 422.129,517.397 421.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5544",
    d: "M 671.5,515.5 C 671.027,516.906 670.027,517.573 668.5,517.5C 668.973,516.094 669.973,515.427 671.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 691.5,516.5 C 690.738,518.262 689.404,519.262 687.5,519.5C 688.262,517.738 689.596,516.738 691.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888888",
    d: "M 685.5,520.5 C 685.027,521.906 684.027,522.573 682.5,522.5C 682.973,521.094 683.973,520.427 685.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#945f85",
    d: "M 120.5,519.5 C 120.389,520.117 120.056,520.617 119.5,521C 121.333,524.167 123.167,527.333 125,530.5C 138.434,549.718 151.601,569.051 164.5,588.5C 159.5,588.5 154.5,588.5 149.5,588.5C 133.45,566.796 117.45,545.129 101.5,523.5C 107.939,522.64 114.273,521.307 120.5,519.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5443",
    d: "M 660.5,522.5 C 660.027,523.906 659.027,524.573 657.5,524.5C 657.973,523.094 658.973,522.427 660.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 682.5,522.5 C 682.027,523.906 681.027,524.573 679.5,524.5C 679.973,523.094 680.973,522.427 682.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac9b7c",
    d: "M 424.5,522.5 C 425.377,524.728 426.71,526.728 428.5,528.5C 425.224,527.878 423.891,525.878 424.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8d8d",
    d: "M 679.5,524.5 C 679.027,525.906 678.027,526.573 676.5,526.5C 676.973,525.094 677.973,524.427 679.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b624e",
    d: "M 655.5,525.5 C 655.027,526.906 654.027,527.573 652.5,527.5C 652.973,526.094 653.973,525.427 655.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919191",
    d: "M 676.5,526.5 C 676.027,527.906 675.027,528.573 673.5,528.5C 673.973,527.094 674.973,526.427 676.5,526.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#615847",
    d: "M 652.5,527.5 C 651.514,529.408 649.848,530.408 647.5,530.5C 648.659,528.75 650.326,527.75 652.5,527.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#372c24",
    d: "M 310.5,549.5 C 312.637,557.418 312.97,565.418 311.5,573.5C 308.917,580.079 304.583,585.079 298.5,588.5C 291.5,588.5 284.5,588.5 277.5,588.5C 271.295,584.793 266.961,579.46 264.5,572.5C 261.607,564.01 260.94,555.343 262.5,546.5C 265.197,539.632 269.864,534.466 276.5,531C 293.144,527.487 304.477,533.654 310.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 671.5,529.5 C 671.027,530.906 670.027,531.573 668.5,531.5C 668.973,530.094 669.973,529.427 671.5,529.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#615846",
    d: "M 647.5,530.5 C 647.027,531.906 646.027,532.573 644.5,532.5C 644.973,531.094 645.973,530.427 647.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 668.5,531.5 C 667.738,533.262 666.404,534.262 664.5,534.5C 665.262,532.738 666.596,531.738 668.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#966087",
    d: "M 72.5,532.5 C 75.5344,535.505 78.3677,538.838 81,542.5C 91.0934,557.692 100.927,573.025 110.5,588.5C 97.8333,588.5 85.1667,588.5 72.5,588.5C 72.5,569.833 72.5,551.167 72.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1daaf",
    d: "M 305.5,558.5 C 306.344,562.099 306.677,565.766 306.5,569.5C 303.369,579.746 296.369,583.912 285.5,582C 270.226,573.187 265.393,560.353 271,543.5C 280.593,533.944 289.926,534.277 299,544.5C 301.982,548.798 304.149,553.464 305.5,558.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c7c64",
    d: "M 341.5,538.5 C 342.906,538.973 343.573,539.973 343.5,541.5C 342.094,541.027 341.427,540.027 341.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898989",
    d: "M 650.5,542.5 C 650.027,543.906 649.027,544.573 647.5,544.5C 647.973,543.094 648.973,542.427 650.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a2f26",
    d: "M 212.5,566.5 C 210.689,568.385 209.522,570.719 209,573.5C 208.501,578.489 208.334,583.489 208.5,588.5C 206.167,588.5 203.833,588.5 201.5,588.5C 200.491,570.013 208.491,557.179 225.5,550C 228.916,549.107 232.083,549.607 235,551.5C 235.64,555.44 234.14,558.106 230.5,559.5C 222.363,556.232 216.363,558.566 212.5,566.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#907f67",
    d: "M 340.5,552.5 C 342.245,554.033 343.245,556.033 343.5,558.5C 341.755,556.967 340.755,554.967 340.5,552.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c8b70",
    d: "M 262.5,546.5 C 260.94,555.343 261.607,564.01 264.5,572.5C 263.21,571.942 262.377,570.942 262,569.5C 260.695,562.874 260.362,556.208 261,549.5C 261.232,548.263 261.732,547.263 262.5,546.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9d9d",
    d: "M 617.5,561.5 C 616.514,563.408 614.848,564.408 612.5,564.5C 613.659,562.75 615.326,561.75 617.5,561.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f614e",
    d: "M 305.5,558.5 C 306.117,558.611 306.617,558.944 307,559.5C 307.808,563.027 307.641,566.36 306.5,569.5C 306.677,565.766 306.344,562.099 305.5,558.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#534b3c",
    d: "M 590.5,562.5 C 589.514,564.408 587.848,565.408 585.5,565.5C 586.659,563.75 588.326,562.75 590.5,562.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#726450",
    d: "M 310.5,549.5 C 311.6,551.277 312.434,553.277 313,555.5C 313.667,560.833 313.667,566.167 313,571.5C 312.722,572.416 312.222,573.082 311.5,573.5C 312.97,565.418 312.637,557.418 310.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a4a4",
    d: "M 604.5,568.5 C 601.229,571.812 597.229,574.145 592.5,575.5C 595.771,572.188 599.771,569.855 604.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7a483",
    d: "M 212.5,566.5 C 209.897,573.513 208.897,580.846 209.5,588.5C 209.167,588.5 208.833,588.5 208.5,588.5C 208.334,583.489 208.501,578.489 209,573.5C 209.522,570.719 210.689,568.385 212.5,566.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0b0b0",
    d: "M 588.5,576.5 C 585.237,580.635 580.903,582.968 575.5,583.5C 579.666,580.916 584,578.583 588.5,576.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afafaf",
    d: "M 575.5,583.5 C 573.941,585.624 571.941,587.291 569.5,588.5C 568.167,588.5 566.833,588.5 565.5,588.5C 568.515,586.326 571.849,584.659 575.5,583.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1b0283fa7c3a1d3eb0d320dbdbddcbc0.svg";
export { ForwardRef as ReactComponent };